/** biome-ignore-all lint/suspicious/noTemplateCurlyInString: expected */

import { getExecutingEnvironment } from "@app/resolveModule/env";
import type { DefaultLocale } from "@ext/localization/locale/translate";

const locale: DefaultLocale = {
	"date-placeholder": {
		day: "д",
		month: "м",
		year: "г",
	},
	"left-navigation": {
		expand: "Раскрыть боковую панель",
		collapse: "Свернуть панель",
	},
	"floating-panel": {
		actions: "Действия с панелью",
		"dock-left": "Поместить в панель слева",
		"dock-right": "Поместить в панель справа",
		maximize: "Развернуть на весь экран",
		"reset-size": "Сбросить размер",
		restore: "Свернуть",
		undock: "Открепить в окно",
	},
	"swagger-ui": {
		"api-definition-empty": "Описание API не предоставлено.",
		"api-definition-load-error": "Не удалось загрузить описание API.",
		"api-key": "API-ключ",
		application: "Приложение",
		"apply-credentials": "Применить учётные данные",
		"apply-oauth2-credentials": "Применить учётные данные OAuth2",
		"available-authorizations": "Доступные способы авторизации",
		"available-values": "Допустимые значения",
		authorize: "Авторизоваться",
		authorized: "Авторизовано",
		authorization: "Авторизация",
		"authorization-header": "Заголовок Authorization",
		"authorization-method": "Способ авторизации",
		"authorization-url": "URL авторизации",
		"basic-authorization": "Базовая аутентификация",
		callbacks: "Callback-запросы",
		cancel: "Отмена",
		clear: "Очистить",
		"collapse-all": "Свернуть всё",
		"client-credentials-location": "Где передавать учётные данные клиента",
		"client-id": "client_id",
		"client-secret": "client_secret",
		close: "Закрыть",
		code: "Код",
		"default-value": "Значение по умолчанию",
		description: "Описание",
		details: "Подробности",
		download: "Скачать",
		"download-file": "Скачать файл",
		edit: "Изменить",
		"edit-value": "Изменить значение",
		execute: "Выполнить",
		"expand-all": "Развернуть всё",
		example: "Пример",
		"example-description": "Описание примера",
		"example-value": "Пример значения",
		examples: "Примеры",
		"controls-accept-header": "Задаёт заголовок Accept.",
		deprecated: "Устарело",
		"deprecated-warning": "Внимание: операция устарела",
		"remote-config-load-error": "Не удалось загрузить удалённую конфигурацию.",
		"find-more-details": "Подробнее в документации",
		flow: "Сценарий OAuth2",
		headers: "Заголовки",
		hide: "Скрыть",
		"http-auth-unsupported-scheme": "использует неподдерживаемую схему HTTP-аутентификации:",
		in: "Расположение",
		"json-schema": {
			"additional-properties": "Дополнительные свойства",
			"all-of": "Все условия",
			"any-of": "Хотя бы одно условие",
			"content-schema": "Схема содержимого",
			contains: "Содержит",
			"dependent-schemas": "Зависимые схемы",
			else: "Иначе",
			if: "Если",
			items: "Элементы",
			not: "Не должно соответствовать",
			"one-of": "Ровно одно условие",
			"prefix-items": "Позиционные элементы",
			"property-names": "Имена свойств",
			"required-when-defined": "Обязательны при наличии",
			"then-keyword": "Тогда",
			"unevaluated-items": "Непроверенные элементы",
			"unevaluated-properties": "Непроверенные свойства",
		},
		links: "Ссылки",
		loading: "Загрузка",
		location: "Расположение",
		logout: "Выйти",
		"media-type": "Тип содержимого",
		model: "Модель",
		models: "Модели",
		"modified-value": "Изменённое значение",
		"mutual-tls-description":
			"Для этого API или операции требуется Mutual TLS. Сертификатами управляет операционная система или браузер.",
		name: "Имя",
		"no-example-available": "Пример недоступен",
		"no-links": "Ссылок нет",
		"no-parameters": "Параметров нет",
		"oauth-scopes-apply":
			"Для этого API нужны следующие области доступа. Выберите, какие области предоставить Swagger UI.",
		"oauth-scopes-description":
			"Области доступа определяют, какие разрешения получает приложение от имени пользователя. API может объявлять одну или несколько областей.",
		"oauth2-pkce-unavailable": "Авторизация с PKCE недоступна: в браузере недоступен Web Crypto API.",
		"oauth2-redirect-url-missing": "oauth2RedirectUrl не настроен. OAuth2-авторизацию продолжить нельзя.",
		"openid-connect-url": "URL OpenID Connect",
		"operation-server-override": "Эти настройки операции переопределяют глобальные настройки сервера.",
		"parameter-content-type": "Тип содержимого параметра",
		"parameter-include-empty": "Отправлять пустое значение",
		parameters: "Параметры",
		password: "Пароль",
		"path-server-override": "Эти настройки пути переопределяют глобальные настройки сервера.",
		"request-body": "Тело запроса",
		"request-content-type": "Тип содержимого запроса",
		"request-duration": "Время выполнения запроса",
		"request-url": "URL запроса",
		required: "обязательно",
		reset: "Сбросить",
		"response-body": "Тело ответа",
		"response-content-type": "Тип содержимого ответа",
		"response-headers": "Заголовки ответа",
		"remove-authorization": "Удалить авторизацию",
		responses: "Ответы сервера",
		schema: "Схема",
		schemas: "Схемы",
		schemes: "Протокол запроса",
		scopes: "Области доступа",
		"server-response": "Ответ сервера",
		servers: "Серверы",
		show: "Показать",
		"try-it-out": "Попробовать",
		token: "Токен",
		"token-url": "URL получения токена",
		type: "Тип",
		undocumented: "Не задокументировано",
		username: "Имя пользователя",
		validation: {
			"array-max-items": "Массив должен содержать не больше",
			"array-min-items": "Массив должен содержать не менее",
			"character-few": "символа",
			"character-many": "символов",
			"character-one": "символ",
			"item-few": "элемента",
			"item-many": "элементов",
			"item-one": "элемент",
			"no-duplicates": "Повторяющиеся значения недопустимы",
			parameter: "Параметр",
			path: "путь",
			"required-field": "Обязательное значение не указано",
			"required-property": "Обязательное свойство не указано",
			"valid-json": "Значение должно быть корректным JSON",
			"value-boolean": "Значение должно быть true или false",
			"value-date-time": "Значение должно быть корректной датой и временем",
			"value-file": "Значение должно быть файлом",
			"value-greater-or-equal": "Значение должно быть не меньше",
			"value-guid": "Значение должно быть корректным GUID/UUID",
			"value-integer": "Значение должно быть целым числом",
			"value-less-or-equal": "Значение должно быть не больше",
			"value-max-length": "Значение должно быть не длиннее",
			"value-min-length": "Значение должно быть не короче",
			"value-number": "Значение должно быть числом",
			"value-pattern": "Значение должно соответствовать шаблону",
			"value-string": "Значение должно быть строкой",
		},
		"validation-errors-retry": "Исправьте ошибки валидации и повторите запрос.",
		value: "Значение",
		webhooks: "Вебхуки",
		"with-pkce": "с PKCE",
	},
	forms: {
		"catalog-edit-props": {
			name: "Настройки каталога",
			description: "Задайте параметры каталога и его отображение",
			tabs: {
				title: "Разделы",
				general: "Основные",
				icons: "Библиотека иконок",
				storage: "Репозиторий",
				language: "Языки и версии",
				advanced: "Расширенные",
				extended: "Формат",
				lfs: "Git LFS",
				storageUsage: "Хранилище",
			},
			sidebar: {
				git: "Git",
			},
			props: {
				title: {
					name: "Название каталога",
					placeholder: "Введите название каталога",
					description: "Отображается в списке каталогов, на карточке и в интерфейсе редактора.",
				},
				url: {
					name: "Название",
					placeholder: "Введите название репозитория",
					description: "Системное имя Git-репозитория. Задаётся при создании каталога.",
				},
				docroot: {
					name: "Поддиректория",
					placeholder: "Укажите директорию",
					description:
						"Путь до директории, где будет храниться вся документация в репозитории. По умолчанию — корневая папка репозитория. При указании все статьи (со всеми ресурсами) будут перемещены в новую папку при сохранении.",
				},
				versions: {
					name: "Версии",
					placeholder: "Укажите версии",
					description:
						"Список версий (веток или тегов). Задаются в виде glob-паттернов, например v19.* или release-*",
				},
				lfs: {
					lazy: {
						name: "Автоматически загружать файлы LFS",
						description: "Загружать все файлы LFS при синхронизации каталога, а не при открытии статьи.",
					},
					patterns: {
						name: "Отслеживаемые файлы LFS",
						placeholder: "Укажите паттерны файлов",
						description: "Паттерны файлов для отслеживания через Git LFS (например, *.jpg, *.png, *.zip).",

						"default-tooltip": "Установить часто используемые паттерны файлов",
					},
					auto: {
						name: "Хранить новые вложения в LFS",
						description:
							"Изображения, видео и файлы, которые вы добавляете в статьи, будут сохраняться в Git LFS",
					},
					exclude: {
						name: "Исключения",
						placeholder: "Укажите паттерны файлов",
						description:
							"Файлы по этим маскам в LFS не попадают (например, *.psd, *.ai). Действует только на новые вложения.",
					},
				},
				filterProperty: {
					name: "Фильтрация",
					placeholder: "Выберите свойство",
					description: "Выберите флаг или перечисление для фильтрации каталога",
					none: "Без фильтра",
				},
				language: {
					name: "Основной язык",
					placeholder: "Русский",
					description: "Основной язык каталога. Нельзя изменить после выбора",
				},
				description: {
					name: "Описание",
					placeholder: "Введите описание",
					description:
						"Показывается в карточке каталога на главной и может использоваться в поиске по каталогам.",
				},
				style: {
					name: "Стиль",
					placeholder: "Синий",
					description: "Цветовой стиль карточки каталога.",
				},
				code: {
					name: "Краткое название",
					placeholder: "Введите краткое название",
				},
				properties: {
					name: "Свойства",
				},
				icons: {
					name: "Иконки",
					description: "Все загруженные иконки будут доступны для вставки в статью.",
					fileConditions: "SVG формат ∙ Не более 500KB",
				},
				preview: {
					name: "Предпросмотр карточки",
				},
			},
			section: {
				display: "Отображение на главной",
			},
			extended: {
				name: "Формат",
			},
		},
		"catalog-extended-edit-props": {
			name: "Формат хранения текста",
			props: {
				syntax: {
					name: "Язык разметки статей",
					description:
						"По умолчанию статьи сохраняются в расширенном синтаксисе Markdown. Вы можете выбрать другой формат: после сохранения настроек все статьи отформатируются. Вам останется только опубликовать изменения.",
					placeholder: "Legacy",
				},
				reformat: {
					name: "Переформатировать каталог…",
					description:
						"Gramax приведет файлы каталога к тому виду, в котором сохраняет статьи сам. Текст статей не изменится — поменяется только разметка. После этого правка статьи будет менять в файле только то, что вы исправили.",
					team: "Переформатируйте каталог отдельно от других правок, когда коллеги опубликуют свои, — иначе при синхронизации у них могут возникнуть конфликты.",
					publish: "Опубликовать…",
					confirm: {
						title: "Переформатировать каталог?",
						description: "Текст статей не изменится — Gramax поменяет только разметку в файлах.",
						unpublished:
							"Сначала опубликуйте свои правки — иначе они попадут в одну публикацию с переформатированием.",
						team: {
							conflicts:
								"Если коллеги правят те же статьи и еще не опубликовали правки, при синхронизации у них могут возникнуть конфликты. Чтобы их не было:",
							publish: "Попросите всех опубликовать свои правки.",
							reformat: "Синхронизируйте каталог и переформатируйте его.",
							sync: "Опубликуйте результат и попросите коллег синхронизироваться.",
						},
						action: "Переформатировать",
					},
					report: {
						title: "Каталог переформатирован",
						nothing: "Переформатировать нечего: все файлы уже в том виде, в котором их сохраняет Gramax.",
						written: "Измененные статьи ({{count}})",
						skipped: "Не удалось прочитать ({{count}})",
						"skipped-note": "Эти статьи остались как были — Gramax не смог разобрать их разметку.",
					},
					"commit-message": "Переформатирование каталога",
				},
			},
		},
		"catalog-create-props": {
			name: "Новое свойство",
			name2: "Редактирование свойства",
			description: "Задайте параметры свойства и его отображение",
			description2: "Измените параметры свойства и его отображение",
			props: {
				name: {
					name: "Название",
					placeholder: "Введите название",
				},
				type: {
					name: "Тип",
					placeholder: "Выберите тип",
				},
				icon: {
					name: "Иконка",
					placeholder: "Выберите иконку",
					description: "Иконка, которая будет отображаться в свойстве",
				},
				style: {
					name: "Стиль",
					placeholder: "Выберите стиль",
					description: "Стиль, в котором будет отображаться свойство",
				},
				values: {
					name: "Значения",
					placeholder: "Введите значения",
					description: "Значения, которые можно будет назначать статьям",
				},
			},
		},
		"article-edit-props": {
			name: "Свойства",
			props: {
				title: {
					name: "Заголовок",
					placeholder: "Введите заголовок",
					description: "Название статьи в редакторе, навигации и опубликованном портале",
				},
				description: {
					name: "Описание",
					placeholder: "Введите описание",
					description: "Используется SEO-метатеге `description` при публикации.",
				},
				url: {
					name: "URL",
					placeholder: "Введите URL",
					description: "Настраиваемая часть ссылки. Допустимы латинские буквы, цифры и символы -, _.",
				},
				searchPhrases: {
					name: "Поисковые фразы",
					placeholder: "Пример: оформление отпуска",
					description:
						"Список фраз, которые будут использоваться для поиска статьи. Используется в поиске и сниппете.",
				},
				expanded: {
					name: "Сворачивать раздел по умолчанию",
					description:
						"Раздел будет свёрнут при первом открытии каталога. Если читатель уже разворачивал или сворачивал его сам, сохранится выбранное им состояние.",
				},
				aliases: {
					name: "Дополнительные пути статьи",
					placeholder: "Например: guide/install",
					description:
						"Укажите пути от корня каталога, по которым статья также будет доступна. Перейдя по ним, читатели автоматически попадут на эту статью.",
					"clear-auto": "Очистить автоматически добавленные пути",
					"auto-tooltip": "Добавлен автоматически при переносе или переименовании статьи или раздела",
				},
			},
		},
		"git-source-data": {
			props: {
				sourceType: {
					name: "Тип",
				},
				url: {
					name: "URL сервера Git",
					placeholder: "https://git-server.com",
					description: "Скопируйте URL с главной страницы вашего хранилища",
				},
				token: {
					name: "Токен",
					placeholder: "glpat-***************-***",
					description: "Токен для авторизации на Git-сервере",
				},
				password: {
					name: "Пароль",
					placeholder: "password",
					description: "Пароль для авторизации на Git-сервере",
				},
				useToken: {
					name: "Использовать токен",
					description: "Использовать токен вместо пароля",
				},
				usePassword: {
					name: "Использовать пароль",
					description: "Использовать пароль вместо токена",
				},
				createDate: {
					name: "Время создания",
					placeholder: "1707213960",
					description: "Время получения токена",
				},
				refreshToken: {
					name: "Refresh-токен",
					placeholder: "4740fbc6db719d42c158b88580be7633c1e386827ebe9134e9a5198c52cb2e4c",
					description: "Токен для обновления основного токена",
				},
				userName: {
					name: "Имя автора",
					description: "Будет отображаться в истории изменений",
					placeholder: "Ivan Ivanov",
				},
				gitServerUsername: {
					name: "Имя пользователя",
					description: "Используется для авторизации на git-сервере",
					placeholder: "ivan.ivanov",
				},
				userEmail: {
					name: "Почта",
					description: "Будет отображаться в истории изменений",
					placeholder: "ivan.ivanov@mail.ru",
				},
			},
		},
		"gitlab-source-data": {
			props: {
				sourceType: {
					name: "Тип",
				},
				token: {
					name: "GitLab-токен",
					placeholder: "glpat-***************-***",
					description: "Токен для авторизации в GitLab",
				},
				url: {
					name: "URL сервера GitLab",
					placeholder: "https://gitlab.com",
					description: "Войдите в GitLab и скопируйте URL с главной страницы",
				},
				createDate: {
					name: "Время создания",
					placeholder: "1707213960",
					description: "Время получения токена",
				},
				refreshToken: {
					name: "Refresh-токен",
					placeholder: "4740fbc6db719d42c158b88580be7633c1e386827ebe9134e9a5198c52cb2e4c",
					description: "Токен для обновления основного токена",
				},
				userName: {
					name: "Имя пользователя",
					description: "Будет отображаться в истории изменений",
					placeholder: "Ivan Ivanov",
				},
				userEmail: {
					name: "Почта",
					description: "Будет отображаться в истории изменений",
					placeholder: "ivan.ivanov@mail.ru",
				},
			},
		},
		"gitverse-source-data": {
			props: {
				sourceType: {
					name: "Тип",
				},
				token: {
					name: "Токен",
					placeholder: "e5a43119d84f620fedfc0929e125ed4b10a6a5f4", // # gitleaks:allow
					description: "Токен для авторизации в GitVerse",
				},
				url: {
					name: "URL сервера",
					placeholder: "https://gitverse.ru",
					description: "Войдите в GitVerse и скопируйте URL с главной страницы",
				},
				createDate: {
					name: "Время создания",
					placeholder: "1707213960",
					description: "Время получения токена",
				},
				refreshToken: {
					name: "Refresh-токен",
					placeholder: "4740fbc6db719d42c158b88580be7633c1e386827ebe9134e9a5198c52cb2e4c",
					description: "Токен для обновления основного токена",
				},
				userName: {
					name: "Имя пользователя",
					description: "Будет отображаться в истории изменений",
					placeholder: "Ivan Ivanov",
				},
				userEmail: {
					name: "Почта",
					description: "Будет отображаться в истории изменений",
					placeholder: "ivan.ivanov@mail.ru",
				},
			},
		},
		"gitea-source-data": {
			props: {
				sourceType: {
					name: "Тип",
				},
				token: {
					name: "Gitea-токен",
					placeholder: "31fa8d7b332125ed2d89b9b3d735e1292b499d82", // # gitleaks:allow
					description: "Токен для авторизации в Gitea",
				},
				url: {
					name: "URL сервера Gitea",
					placeholder: "https://gitea.com",
					description: "Войдите в Gitea и скопируйте URL с главной страницы",
				},
				createDate: {
					name: "Время создания",
					placeholder: "1707213960",
					description: "Время получения токена",
				},
				refreshToken: {
					name: "Refresh-токен",
					placeholder: "4740fbc6db719d42c158b88580be7633c1e386827ebe9134e9a5198c52cb2e4c",
					description: "Токен для обновления основного токена",
				},
				userName: {
					name: "Имя пользователя",
					description: "Будет отображаться в истории изменений",
					placeholder: "Ivan Ivanov",
				},
				userEmail: {
					name: "Почта",
					description: "Будет отображаться в истории изменений",
					placeholder: "ivan.ivanov@mail.ru",
				},
			},
		},
		"confluence-server-source-data": {
			props: {
				sourceType: {
					name: "Тип",
				},
				domain: {
					name: "URL сервера Confluence",
					placeholder: "https://confluence.domain.com",
					description: "Скопируйте URL вашего Confluence сервера",
				},
				password: {
					name: "Пароль",
					placeholder: "opxsdk_tvdg",
					description: "Введите пароль аккаунта Confluence",
				},
				userName: {
					name: "Имя пользователя",
					placeholder: "Ivanov",
					description: "Введите имя пользователя аккаунта Confluence",
				},
				token: {
					name: "Токен",
					placeholder: "NzIzNTYyNTQ3NjQxOva29fNcHrLYMGH77/YuEAKpqy+Q",
					description: "Введите токен аккаунта Confluence",
				},
			},
		},
		"admin-login-props": {
			name: "Вход в аккаунт",
			props: {
				login: {
					name: "Логин",
					placeholder: "Введите логин",
				},
				password: {
					name: "Пароль",
					placeholder: "Введите пароль",
				},
			},
			validationErrors: {
				wrongLoginOrPassword: "Неверный логин или пароль",
			},
		},
		"fragment-editor": {
			name: "Редактирование фрагмента",
			props: {
				title: {
					name: "Название",
					placeholder: "Мой фрагмент",
				},
				id: {
					name: "Id",
					placeholder: "my_id",
				},
				content: {
					name: "Содержимое",
				},
			},
		},
		"sign-in-enterprise": {
			name: "Вход в бизнес-аккаунт",
			props: {
				email: {
					name: "Войдите в ваш корпоративный аккаунт Gramax Enterprise Server",
					description:
						"Используйте корпоративный email, чтобы подключиться к пространству вашей организации.",
					placeholder: "Введите свою почту",
				},
			},
		},
		"clone-repo": {
			name: "Загрузка Git-репозитория",
			description: "Выберите хранилище или добавьте новое",
			"enterprise-description": "Выберите репозиторий",
			props: {
				storage: {
					name: "Хранилище",
					placeholder: "Выберите хранилище",
				},
				repository: {
					name: "Репозиторий",
				},
				lfs: {
					lazy: {
						name: "Автоматическая загрузка файлов LFS",
						description:
							"Загружать все файлы LFS при синхронизации каталога вместо загрузки при открытии статьи",
					},
				},
			},
			errors: {
				sourceKey: "Хранилище не выбрано",
				repository: "Репозиторий не выбран",
				user: "Пользователь не выбран",
				connect: "Не удалось подключиться к хранилищу. Пожалуйста, обратитесь к администратору",
			},
		},
		"add-storage": {
			name: "Добавить новое хранилище",
			name2: "Подключить хранилище",
			name3: "Редактировать хранилище",
			description: "Укажите тип хранилища и введите необходимые данные",
			props: {
				storage: {
					name: "Хранилище",
					placeholder: "Выберите хранилище",
				},
			},
		},
		"create-source": {
			name: "Добавить новый источник",
			description: "Укажите тип источника и введите необходимые данные",
			props: {
				source: {
					name: "Тип источника",
					placeholder: "Выберите тип источника",
					description: "Некоторые опции доступны только в десктопной версии приложения",
				},
			},
		},
		"sign-in-ges-tauri": {
			props: {
				gesUrl: {
					name: "URL сервера Gramax Enterprise",
					placeholder: "https://enterprise.gram.ax",
					description: "Укажите адрес вашего сервера Gramax Enterprise",
				},
			},
			errors: {
				urlIsNotValid: "URL не является валидным",
				enterpriseServerIsNotAvailable: "По этому URL недоступен Gramax Enterprise Server",
			},
		},
	},
	app: {
		update: {
			error: "Ошибка обновления приложения",
			retry: "Повторить",
			available: "Доступна новая версия",
			updating: "Обновление...",
			installed: "Обновление установлено",
			more: "Подробная ошибка",
			dmg: {
				title: "Приложение не установлено",
				desc: `Установите приложение для его корректной работы`,
			},
			code: {
				install: "Не удалось установить обновление",
				check: "Не удалось проверить наличие обновлений",
				"not-found": "Сервер не вернул информацию об обновлениях",
				"download-failed": "Не удалось загрузить обновление",
				signature: "Не удалось проверить подлинность обновления",
				"check-enterprise-version": "Не удалось проверить версию энтерпрайз-сервера",
				reqwest: "Не удалось получить обновление от сервера",
				"run-from-dmg": "Приложение запущено из .dmg",
			},
		},
		loading: "загружаем",
		error: {
			offline: {
				"no-internet": "Нет подключения к интернету",
				mode: "Оффлайн режим",
			},
			"browser-not-supported": {
				title: "Этот браузер не поддерживается",
				desc: "<span>Откройте Gramax в <a href='https://gram.ax/resources/docs/app/web-editor'>другом браузере</a> или <a href='https://gram.ax'>скачайте приложение</a> на компьютер</span>",
			},
			"wasm-init-timeout": {
				title: "Не удалось инициализировать Gramax",
				desc: "Превышено время ожидания инициализации wasm-модуля. Пожалуйста, попробуйте еще раз",
			},
			"unknown-error": "Неизвестная ошибка",
			"cannot-load": "Не удалось загрузить приложение",
			"not-https":
				"Для работы приложения необходимо HTTPS-подключение и <a href='https://developer.mozilla.org/en-US/docs/Web/API/Window/crossOriginIsolated'>cross-origin isolation</a>",
			"command-failed": {
				title: "Что-то пошло не так",
				body: `<p>Перезагрузите страницу и попробуйте еще раз.</p><p>Мы получим сообщение о проблеме и постараемся ее быстро исправить. Если ошибка блокирует работу — cоздайте нам заявку в <a style="color: hsl(201 96% 32%)" href="https://github.com/Gram-ax/gramax/issues" target="${getExecutingEnvironment() === "tauri" ? "" : "target='_blank'"}">GitHub</a>.</p>`,
			},
			"something-went-wrong": "Что-то пошло не так",
			"no-permission": "Недостаточно прав для этого действия",
			"sign-in-required": "Войдите, чтобы выполнить это действие",
			"not-on-portal": "Это действие недоступно на портале документации",
			"busy-cloud-upload": "Это действие недоступно, пока каталог загружается в облако",
		},
		"continue-in-browser": {
			title: "Открыто в приложении Gramax",
			description: "Каталог уже открыт в десктопном приложении Gramax. Хотите продолжить в браузере?",
			action: "Продолжить в браузере",
		},
	},
	language: {
		name: "Язык",
		ru: "Русский",
		en: "English",
		zh: "中文",
		hi: "हिन्दी",
		es: "Español",
		fr: "Français",
		ar: "العربية",
		pt: "Português",
		de: "Deutsch",
		ja: "日本語",
		ko: "한국어",
		it: "Italiano",
		tr: "Türkçe",
		nl: "Nederlands",
		pl: "Polski",
		sv: "Svenska",
		cs: "Čeština",
		ky: "Кыргызча",
		uz: "Узбекча",
		kk: "Қазақша",
		fa: "فارسی",
	},
	"style-guide": {
		"check-with-style-guide": "Проверить по стайлгайду",
		"set-up-connection-and-style-guide": "Настройте подключение и правила",
		"check-article": "Проверить текущую статью",
		"set-up-style-guide": "Правила по стайлгайду",
		"set-up-connection": "Подключение к LLM",
		"style-guide-settings": "Правила по стайлгайду",
		"delete-text": "Предложено удалить фрагмент",
		"replace-text": "Предложение по замене",
		"LLM-provider": "LLM Provider",
		"enter-token": "Введите токен",
		"verifying-token": "Проверяем токен",
		"invalid-token": "Неверный токен",
		recommended: "Рекомендуемая",
		"settings-file": "Файл настроек",
		"invalid-file-format": "Неверный формат файла",
		"select-file": "Выберите файл",
		"no-file-selected": "Файл не выбран",
		disabled: "Модуль стайлгайда отключен",
		"failed-to-check": "Не удалось проверить статью",
		"token-descriprion":
			"Ваш токен остается на вашем устройстве и не передается на наши серверы. Пожалуйста, храните ваш токен в безопасности и не делитесь им с другими.",
		"settings-description": `<p>Чтобы загрузить файл настроек стайлгайдов, выполните следующие шаги:</p>
<ol>
	<li>
		<p>
			Зайдите на
			<a
				target="_blank"
				href="https://check.gram.ax"
				rel="noreferrer"
			>
				check.gram.ax
			</a>
			и перейдите в раздел «Настройки».
		</p>
	</li>
	<li>
		<p>
			Настройте токены подключения к выбранному провайдеру LLM (например, OpenAI, Anthropic и др.).
		</p>
	</li>
	<li>
		<p>Создайте правила и протестируйте их работу.</p>
	</li>
	<li>
		<p>Экспортируйте файл настроек.</p>
	</li>
	<li>
		<p>Загрузите полученный файл в эту форму.</p>
	</li>
</ol>
<p>
	Подробнее читайте в
	<a
		target="_blank"
		rel="noreferrer"
		href="https://gram.ax/resources/docs/review/comments"
	>
		документации
	</a>
	.
</p>`,
	},
	workspace: {
		name: "Пространство",
		"configure-your-workspace": "Настройте параметры вашего пространства",
		"default-name": "Основное пространство",
		"enter-name": "Введите название",
		"path-desc": "Директория на локальном диске, в которой находятся рабочие каталоги",
		selected: "Рабочая директория: ",
		add: "Добавить пространство",
		edit: "Настройки пространства",
		delete: {
			desktop: "Удалить пространство? Каталоги останутся на вашем компьютере",
			web: "Удалить пространство? Все каталоги в нем также удалятся",
		},
		"edit-style": "Редактировать стили",
		"editing-css": "Редактирование CSS-стилей",
		"css-style": "CSS-стили",
		plugin: "Добавить плагин",
		"css-configuration-instruction": "Для настройки CSS-стилей приложения и портала воспользуйтесь {{instruction}}",
		instruction: "инструкцией",
		logo: "Логотип",
		appearance: "Внешний вид",
		"appearance-unavailable": "Оформление доступно после того, как у пространства появится рабочая директория",
		"set-ai-server": "AI-сервер",
		"set-ai-server-description": "Заполните для включения AI-функций в пространстве.",
		"ai-server-url": "URL AI-сервера",
		"ai-server-url-description": "Введите ссылку до вашего AI-сервера",
		"ai-server-token": "Токен AI-сервера",
		"ai-server-token-description": "Введите токен для вашего AI-сервера",
		"ai-server-error": "Ошибка при подключении к серверу. Проверьте URL.",
		"ai-token-error": "Токен недействителен. Проверьте его в настройках сервера.",
		"ai-token-set-error": "Токен не установлен. Для подключения необходимо установить токен.",
		"delete-ai-server": "Удалить AI-сервер?",
		"lfs-section-title": "Git LFS",
		"lfs-section-description":
			"Паттерны файлов, отслеживаемые через Git LFS. Применяются ко всем каталогам в пространстве",
		"upload-error-title": "Ошибка при загрузке",
		"invalid-logo-format-body":
			"Неподдерживаемый формат файла. Пожалуйста, загрузите логотип в формате SVG или PNG",
		"icon-invalid-files-body":
			"При загрузке файлов [{{iconNames}}] возникли ошибки. Пожалуйста, загрузите иконки в формате SVG и размером не более 500 КБ",
		"icons-available-in-article": "Иконки, которые доступны в статье",
		"icons-uploaded": "Иконок загружено",
		"logo-upload-failed": "Не удалось загрузить логотип",
		"logo-size-exceeded": "Размер логотипа не должен превышать 500КБ",
		"css-styles-description": "Продвинутая настройка стилей для вашего пространства",
		"dark-logo-description": "Используется только в темной теме",
		"for-dark-theme": "Для темной темы",
		"default-logo-description": "Используется в светлой теме и в темной, если нет логотипа для темной темы",
		tooltip: {
			"only-current": {
				one: "каталог доступен для синхронизации в текущем пространстве",
				few: "каталога доступны для синхронизации в текущем пространстве",
				many: "каталогов доступны для синхронизации в текущем пространстве",
			},
			"including-current": {
				one: "каталог доступен для синхронизации ({{current-count}} в текущем)",
				few: "каталога доступны для синхронизации в {{workspace-count}} пространствах ({{current-count}} в текущем)",
				many: "каталогов доступны для синхронизации в {{workspace-count}} пространствах ({{current-count}} в текущем)",
			},
			"excluding-current": {
				one: "каталог доступен для синхронизации",
				few: "каталога доступны для синхронизации в {{workspace-count}} пространствах",
				many: "каталогов доступны для синхронизации в {{workspace-count}} пространствах",
			},
			"only-one-excluding-current": {
				one: "каталог доступен для синхронизации в одном из пространств",
				few: "каталога доступны для синхронизации в одном из пространств",
				many: "каталогов доступны для синхронизации в одном из пространств",
			},
			"has-changes": {
				one: "Доступен {{count}} каталог для синхронизации",
				few: "Доступно {{count}} каталога для синхронизации",
				many: "Доступно {{count}} каталогов для синхронизации",
			},
		},
		main: {
			title: "Вид главной страницы",
			view: {
				folder: "Папки",
				section: "Секции и папки",
			},
		},
	},
	"file-input": {
		"select-file": "Выберите файл",
		"no-file-chosen": "файл не выбран",
		"logo-light": "Логотип для светлой темы",
		"logo-dark": "Логотип для тёмной темы",
		"dark-theme-only": "Отображается только в тёмной теме",
		"both-themes-if-no-dark": "Отображается в обеих темах, если нет логотипа для тёмной",
		"use-dark-logo": "Другое лого для тёмной темы",
		placeholder: "Иконка / Эмодзи / Свой логотип",
	},
	modal: {
		confirm: {
			"warning-have-changes": "Вы уверены, что хотите выйти из режима редактирования? Ваши изменения удалятся",
		},
	},
	multilang: {
		name: "Мультиязычность",
		description: "Отображение статей каталога на нескольких языках с переключением между ними.",
		switch: "Переключить язык",
		"preview-article": "Предпросмотр статьи",
		warning: {
			action: {
				title: "Будет выполнено также для других языков",
				body: "Вы собираетесь изменить структуру каталога, который поддерживает несколько языков. Для корректного отображения каталога, файловая структура его локализаций должна быть одинаковой.",
			},
			delete: {
				title: "Удалить другие версии?",
				body: "Вы собираетесь выполнить действие над содержимым, которое имеет версии на других языках. Структура каталога на всех языках должна быть одинаковой, поэтому это действие будет выполнено также над содержимым на других языках.",
			},
		},
		"delete-confirm": "Вы уверены, что хотите удалить язык?",
		"add-localization": "Добавить язык",
		current: "Вы уже просматриваете этот язык",
		error: {
			"cannot-switch-to-self": "Нельзя удалить или переключиться на текущий язык",
			"cannot-add-language": "Нельзя добавить уже добавленный язык",
		},
	},
	article: {
		"raw-markdown": {
			broken: {
				title: "Показан файл целиком",
				desc: "Свойства статьи вверху файла не читаются, поэтому Gramax показывает файл как есть — обычно здесь только текст статьи. Исправьте свойства и сохраните файл.",
				save: "Сохранить файл",
			},
			"not-saved": {
				title: "Файл не сохранён",
				desc: "Свойства по-прежнему не читаются:",
			},
			repaired: {
				title: "Свойства прочитаны",
				desc: "Файл сохранён — статья снова доступна целиком.",
				open: "Открыть статью",
			},
		},
		unreadable: {
			file: "Файл: {{path}}",
			reason: "Сообщение парсера:",
			"opened-at": "Сам элемент открыт в строке {{line}} — если он не закрыт, искать надо там.",
			mismatch: "Внутри {{node}} на этом месте ожидался {{expected}}, а встретился {{got}}.",
			"mismatch-text":
				"Внутри {{node}} ожидался {{expected}}, но Gramax прочитал эту строку как обычный текст — значит разметку на ней он не распознал.",
			"open-markup": "Открыть разметку",
			markup: {
				title: "Не удалось прочитать разметку статьи",
				"at-line": "Gramax не смог разобрать разметку в строке {{line}}. Текст статьи цел, файл не изменён.",
				somewhere: "Gramax не смог разобрать разметку статьи. Текст статьи цел, файл не изменён.",
				remedy: "Откройте разметку и исправьте это место — после этого статья откроется.",
			},
			properties: {
				title: "Не удалось прочитать свойства статьи",
				desc: "В начале файла хранятся название статьи и её место в списке — Gramax не смог их прочитать. Текст статьи цел, файл не изменён.",
				remedy: "Откройте разметку и исправьте свойства — после этого статья откроется.",
			},
		},
		"save-pending": "Есть несохранённые изменения",
		"save-done": "Все изменения сохранены",
		width: {
			label: "Ширина статьи",
			drag: "Потяните, чтобы изменить ширину статьи",
			expand: "Двойной клик — во всю ширину",
			reset: "Двойной клик — обычная ширина",
		},
		actions: {
			title: "Действия со статьей",
			delete: {
				section: {
					title: "Удалить раздел?",
					body: 'Раздел <strong style="font-weight: 500">{{title}}</strong> и вложенные статьи {{count}} в нем будут удалены.',
				},
				article: {
					title: "Удалить статью?",
					body: 'Статья <strong style="font-weight: 500">{{title}}</strong> будет удалена.',
				},
				buttons: {
					primary: "Удалить{{count}}",
					secondary: "Отмена",
				},
				"restore-from-trash": "Вы можете восстановить её из корзины.",
			},
		},
		create: {
			title: "Создать статью",
			body: "В левой навигации будут ваши разделы и статьи. Для начала создайте первую статью.",
		},
		move: {
			"to-workspace": "Переместить",
			"no-workspaces": "Переместить некуда: других рабочих пространств нет",
			"create-new-catalog": "Создать новый каталог",
			"no-catalogs": "Нет доступных каталогов",
			"cannot-move-language": "Статью нельзя переместить из многоязычного каталога",
			"cannot-move-template": "Статья создана по шаблону каталога, а шаблон не переместится вместе с ней",
			"cannot-move-template-inside":
				"В разделе есть статья «{{title}}» по шаблону каталога, а шаблон не переместится вместе с разделом",
			"shared-templates-move": "Статьи по шаблонам из общих материалов можно перемещать в пределах пространства",
			"template-taken":
				"Статью нельзя переместить в каталог «{{catalog}}»: его шаблон «{{template}}» заменит шаблон «{{shared}}» из общих материалов. Выберите другой каталог.",
			"template-taken-unresolved":
				"Статью нельзя переместить в каталог «{{catalog}}»: её шаблон не найден, и там статья открылась бы по шаблону «{{template}}». Выберите другой каталог.",
			progress: "Перемещение статьи",

			duplicate: {
				title: "Эта статья уже существует",
				description:
					"В каталоге <code>{{targetCatalogName}}</code> статья <code>{{articleName}}</code> уже существует. Вы можете оставить обе статьи или заменить существующую",
				"keep-both": "Оставить обе",
				replace: "Заменить",
				cancel: "Отмена",
			},
		},
		title: "Заголовок статьи",
		"no-name": "Без названия",
		placeholder: "Текст статьи",
		"add-child": "Добавить дочернюю статью",
		"add-root": "Добавить статью в корень",
		add: "Добавить статью",
		"next-article": "Следующая статья",
		"previous-article": "Предыдущая статья",
		configure: {
			title: "Настройки статьи",
			description: "Настройте параметры вашей статьи",
		},
		"edit-markdown": "Редактировать Markdown",
		"edit-markdown-disabled-template": "Вы не можете редактировать Markdown шаблонной статьи",
		"edit-markdown-disabled-not-current-item": "Вы не можете редактировать Markdown не текущей статьи",
		links: {
			name: "Связанные статьи",
			backlinks: "Ссылки на статью",
			links: "Ссылки из статьи",
			"no-links": "Ссылки не найдены",
		},
		"markdown-edit": {
			title: "Разметка Markdown",
			description: "Измените или задайте оформление статьи в разметке",
		},
		error: {
			parse: {
				default:
					"Gramax не смог прочитать Markdown-конструкцию в файле статьи.\nИсправьте ошибку или удалите конструкцию.",
				web: "Gramax не смог прочитать Markdown-конструкцию в файле статьи.\nКликните <a href='?mode=markdown'>Редактировать Markdown</a>, а затем исправьте ошибку или удалите конструкцию.",
			},
			frontmatter: "Gramax не смог прочитать свойства статьи в начале файла.",
			"resource-too-large": {
				title: "Не удалось добавить файл",
				desc: "Размер файла превышает {{maxSizeMb}}мб. Сожмите его, выберите файл поменьше или воспользуйтесь десктопной версией.",
			},
			"not-found": {
				title: "Статья не найдена",
				body: "Статья была перенесена или удалена. Перезагрузите страницу, чтобы получить изменения.",
			},
			"render-failed": "Не удалось отобразить статью",
		},
		"page-error": {
			"article-not-found": {
				title: "Статья не найдена",
				desc: "По пути {{path}} в каталоге «{{catalog}}» ничего нет. Статью могли удалить или переименовать.",
				"desc-no-catalog": "По пути {{path}} ничего нет. Статью могли удалить или переименовать.",
				remedy: "Проверьте ссылку или откройте статью из списка слева.",
				action: "В начало каталога",
				"open-in-desktop": "Открыть в десктопе",
			},
			"catalog-not-found": {
				title: "Каталог не найден",
				desc: "Каталога {{path}} нет в этом рабочем пространстве. Его могли удалить, переименовать или не загрузить на это устройство.",
				"desc-no-path": "Gramax не понял, какой каталог нужно открыть.",
				remedy: "Проверьте ссылку или выберите каталог из списка.",
				action: "К списку каталогов",
			},
			forbidden: {
				title: "Нет доступа к статье",
				desc: "Статья приватная. Она открыта не всем, кто может читать каталог.",
				remedy: "Войдите под аккаунтом, у которого есть доступ, или запросите права у владельца каталога.",
				action: "Войти",
			},
			unknown: {
				title: "Не удалось открыть статью",
				desc: "Gramax не смог собрать эту страницу. Файл статьи при этом не изменялся — сбой произошёл при чтении.",
				remedy: "Перезагрузите страницу. Если не помогло, откройте другую статью и вернитесь к этой позже.",
				action: "Перезагрузить",
			},
			"read-only": {
				title: "Не удалось открыть статью",
				desc: "Статья написана с ошибкой, и Gramax не может её показать.",
				remedy: "Сообщите об этом автору каталога — починить статью можно только в исходном тексте.",
			},
		},
	},
	section: {
		configure: {
			title: "Настройки раздела",
			description: "Настройте параметры вашего раздела",
		},
	},
	catalog: {
		actions: {
			title: "Действия с каталогом",
		},
		report: {
			name: "Отчет",
		},
		navigation: "Навигация по каталогу",
		new: "Создать новый",
		"new-2": "Создать новый каталог",
		"new-3": "Хранится локально до первой публикации",
		unpublished: "Каталог еще не опубликован",
		clone: "Загрузить",
		"clone-2": "Загрузить существующий каталог",
		"clone-3": "Загрузить по ссылке",
		"clone-4": "Из GitHub, GitLab или другого хранилища",
		"available-error": {
			loading: "Загружаем список доступных каталогов…",
			hint: "Нажмите, чтобы повторить",
			title: "Не удалось загрузить доступные каталоги",
			retry: "Повторить",
		},
		import: "Импортировать",
		"import-2": "Импортировать из другой системы",
		"import-3": "Из Confluence или Notion",
		add: "Добавить каталог",
		views: {
			trigger: "Представление каталога",
			editing: "Редактирование",
			"name-required": "Укажите название",
			sections: {
				saved: "Сохраненные",
				grouping: "Группировка",
				filters: "Фильтры",
				properties: "Переменные",
			},
			"group-by-hierarchy": "По родителю",
			"filtered-out": "Не подходит под текущее представление",
			"temp-view": "Временное представление",
			edit: {
				title: {
					new: "Новое представление",
					edit: "Редактирование представления",
				},
				description: {
					new: "Создайте новое представление для вашего каталога",
					edit: "Измените параметры вашего представления",
				},
				deleteDescription: "Вы уверены, что хотите удалить это представление? Это действие нельзя отменить.",
				form: {
					name: "Название",
					filter: "Фильтр",
					property: "Переменные",
					options: {
						docportalVisible: {
							name: "Показывать читателям",
							description: "Представление будет видно и доступно для применения на портале документации",
						},
					},
				},
			},
		},
		delete: {
			name: "Удалить каталог",
			title: "Удалить каталог?",
			local: "Этот каталог хранится только в приложении. Вы не сможете его восстановить",
			storage: "Каталог удалится только из приложения. Но вы сможете его заново загрузить из хранилища",
			progress: "Удаление каталога",
			device: {
				name: "Удалить с устройства",
				title: "Удалить каталог с устройства?",
				confirm: "Каталог удалится только с этого устройства. Его можно будет снова загрузить из пространства",
			},
			space: {
				name: "Удалить из пространства",
				title: "Удалить каталог из пространства?",
				confirm:
					"Каталог исчезнет из пространства у всех участников и удалится с этого устройства. Репозиторий в хранилище останется — вернуть каталог в пространство сможет администратор",
				"confirm-not-loaded":
					"Каталог исчезнет из пространства у всех участников. Репозиторий в хранилище останется — вернуть каталог в пространство сможет администратор",
			},
		},
		move: {
			"unavailable-in-ges": "Невозможно переместить каталог из энтерпрайз-пространства",
			"to-workspace": "Переместить",
			"no-workspaces": "Переместить некуда: других рабочих пространств нет",
		},
		duplicate: {
			title: "Этот каталог уже существует",
			description:
				"В пространстве <code>{{targetWorkspaceName}}</code> каталог <code>{{catalogName}}</code> уже существует. Вы можете оставить оба, либо заменить существующий каталог",
			"keep-both": "Оставить оба",
			replace: "Заменить",
			cancel: "Отмена",
		},
		name: "каталог",
		configure: "Настроить каталог",
		"missing-config": {
			title: "Недостаточно информации о каталоге",
			description:
				"Этот каталог создан не в Gramax: у него нет названия, группы и логотипа. Укажите их в настройках.",
			"open-settings": "Открыть настройки",
		},
		"catalog-already-linked": {
			name: "Каталог уже связан с хранилищем",
			description:
				"Мы определили, что каталог связан с репозиторием. Но мы не знаем, в каком хранилище этот репозиторий находится. Добавьте хранилище, чтобы подтвердить привязку.",
		},
		style: {
			red: "Красный",
			blue: "Синий",
			black: "Черный",
			green: "Зеленый",
			purple: "Фиолетовый",
			"blue-pink": "Сине-розовый",
			"pink-blue": "Розово-синий",
			"blue-green": "Сине-зеленый",
			"red-green": "Красно-зеленый",
			"orange-red": "Оранжево-красный",
			"red-orange": "Красно-оранжевый",
			"blue-purple": "Сине-фиолетовый",
			"purple-blue": "Фиолетово-синий",
			"dark-orange": "Темно-оранжевый",
			"pink-purple": "Розово-фиолетовый",
			"orange-green": "Оранжево-зеленый",
			"green-orange": "Зелено-оранжевый",
			"bright-orange": "Светло-оранжевый",
			"purple-orange": "Фиолето-оранжевый",
			teal: "Бирюзовый",
		},
		"get-started": {
			editor: "С помощью Gramax можно создавать и редактировать документацию прямо в репозитории с кодом. Начать работу можно тремя способами:",
			"editor-desc":
				"<ul><li>Создайте каталог в Gramax и опубликуйте его в GitLab или GitHub.</li><li>Загрузите существующий репозиторий.</li><li>Импортируйте раздел из Confluence.</li></ul>",
			docportal: "Загрузите каталоги, которые будут видны читателям",
		},
		error: {
			"already-exist": "Такой каталог уже существует",
			"already-exist-2":
				"В хранилище % каталог % уже существует.\nИзмените «Название репозитория» в настройках каталога.",
			"read-only-item": "Разделы верхнего уровня этого каталога изменить нельзя",
			"no-root-articles": "На верхний уровень этого каталога нельзя добавлять новое",
			"locked-article-url": "URL статьи этого каталога изменить нельзя",
			"registered-name": "Имя этого каталога задает пространство, переименовать его нельзя",
			"registered-move": "Этот каталог принадлежит пространству, перенести его в другое нельзя",
			"no-new-groups": "В этот каталог нельзя добавлять новые разделы верхнего уровня",
			"unreadable-name":
				"Имя каталога не может начинаться с точки, содержать слэш или совпадать со служебной папкой",
			"clone-in-progress": "В эту папку уже клонируется другой репозиторий",
			"top-level-article-nesting": "В статью верхнего уровня этого каталога нельзя вкладывать статьи",
			"folder-taken": "Папка {{path}} не пуста",
			"no-source-data": "Нет учетных данных для хранилища {{source}}",
			"props-unreadable": {
				title: "Не удалось сохранить настройки каталога",
				body: "<p>Файл свойств каталога {{name}} <code>{{path}}</code> не читается, поэтому Gramax не стал его перезаписывать. Настройки в файле целы, новые не сохранены.</p><p>Исправьте файл вручную — после этого настройки сохранятся.</p>",
			},
		},
	},
	share: {
		name: {
			catalog: "Поделиться каталогом",
			article: "Поделиться статьей",
		},
		description: {
			catalog: "Поделиться ссылкой на каталог с другими пользователями",
			article: "Поделиться ссылкой на статью с другими пользователями",
		},
		"new-file-disable": "Поделиться возможно только после публикации статьи",
		copy: "Ссылка для доступа к статье и каталогу на ветке ",
		hint: "Вы также можете скопировать ссылку напрямую из адресной строки браузера.",
		note: "Примечание:",
		desc: "<b>Примечание:</b> Убедитесь, что у получателя есть доступ к репозиторию в {{domain}} через <em>Access Token</em> с правами <code>read_api</code> и <code>write_repository</code>.",
		more: "Подробнее.",
		popover: "Скопировано в буфер обмена",
		error: {
			"no-private-groups":
				"Не установленно ни одной приватной группы. Подробнее https://docs.ics-it.ru/doc-reader/catalog/private",
			"need-permission": "Нужен доступ к каталогу",
			"incorrect-ticket": "Некорректный тикет",
			"failed-to-copy": "Не удалось скопировать в буфер обмена",
		},
	},
	diagram: {
		modal: {
			"warning-have-changes": {
				title: "Выйти из режима редактирования?",
				body: "Несохранённые изменения будут потеряны.",
				stay: "Остаться",
				exit: "Выйти",
			},
		},
		name: "Диаграмма",
		"bpmn-editor": "Диаграмма BPMN",
		names: {
			mermaid: "Mermaid",
			puml: "PlantUml",
			drawio: "Diagrams.net",
			bpmn: "BPMN",
		},
		error: {
			"render-failed": "Не удалось отобразить диаграмму",
			"save-failed": "Не удалось сохранить диаграмму. Файл не записан — схема осталась в редакторе.",
			"cannot-get-data": "Проверьте, правильно ли указан путь, а также есть ли файл в репозитории.",
			"no-diagram-renderer": "Модуль для рендера диаграмм не включен",
			"no-internet": "Проверьте подключение к интернету.",
			"invalid-syntax": "Проверьте синтаксис диаграммы.",
			"tabledb-render-failed": "Не удалось отобразить таблицу",
			"tabledb-file-not-found": "Не найден файл схемы по пути",
			"tabledb-not-found": "Таблица не найдена",
			"wrong-name": "Неправильное имя диаграммы",
			specification: "Не удалось отобразить спецификацию",
			"content-empty": "Файл диаграммы пуст",
			"mermaid-export-next-error": "Mermaid диаграмма будет выведена в виде контента диаграммы",
		},
	},
	openApi: {
		loading: "Загружаю OpenAPI спецификацию...",
		noSourceHint: "Укажите src или передайте spec, чтобы отрендерить документ OpenAPI.",
		errorTitle: "Не удалось отобразить OpenAPI-спецификацию",
		errorInvalidFormat: "Файл спецификации имеет неверный формат.",
		errorTechnicalDetails: "Технические детали",
		authorize: "Авторизоваться",
		noResultsFound: "Ничего не найдено",
		operationsHeading: "Операции",
		searchPlaceholder: "Поиск по операциям...",
		searchResultsCount: "{count} из {total}",
		searchClearAriaLabel: "Очистить поиск",
		serverVariableUnused: "нет в URL",
		termsOfService: "Условия использования",
		contact: "Контакт",
		externalDocs: "Внешняя документация",
		docsLinkFallback: "Документация",
		diagnosticsAriaLabel: "Диагностика OpenAPI",
		diagnosticsErrors: "Ошибки",
		diagnosticsWarnings: "Предупреждения",
		diagnosticsInfo: "Информация",
		diagnosticPath: "Путь",
		diagnosticExpected: "Ожидалось",
		diagnosticReceived: "Получено",
		diagnosticAction: "Действие",
		diagnosticVersionUnsupported: "OpenAPI {received} поддерживается частично.",
		diagnosticResponsesMissing: "нет responses, операция пропущена.",
		diagnosticResponsesNotObject: "responses должен быть объектом, операция пропущена.",
		diagnosticExternalRefUnresolved: "$ref не разрешился, использовано резервное значение.",
		diagnosticInternalRefUnresolved: "$ref не разрешился, использовано резервное значение.",
		diagnosticOperationNotObject: "Операция должна быть объектом и была пропущена.",
		diagnosticPathItemNotObject: "Элемент paths должен быть объектом и был пропущен.",
		diagnosticParametersNotArray: "parameters должен быть массивом, блок параметров пропущен.",
		diagnosticParameterNotObject: "Параметр должен быть объектом или $ref, был пропущен.",
		diagnosticParameterNameNotString: "Имя параметра должно быть строкой, использовано резервное пустое имя.",
		diagnosticParameterLocationNotString:
			"Расположение параметра должно быть строкой, использовано резервное значение.",
		diagnosticParameterSchemaNotObject: "Схема параметра должна быть объектом, отрендерена как неизвестная схема.",
		diagnosticContentNotObject: "content должен быть объектом по media type, рендеринг content пропущен.",
		diagnosticMediaTypeNotObject: "Запись media type должна быть объектом, пропущена.",
		diagnosticMediaSchemaNotObject: "Схема media должна быть объектом, пример может всё же отрендериться.",
		diagnosticRequestBodyNotObject: "requestBody должен быть объектом или $ref, пропущено.",
		diagnosticResponseNotObject: "Response должен быть объектом или $ref, отрендерен с резервными значениями.",
		diagnosticResponseHeadersNotObject: "Заголовки response должны быть объектом, пропущены.",
		diagnosticResponseLinksNotObject: "Ссылки response должны быть объектом, пропущены.",
		diagnosticSchemasNotObject: "components.schemas должен быть объектом, секция «Схемы» пропущена.",
		diagnosticSchemaNotObject: "Запись схемы должна быть объектом, пропущена.",
		diagnosticSecuritySchemesNotObject: "Security schemes должны быть объектом, способы авторизации пропущены.",
		diagnosticSecuritySchemeNotObject: "Security scheme должна быть объектом или $ref, схема пропущена.",
		diagnosticSecuritySchemeTypeInvalid:
			"Тип security scheme отсутствует или некорректен, способ нельзя применить.",
		diagnosticSecuritySchemeFieldInvalid: "В security scheme отсутствует обязательное поле или оно некорректно.",
		diagnosticSecurityRequirementsNotArray: "security должен быть массивом, требования авторизации пропущены.",
		diagnosticSecurityRequirementNotObject: "Security requirement должен быть объектом и был пропущен.",
		diagnosticSecurityRequirementScopesNotArray:
			"Scopes в security requirement должны быть массивом и были проигнорированы.",
		diagnosticSecurityRequirementUnknownScheme: "Security requirement ссылается на необъявленную схему.",
		diagnosticVersionMissing: "Версия OpenAPI не указана, рендеринг продолжается в режиме совместимости.",
		diagnosticInfoMissing: "В спеке нет объекта info, использованы резервные заголовок и версия.",
		errors: {
			title: "Не удалось отобразить OpenAPI-спецификацию",
			missing: "Файл «{path}» не найден. Проверьте путь или пересоздайте компонент.",
			empty: "Файл «{path}» пуст. Откройте редактор спеки (карандаш) и заполните её.",
			invalidFormat: "Файл спецификации имеет неверный формат.",
			syntax: "Ошибка синтаксиса {format}: строка {line}, колонка {column}.",
			structureObject: "Файл не похож на OpenAPI-спецификацию: содержимое должно быть объектом.",
			structurePaths: "Файл не похож на OpenAPI-спецификацию: нет секции paths с операциями API.",
			structurePathsObject:
				"Файл не похож на OpenAPI-спецификацию: секция paths должна быть объектом с операциями API.",
			structureOperations: "Файл не похож на OpenAPI-спецификацию: нет валидных операций API.",
			expected: "ожидалось:",
			received: "получено:",
			runtimeTitle: "Что-то пошло не так",
			runtimeMessage: "Не удалось отобразить блок. Разработчики уже получили отчёт об ошибке.",
		},
		permalink: "Постоянная ссылка",
		permalinkTo: "Постоянная ссылка на",
		deprecated: "устарело",
		parametersTitle: "Параметры",
		requestTitle: "Запрос",
		curlTitle: "cURL",
		modeDescribe: "Обзор",
		modeExecute: "Попробовать",
		requiredBadge: "обязательный",
		paramColumnName: "Параметр",
		paramColumnDescription: "Описание",
		paramColumnValue: "Значение",
		paramDefaultLabel: "По умолчанию",
		paramExampleLabel: "Пример",
		sendEmptyValue: "отправлять как ?{name}=",
		valueNotSet: "Не задано",
		deepObjectHint: "JSON-объект или пары key=value; сериализуется как name[key]=value.",
		fieldColumnName: "Поле",
		cookieParamsNotice: "Try не отправит cookie-параметры",
		cookieParamsNoticeDetail: "Введённые значения будут добавлены только в сгенерированную команду curl.",
		codeSamplesLabel: "Примеры кода",
		sampleFallbackLabel: "Пример",
		copyTitle: "Копировать",
		openLinkLabel: "Открыть",
		contentTypeLabel: "Тип содержимого",
		exampleTab: "Пример",
		schemaTab: "Схема",
		schemaAllowedValuesLabel: "Допустимые значения",
		schemaArrayItemsLabel: "Элементы массива",
		schemaAdditionalPropertiesLabel: "Дополнительные поля",
		schemaAdditionalPropertiesForbiddenLabel: "Запрещены",
		binaryTab: "Бинарные данные",
		requestBodyHeading: "Тело запроса",
		binaryBodyHint: "Бинарное тело отправляется как файл/blob без JSON-форматирования.",
		plainBodyHint: "Режим обычного текста: содержимое отправляется как есть, без экранирования JSON.",
		responsesHeading: "Ответы сервера",
		responseColumnCode: "Код",
		responseDefaultHint: "Любой другой HTTP-статус",
		noResponseBody: "Тело ответа отсутствует.",
		binaryResponseNotice: "Бинарный ответ/скачивание. Предпросмотр не выводит сырые байты как текст.",
		formatLabel: "Формат",
		headersLabel: "Заголовки",
		headerColumnName: "Заголовок",
		headerColumnType: "Тип",
		linksLabel: "Ссылки",
		linkColumnName: "Ссылка",
		operationColumnName: "Операция",
		linkedOperationFallback: "связанная операция",
		parametersPrefix: "Параметры следующего вызова:",
		requestBodyPrefix: "Тело следующего запроса:",
		authorizationTitle: "Авторизация",
		noAuthRequired: "Авторизация не требуется.",
		executeRequestButton: "Отправить",
		executeSendingButton: "Отправляем…",
		requiredFieldError: "Обязательное поле",
		requestFailedTitle: "Не удалось получить ответ",
		requestFailedHint:
			"API недоступен или запрос был заблокирован. Проверьте URL сервера или попробуйте команду curl выше.",
		requestFailedMixedContent:
			"Страница отдаётся по HTTPS, а запрос уходит на HTTP — браузер заблокировал его как смешанное содержимое. Укажите адрес сервера по HTTPS.",
		requestFailedCrossOrigin:
			"Запрос уходит на другой источник ({origin}), а про CORS, закрытый порт и недоступный хост браузер сообщает одинаково. Чаще всего API не прислал Access-Control-Allow-Origin для этой страницы. Команду curl выше CORS не ограничивает — если она отвечает, дело в нём.",
		requestFailedNetwork: "Адрес не ответил: сервер не работает, путь неверный или запрос заблокировали по дороге.",
		requestFailedReported: "Транспорт сообщил: {detail}",
		emptyResponseLabel: "(пустой ответ)",
		binaryResponseSummary:
			"Бинарный ответ ({type}), {size} байт. Скачайте его вне предпросмотра, чтобы сохранить файл.",
		secretShow: "Показать значение",
		secretHide: "Скрыть значение",
		requestDetailsLabel: "Детали запроса",
		requestUrlLabel: "URL запроса",
		resultHeading: "Ответ",
		statusLabel: "Статус",
		clearButton: "Очистить",
		bodyLabel: "Тело",
		schemasSectionName: "Схемы",
		schemasSectionDesc: "Модели компонентов OpenAPI",
		modelLabel: "Модель",
		securitySchemesKicker: "Способ авторизации",
		closeLabel: "Закрыть",
		noAuthLabel: "Без авторизации",
		mutualTlsNote: "Сертификат выбирает браузер, когда сервер его запрашивает. Здесь настраивать нечего.",
		httpAuthUnsupportedNote: "Способ HTTP {scheme} здесь не настраивается.",
		authVariantConflictNote: "Эти способы используют одно и то же место в запросе, вместе их не отправить.",
		deprecatedAuthNote: "Этот способ авторизации устарел.",
		doneButton: "Сохранить",
		bearerTokenLabel: "Токен",
		usernameLabel: "Имя пользователя",
		passwordLabel: "Пароль",
		apiKeyHeaderHint: "Уходит в заголовке {name}.",
		apiKeyQueryHint: "Уходит в параметре запроса {name}.",
		apiKeyCookieHint: "Уходит в curl как cookie {name}: «{mode}» cookie не отправляет.",
		apiKeyCookieRequestHint: "Уходит в cookie {name}.",
		authDialogDescription: "Нужны для запросов из «{mode}». Хранятся, пока открыта статья.",
		authDialogOperationDescription: "Для операции «{operation}». Хранятся, пока открыта статья.",
		authMethodBearer: "Bearer-токен",
		authMethodBasic: "Логин и пароль",
		authMethodApiKey: "API-ключ",
		authMethodApiKeyHeader: "API-ключ · заголовок {name}",
		authMethodApiKeyQuery: "API-ключ · параметр {name}",
		authMethodApiKeyCookie: "API-ключ · cookie {name}",
		authMethodMutualTls: "Сертификат клиента",
		authMethodHttp: "HTTP {scheme}",
		authMethodJoin: " и ",
		authVariantAllNote: "Операции нужны все эти способы сразу.",
		unsupportedAuthNote: "Этот способ здесь не настраивается.",
		secretClear: "Очистить",
		bearerHint: "Уходит в заголовке {name}.",
		bearerFormatHint: "Формат {format}. Уходит в заголовке {name}.",
		basicHint: "Логин и пароль уходят в заголовке {name}.",
		usernamePlaceholder: "ivan.ivanov",
		apiKeyLabel: "API-ключ",
		accessTokenLabel: "Токен доступа",
		oauthTokenHint: "Войти через OAuth 2.0 отсюда нельзя: получите токен в сервисе и вставьте его сюда.",
		openIdTokenHint: "Войти через OpenID Connect отсюда нельзя: получите токен в сервисе и вставьте его сюда.",
		requiredScopesHint: "Операции нужны права {list}.",
		oauthSettingsTitle: "Параметры OAuth 2.0",
		openIdSettingsTitle: "Параметры OpenID Connect",
		collapseLabel: "Свернуть",
		expandLabel: "Развернуть",
		authorizationUrlLabel: "Адрес входа",
		tokenUrlLabel: "Адрес получения токена",
		refreshUrlLabel: "Адрес обновления токена",
		deviceAuthorizationUrlLabel: "Адрес входа с устройства",
		oauthMetadataUrlLabel: "Адрес метаданных OAuth 2.0",
		openIdConnectUrlLabel: "Адрес настроек OpenID Connect",
		scopesLabel: "Права",
		cancelLabel: "Отмена",
		printExampleCaption: "Пример: {name}",
		printCodeSampleCaption: "Примеры кода: {name}",
		printAuthLine: "Авторизация: {methods}",
		printAuthOr: " или ",
		serverVariableColumn: "Переменная",
		serverVariableDefaultColumn: "По умолчанию",
		serverVariableOptionsColumn: "Варианты",
		paramTipQuery: "Передаётся в строке запроса URL после «?», например ?page=1",
		paramTipPath: "Подставляется прямо в путь URL, например /users/42",
		paramTipHeader: "Передаётся в заголовке HTTP-запроса",
		paramTipCookie: "Передаётся в cookie запроса",
		serverLabel: "Сервер",
		baseUrlLabel: "Базовый URL",
		serverVariablesLabel: "Переменные URL",
		operationServersLabel: "Базовый URL этой операции",
		relativeUrlFallback: "относительный",
		serverSelectAriaLabel: "Сервер",
		untaggedGroupLabel: "Без тега",
		specSwitcherAriaLabel: "Спецификация OpenAPI",
		otherTagsLabel: "Другие теги",
		swagger2HostLabel: "Хост Swagger 2.0",
	},
	"open-in": {
		web: "Открыть в веб-приложении",
		desktop: "Открыть в приложении",
		gramax: "Редактировать в Gramax",
		generic: "Открыть в",
		teams: "Открыть в Teams",
		finder: "Показать в Finder",
		explorer: "Показать в проводнике",

		error: {
			"cannot-open-desktop": {
				title: "Приложение не установлено",
				desc: "<a target='_blank' rel='noreferrer' href='https://gram.ax'>Скачайте приложение</a><span> и попробуйте еще раз.</span>",
			},
		},
	},
	"enterprise-guest": {
		welcomeTitle: "Добро пожаловать в Gramax!",
		privateTitle: "Войдите, чтобы продолжить",
		privateDescription: "Эта статья доступна только авторизованным пользователям",
		"session-expired": "Срок сессии истек. Войдите снова.",
		descriptions: {
			emailFieldDescription: "Введите почту, на нее будет отправлен одноразовый код",
			otpFieldDescription: "Введите код, который пришел на почту",
			continueWith: "или продолжите с",
		},
		placeholders: {
			emailPlaceholder: "ivanov@example.com",
			otpPlaceholder: "123456",
		},
		buttons: {
			sendPasswordButton: "Отправить код",
			resendPasswordButton: "Отправить код повторно",
			confirmButton: "Подтвердить",
			resendPasswordButtonWithCooldown: "Отправить код повторно через {seconds} сек",
			corporateLoginButton: "Вход через SSO",
		},
		fields: {
			emailLabel: "Email",
			otpLabel: "Код доступа",
		},
		validationErrors: {
			emailRequired: "Почта обязательна",
			emailInvalidFormat: "Некорректный формат почты",
			edgeWhitespace: "Email содержит пробелы. Пересоздайте запись.",
			otpRequired: "Код обязателен",
			formSubmitError: "Заполните все обязательные поля корректно",
			otpNumbersOnly: "Код должен содержать только цифры",
			otpLength: "Код должен состоять из 6 цифр",
		},
		tooltips: {
			tooManyRequests: "Превышен лимит запросов. Попробуйте через {minutes} мин",
			resendAvailableIn: "Повторная отправка доступна через {seconds}",
			internalServerError: "Внутренняя ошибка сервера. Пожалуйста, попробуйте позже",
			loginFailed: "Ошибка входа (Статус: {status})",
			errorSendingPassword: "Ошибка при отправке кода (Статус: {status})",
			invalidOtp: "Неверный одноразовый код",
			networkError: "Ошибка сети. Пожалуйста, попробуйте снова",
		},
	},
	"enterprise-cloud-guest": {
		buttons: {
			continueWithGoogle: "Войти с помощью Google",
			continueWithYandex: "Войти с помощью Yandex",
			continueWithoutAccount: "Продолжить без аккаунта",
			continueWithEmail: "Войти с помощью почты",
			continueWithGes: "Войти через SSO",
			back: "Назад",
		},
		//TODO: what text should be here?
		description: "Войдите, чтобы синхронизировать устройства",
		"email-code": {
			emailLabel: "Почта",
			emailPlaceholder: "Введите вашу почту",
			sendCode: "Получить код",
			sending: "Отправляем код",
			retryIn: "Повторить через {time}",
			recentlySent: "Код недавно уже отправлен на этот адрес",
			serviceBusy: "Сейчас слишком много запросов на вход. Попробуйте позже",
			tryAgain: "Попробовать ещё раз",
			checkEmail: "Проверьте почту",
			codeSentTo: "Мы отправили код из {length} цифр на",
			changeEmail: "Изменить почту",
			codeLabel: "Код из письма",
			verifying: "Проверяем код",
			resendCode: "Отправить код повторно",
			resendCodeIn: "Отправить повторно через {time}",
			sendNewCode: "Отправить новый код",
			sendNewCodeIn: "Отправить новый код через {time}",
			spamHint: "Не пришло письмо? Проверьте папку «Спам»",
			startOver: "Начать заново",
			errors: {
				invalidEmail: "Проверьте адрес почты",
				invalidCode: "Неверный код. Осталось попыток: {attempts}",
				expiredCode: "Этот код больше не действует",
				sendFailed: "Не удалось отправить код. Проверьте подключение и попробуйте ещё раз",
				verifyFailed: "Не удалось проверить код. Запросите новый",
				loginNotCompleted: "Не удалось завершить вход. Начните заново",
			},
		},
	},
	cloud: {
		"publish-to-cloud": "Опубликовать в облако",
		"login-modal": {
			title: "Войдите в Gramax Cloud",
			description: "Для публикации каталога требуется авторизация",
			definition:
				"это сервис для размещения статических HTML-версий каталогов. После публикации ваш каталог будет доступен по ссылке",
			"account-info":
				"Вход нужен для защиты и привязки публикации к аккаунту. Все последующие публикации также будут выполняться от имени этого аккаунта.",
		},
		"upload-modal": {
			title: "Опубликовать каталог",
			description: "Сделайте каталог доступным для всех",
			info: "После публикации каталог станет доступен <strong>всем в интернете</strong> по ссылке:",
			revoke: "В любой момент каталог можно снять с публикации.",
			"switch-account": "Сменить аккаунт",
			status: {
				building: "Сборка сайта",
				publishing: "Публикация",
				error: "Не удалось опубликовать",
			},
			published: {
				title: "Перепубликовать каталог",
				description: "Обновите опубликованный каталог доступный для всех",
				info: "После перепубликации каталог продолжит быть доступен <strong>всем в интернете</strong> по ссылке:",
			},
		},
		"uploaded-modal": {
			title: "Каталог успешно опубликован",
			link: "Ссылка на опубликованный каталог",
			description:
				"Статус публикации вы можете увидеть в правой панели. Там же можно обновить или отозвать публикацию.",
		},
		"publish-status-panel": {
			published: "Опубликовано",
			republish: "Перепубликовать",
			delete: "Удалить публикацию",
		},
		error: {
			"failed-to-connect": "Не удалось подключиться к облачному серверу",
			"request-failed": "Не удалось выполнить запрос на облачный сервер",
			"lfs-object-missing":
				"Не удалось получить LFS-файл {{path}}: на этом компьютере только его указатель, а скачать объект из хранилища не получилось. Проверьте доступ к репозиторию и повторите публикацию.",
		},
		"delete-catalog": "Каталог будет удален из облака",
	},
	"log-in": "Войти в ",
	"login-with": "Войти с помощью ",
	search: {
		name: "Поиск",
		open: "Открыть поиск",
		"search-in-article": "Искать в этой статье",
		"search-in-category": "Искать в этом разделе",
		placeholder: "Введите запрос",
		"articles-not-found": "Статей не найдено",
		"all-catalogs": "Искать по всем каталогам",
		ai: "AI-поиск",
		"ai-search-error":
			"Функция AI-поиска недоступна из-за технических неполадок. Рекомендуем обратиться к администратору системы за дополнительной информацией.",
		"ai-search-error-title": "Технические проблемы с AI-поиском",
		"indexing-info": "Индексация...",
		"hidden-results": "...еще {{count}}",
		recommended: "Рекомендовано",
		current: "Текущая статья",
		"property-filter": {
			tooltip: "Фильтр по свойствам",
			"reset-all": "Сбросить всё",
			selected: "Выбрано",
		},
		"resource-filter": {
			"with-resources": "С вложениями",
			"without-resources": "Без вложений",
			"only-resources": "Только во вложениях",
			tooltip: "Поиск во вложениях",
		},
		"scope-filter": {
			all: "По всем каталогам",
			catalog: "В этом каталоге",
			article: "В этой статье",
			category: "В этом разделе",
			folder: "В этой папке",
			tooltip: "Область поиска",
		},
		help: {
			ai: {
				title: "Умный поиск",
				description: "Ищет ответ в базе знаний по смыслу, а не по точному совпадению слов",
			},

			title: "Ищите точнее",

			"exact-desc": "Точное совпадение",
			"exact-example": `"фраза"`,

			"exclude-desc": "Без этого слова",
			"exclude-example": `-слово`,

			"include-desc": "Обязательно с этим словом",
			"include-example": `+слово`,

			"combine-desc": "Можно сочетать",
			"combine-example": `+настройка -"слово"`,
		},
	},
	list: {
		"no-results-found": "Ничего не найдено",
		"search-articles": "Введите ссылку или найдите статью",
		"search-catalogs": "Введите ссылку или найдите каталог",
	},
	versions: {
		name: "Версионирование",
		description: "Несколько версий каталога на основе веток или тегов Git с переключением между ними.",
		switch: "Переключить версию",
		version: "Версия",
		"not-actual-warning": {
			header: "Неактуальная версия",
			"1": "Вы просматриваете неактуальную версию ",
			"2": "<a data-qa href='{{link}}'>Переключите версию</a> для просмотра актуальной версии",
		},
	},
	filterProperties: {
		switch: "Фильтр",
		unfilter: "Без фильтра",
		hasProperty: "Есть свойство",
		value: "Значение",
	},
	git: {
		source: {
			gitlab: {
				info: `Токен для чтения и изменения репозиториев в хранилище. Укажите для токена права: <code>api</code>, <code>read_repository</code>, <code>write_repository</code>.`,
			},
			gitverse: {
				info: `Токен для чтения и изменения репозиториев в хранилище. Укажите для токена права: <code>Репозитории</code>, <code>Пользователи</code>.`,
			},
			gitea: {
				info: `Токен для чтения и изменения репозиториев в хранилище. Укажите для токена права: <code>repository</code>, <code>user</code> (Read and Write).`,
			},
			error: {
				"cannot-create-repo": "Не удалось создать репозиторий",
				"storage-not-exist": `Хранилище с именем "{{storage}}" не существует. Добавьте его.`,
				"catalog-exist": `В хранилище {{storage}} каталог {{name}} уже существует.\nИзмените поле "Название репозитория" в настройках каталога.`,
				"cannot-bind-to-storage": `Нельзя привязать к этому хранилищу`,
				"unsupported-link": "Необходимо указать ссылку формата",
				"invalid-credentials": {
					desc: "Текущий токен для этого хранилища недействителен. Обновите данные хранилища и попробуйте снова.",
				},
				"invalid-credentials2": "Недействительны данные хранилища",
			},
			"remove-alert": "Вы уверены, что хотите удалить это хранилище?",
			"remove-alert-usage": "Оно используется в следующих каталогах:\n\n",
		},
		clone: {
			progress: {
				downloading: "Загрузка",
				checkout: "Извлечение файлов",
				wait: "Ожидание сервера",
				queue: "В очереди",
				finish: "Завершено",
				cancel: "Отмена",
			},
			etc: {
				bs: "{bs} Б/с",
				kbs: "{kbs} КБ/с",
				mbs: "{mbs} МБ/с",
				b: "Б",
				kb: "КБ",
				mb: "МБ",
				gb: "ГБ",
				"eta-s": ", ~{s}с",
				"eta-m": ", ~{m}м {s}с",
				"eta-h": ", ~{h}ч {m}м {s}с",
			},

			"receiving-objects": "Получено {received} объектов из {total} (проиндексировано {indexed})",
			"indexing-deltas": "Проиндексировано {indexed} дельт из {total}",
			checkout: "Извлечено {checkouted} файлов из {total}",
			lfs: "Скачано {handledObjects} LFS-объектов из {totalObjects} ({bytesHandled} / {totalBytes})",
			"repo-link": "Ссылка на репозиторий",
			"not-cloned": {
				title: "Загрузить каталог?",
				body: "Ссылка ведет на каталог, который еще не загружен. Для просмотра и изменения нужно загрузить его из хранилища.",
			},
			"other-storage": {
				title: "Каталог из другого хранилища",
				body: "Эта ссылка ведёт на каталог из хранилища, недоступного в текущем аккаунте Gramax Cloud. Выйдите из аккаунта и откройте ссылку снова.",
			},
			"open-in-app": "Вы также можете открыть этот каталог в десктопном приложении Gramax",
			"public-clone": "Склонировать по ссылке",
			public: {
				"link-title": "Ссылка на репозиторий",
				"link-placeholder": "URL публичного git-репозитория",
				"link-description": `Ссылка на публичный git-репозиторий для клонирования.<br>Например: <a href='https://github.com/gram-ax/gramax' ${getExecutingEnvironment() === "tauri" ? "" : "target=_blank"} rel='noreferrer'>https://github.com/gram-ax/gramax</a>`,
			},
			error: {
				title: "Ошибка загрузки",
				"cannot-clone": "Не удалось загрузить каталог",
				"already-exist": "Каталог с названием <b>{{path}}</b> уже существует",
				"no-permission": "Нет доступа к репозиторию {{url}}",
				generic: "Попробуйте обновить страницу и загрузить каталог заново.",
				"branch-not-found": "Не удалось загрузить каталог на ветке <code>{{branch}}</code>",
				public: {
					"invalid-link":
						"Неверная ссылка на репозиторий. Пожалуйста, проверьте правильность ссылки и публичность репозитория",
					"name-empty": "Название репозитория и ссылка не могут быть пустыми",
				},
			},
		},
		sync: {
			error: {
				"local-changes-present": "Ваши локальные изменения не позволяют синхронизироваться",
				"no-permission": "У вас нет прав для синхронизации с этим каталогом",
				"at-revision":
					"Синхронизация и публикация в истории изменений недоступны — вернитесь к текущей версии.",
			},
		},
		checkout: {
			"enable-transfer-tooltip": "Сначала опубликуйте или отмените локальные изменения либо включите их перенос",
			"transfer-changes": "Переносить изменения между ветками",
			"do-not-show-dialog-again": "Больше не показывать это окно",
			"mode-description": "Настроить поведение при смене веток можно в меню «…» окна веток.",
			"transfer-title": "Перенести изменения в {{branch}}?",
			"transfer-description":
				"У вас есть неопубликованные изменения в ветке {{from}}. Они будут перенесены в ветку {{to}} и останутся неопубликованными.",
			transfer: "Перенести",
			"remember-choice-hint": "Запомним выбор. Изменить его можно в меню «…» окна веток.",
			"blocked-title": "Нельзя сменить ветку",
			"blocked-description":
				"У вас есть неопубликованные изменения в ветке {{branch}}. Опубликуйте или отмените изменения и попробуйте сменить ветку.",
			"change-branch": "Сменить ветку",
			conflict:
				"В текущей ветке есть неопубликованные изменения, которые конфликтуют с изменениями в другой ветке. Опубликуйте или отмените их.",

			error: {
				"local-changes-present": "Ваши локальные изменения не позволяют поменять ветку",
				conflict: "Не удалось сменить ветку",
				"conflict-diagnosis":
					"В текущей ветке есть неопубликованные изменения. Ваши изменения сохранены локально.",
				"conflict-recipe": "Опубликуйте или отмените изменения, затем повторите смену ветки.",
			},
		},
		branch: {
			management: "Управление ветками",
			current: "Текущая ветка",
			actual: "Актуальная ветка",
			create: "Создать ветку",
			actions: "Действия с веткой",
			error: {
				"deleting-head-branch":
					"Вы пытаетесь удалить ветку, на которой находитесь. Переключите её и попробуйте ещё раз",
				"cannot-delete-protected": `Ветка <code>{{branch}}</code> защищена от удаления. Снимите флаг с пункта "Удалить ветку <code>{{branch}}</code> после слияния" и попробуйте еще раз.`,
				"cannot-delete":
					"Не удалось завершить удаление опубликованной ветки <code>{{branch}}</code>. Перезагрузите страницу и попробуйте еще раз",
				"not-found": {
					local: "Не удалось определить текущую ветку",
					remote: "Не удалось найти удалённую ветку для локальной ветки <code>{{branch}}</code>",
					default: "Не удалось найти ветку по умолчанию для переключения",
				},
				"checked-out-elsewhere":
					"Эта ветка уже открыта в другой копии репозитория. Переключите ту копию на другую ветку или выберите здесь другую",
				"not-found-reload": "Не удалось определить текущую ветку. Обновите страницу.",
				"already-exist": "Не удалось создать новую ветку. Ветка <code>{{branch}}</code> уже существует",
				"has-been-deleted": {
					title: "Ветка была удалена",
					body: "Ветка, на которой находился каталог, была удалена. Вы будете переключены на основную ветку каталога.",
				},
			},
			delete: {
				confirm: {
					title: "Удалить ветку?",
					description:
						"<p>Ветка <code>{{branch}}</code> и все ее содержимое удалится из приложения и из Git-хранилища.</p><p>Восстановить ее не получится</p>",
				},
			},
		},
		merge: {
			title: "Слияние веток",
			"instant-merge": "Слить",
			merge: "Слить",
			"add-user": "Добавить пользователя",
			branches: "Слить ветки",
			"after-merge": "После слияния",
			"current-branch": "Слить текущую ветку",
			"delete-branch-after-merge": "Удалить ветку после слияния",
			squash: "Объединить коммиты",
			"squash-tooltip": "После слияния, изменения из текущей ветки будут объединены в один коммит",
			conflict: {
				conflicts: "Конфликты",
				"abort-confirm": {
					title: {
						sync: "Отменить синхронизацию?",
						branch: "Отменить слияние веток?",
					},
					body: {
						sync: "При синхронизации возник конфликт. Для завершения синхронизации нужно его решить. Если это не сделать, каталог вернется в предыдущее состояние.",
						branch: "При слиянии веток возник конфликт. Для завершения слияния нужно его решить. Если это не сделать, слияние отменится.",
						"impossible-conflict":
							"При слиянии веток возник конфликт. Перезагрузите страницу и решите конфликт.",
					},
					"action-button": {
						sync: "Отменить синхронизацию",
						branch: "Отменить слияние",
					},
					"cancel-button": "Решить конфликт",
				},
				"current-change": "Текущее изменение",
				"incoming-change": "Входящее изменение",
				"accept-current-change": "Оставить текущее изменение",
				"accept-incoming-change": "Выбрать входящее изменение",
				"accept-both": "Выбрать оба изменения",
				"delete-in-current": "Файл был удален в текущем изменении, но изменен во входящем",
				"delete-in-incoming": "Файл был изменен в текущем изменении, но удален во входящем",
				"default-with-deletion-text": "Файл был удален или добавлен в текущем или входящем изменении",
				leave: "Оставить",
				"added-by-them": "У вас нет файла, который был добавлен или переименован во входящем изменении",
				"added-by-us": "Вы добавили или переименовали файл, которого нет во входящем изменении",
				"deleted-by-them": "Вы изменили файл, который удален или переименован во входящем изменении",
				"deleted-by-us": "Вы удалили или переименовали файл, который изменен во входящем изменении",
				resolver: {
					title: "Решить конфликт",
					description: "Выберите файлы и разрешите конфликты слияния",
				},
			},
			confirm: {
				sync: "У вас есть неопубликованные изменения, которые конфликтуют с изменениями в актуальном состоянии ветки. Решите конфликт перед синхронизацией.",
				branch: "Изменения в ветках конфликтуют. Решите конфликт перед слиянием.",
				"catalog-conflict-state":
					"Ваш каталог находится в состоянии конфликта. Решите конфликт прежде чем продолжить редактирование.",
				"catalog-conflict-state-with-checkout":
					"<p>Ссылка ведет на ветку <code>{{branchToCheckout}}</code>, но ваш каталог находится в состоянии конфликта. Решите конфликт прежде чем продолжить редактирование.</p>",
			},
			error: {
				generic: "Не удалось слить ветки",
				"workdir-not-empty": {
					title: "У вас есть локальные изменения",
					body: "Опубликуйте или отмените локальные изменения. После этого объедините ветки.",
				},
				"not-supported": "Ошибка при слиянии. Мы пока не умеем решать такие конфликты",
				"conflict-occured": "Не удалось автоматически решить конфликт слияния",
				"conflicts-not-found": "Не удалось получить конфликтующие файлы",
				branches: "Не удалось слить ветки",
				sync: "Не удалось синхронизировать каталог",
				"catalog-conflict-state": "Решите конфликт",
				"merge-request-exists": "Запрос на слияние по этой ветке уже создан",
				"merge-request-instant-merge": "По этой ветке уже есть запрос на слияние — слияние идет через него",
			},
		},
		publish: {
			"empty-state": {
				title: "Нет изменений",
				description: "Здесь появятся изменённые файлы, как только вы начнёте редактировать",
			},
			name: "Публикация",
			"to-publish": "Опубликовать",
			"comment-one-file": "Обновлён файл: {{path}}",
			"comment-files": "Обновлено файлов: {{count}}",
			error: {
				"non-fast-forward": {
					title: "Устаревшая версия каталога",
					body: "Синхронизируйте каталог, чтобы получить изменения коллег. После этого опубликуйте свои изменения.",
				},
				unknown: "Неизвестная ошибка при публикации. Сообщение ошибки -",
				protected: "Ветка защищена от публикации",
				"protected-branch": "Защищенная ветка",
				"protected-branch-description":
					"Прямая публикация в защищённую ветку запрещена. Чтобы внести изменения, создайте новую ветку и выполните слияние или создайте запрос на слияние.",
				"direct-publish-forbidden": "Прямая публикация запрещена.",
				"create-branch-and-merge": "Создайте новую ветку и выполните слияние",
				"resolve-conflicts": "Решить конфликтующие изменения",
				"has-conflicts-description": "Опубликовать не получится. Сначала нужно решить конфликтующие изменения.",
				declined: {
					title: "Хранилище отклонило публикацию",
					body: "Хранилище отклонило публикацию согласно своим внутренним правилам. Ваши изменения остались локально. Устраните причину или обратитесь к администратору хранилища, затем опубликуйте снова.",
					"remote-message": "Сообщение хранилища:",
					"no-reason": "Хранилище не сообщило причину. Обратитесь к его администратору.",
				},
				"no-permission": "У вас нет прав для публикации в этот каталог",
				"permissions-unavailable": "Не удалось проверить права доступа. Попробуйте ещё раз.",
				"main-branch": "Публикация в эту ветку запрещена",
				"at-revision": "Публикация в истории изменений недоступна — вернитесь к текущей версии.",
			},
		},
		history: {
			"empty-state": { title: "История пуста", description: "Здесь появятся изменения\nпосле первой публикации" },
			modal: {
				title: "История изменений",
				description: "Просмотрите историю изменений статьи",
			},
			filters: {
				title: "Фильтр",
				reset: "Сбросить всё",
				cancel: "Отмена",
				apply: "Применить",
				"all-authors": "все авторы",
				date: {
					title: "Период",
					today: "Сегодня",
					"7-days": "7 дней",
					"30-days": "30 дней",
					"all-time": "Всё время",
				},
				authors: { title: "Автор", placeholder: "Поиск автора..." },
				articles: { title: "Статьи" },
			},
			revisions: {
				title: "Сравнение ревизий",
				reset: "Сбросить",
				"pick-a-commit": "Выберите коммит",
				combined: "Суммарно",
				hint1: "Выберите два коммита из списка",
				hint2: "чтобы увидеть изменения между ними",
			},
			button: "Показать историю",
			name: "История",
			error: {
				empty: "Не удалось найти историю файла",
				"not-found": "Не удалось найти историю файла",
				"need-to-publish": "История изменений станет доступна после публикации статьи",
			},
		},
		revisions: {
			"go-to-revision": "Перейти к ревизии",
			"compare-title-catalog": "Просмотр изменений",
			"compare-title-article": "История статьи",
			"compare-button": "Просмотр изменений",
			"open-catalog-compare": "Открыть каталог на сравнение",
			"choose-placeholder": "Выберите ревизию...",
			"n-more": ", ещё {count}",
		},
		discard: {
			"select-all-arrow-tooltip": "Откатить выбранные изменения",
			"selected-file-arrow-tooltip": "Откатить изменения",
			"paragraph-tooltip": "Откатить изменения",
			alert: {
				title: "Откатить выбранные изменения?",
				body: "Статьи вернутся к прошлой версии. Новые файлы и изображения будут удалены.",
				buttons: {
					primary: "Откатить {count}",
					secondary: "Отмена",
				},
			},
		},
		"lfs-migration": {
			alert: {
				title: "Нужно перенести файлы в новое хранилище",
				body: "В этом каталоге изменились правила хранения больших файлов. Gramax один раз перенесёт их автоматически — ваши правки и тексты не пострадают.",
				affected: "Файлов к переносу: {count} · объём: {size}",
				"details-trigger": "Технические детали",
				"details-lead": "Изменится {file}: ",
				"details-added": "в LFS добавлены",
				"details-removed": "из LFS исключены",
				"details-directions":
					"Перенос идёт в обе стороны: новые маски заливаются в LFS, исключённые — скачиваются и возвращаются в git. Миграция записывается отдельным служебным коммитом и не попадёт в ваши изменения.",
				migrate: "Перенести файлы",
				later: "Напомнить позже",
				migrating: "Переносим файлы в хранилище…",
				footnote: "Если отложить, окно появится при следующей синхронизации",
			},
		},
		"lfs-auto-attachments": {
			alert: {
				title: "Перенести вложения в Git LFS?",
				body: "Все вложения статей этого каталога будут перенесены в Git LFS. Перенос запишется отдельным служебным коммитом — ваши правки и тексты не пострадают.",
				affected: "Файлов к переносу: {count} · объём: {size}",
				"details-trigger": "Технические детали",
				"details-lead": "Изменится {file}: ",
				"details-added": "в LFS добавлены",
				migrate: "Перенести файлы",
				cancel: "Отмена",
				migrating: "Переносим файлы в хранилище…",
			},
		},
		warning: {
			"no-changes": {
				title: "Нет изменений",
				body: "В текущем каталоге нет изменений для публикации.",
			},
		},
		error: {
			"not-found": {
				branch: "Не удалось найти ветку <code>{{what}}</code>",
				"remote-branch": "Не удалось найти удалённую ветку <code>{{what}}</code>",
				blob: "Не удалось найти файл <code>{{path}}</code>",
				repo: {
					title: "Репозиторий не найден",
					message: `Не удалось найти репозиторий <a href='{{url}}' ${getExecutingEnvironment() === "tauri" ? "" : "target='_blank'"} rel='noreferrer'>{{name}}</a> в Git-хранилище. Возможно он был удален, перемещен или у вас недостаточно прав для работы с ним`,
				},
				"local-repo": {
					title: "Репозиторий не найден",
					message:
						"В папке каталога нет Git-репозитория. Возможно, папка <code>.git</code> была удалена или перемещена. Загрузите каталог из хранилища заново или подключите его к хранилищу.",
				},
				generic: "Код ошибки - NotFoundError. Сообщение ошибки - ",
			},
			broken: {
				tooltip: "Репозиторий возможно повреждён",
				healthcheck: {
					title: "Репозиторий возможно повреждён",
					body: "Работа с каталогом может быть нестабильной",
					body2: "Рекомендуем сохранить изменения и восстановить репозиторий",
					"download-zip": "Сохранить ZIP",
					recover: {
						button: "Восстановить",
						confirm: {
							title: "Восстановление",
							description:
								"Восстановление приведёт к потере всех локальных веток, однако ваши изменения в рабочей директории будут сохранены",
						},
					},
					ignore: {
						button: "Игнорировать",
						confirm: {
							title: "Игнорирование ошибки",
							description: "Игнорирование ошибки может привести к неопределённому поведению",
						},
					},
					"technical-details": "подробнее",
				},
				"clone-failed": {
					title: "Не удалось загрузить каталог",
					body: "При загрузке каталога возникла непредвиденная ошибка. Вы можете попробовать загрузить его повторно или удалить",
					"technical-details": "Подробнее",
					clone: {
						button: "Загрузить",
						title: "Загрузить каталог",
						description: "Вы уверены, что хотите загрузить каталог?",
					},
					delete: {
						button: "Удалить",
						title: "Удаление каталог",
						description:
							"Вы уверены, что хотите удалить каталог? Вы сможете заново загрузить его из хранилища",
					},
				},
			},
			"content-too-large": {
				title: "Слишком много изменений",
				message: `Вы пытаетесь опубликовать файл большого размера или слишком много изменений за раз. Попробуйте опубликовать изменения по частям`,
			},
			"disk-full": {
				title: "Недостаточно места на диске",
				message:
					"На диске недостаточно свободного места для выполнения операции. Освободите место и попробуйте ещё раз.",
			},
			"network-timeout": {
				title: "Сервер не ответил вовремя",
				message:
					"Сервер Git-хранилища больше минуты не передавал данные, поэтому Gramax прервал операцию. Попробуйте ещё раз. Если ошибка повторяется, сервер может быть перегружен или соединение задерживает ваша сеть — например, корпоративный прокси или VPN. С правами доступа и токеном это не связано.",
			},
			network: {
				title: "Не удалось подключиться к серверу",
				message:
					"Для публикации, синхронизации, смены ветки и других операций нужен доступ к серверу Git-хранилища. Проверьте соединение и попробуйте ещё раз. Если проблема сохраняется, сервер может быть временно недоступен или соединение с ним блокирует ваша сеть — например, корпоративный прокси или VPN. С правами доступа и токеном это не связано.",
			},
			http: {
				title: "Ошибка при запросе к Git-хранилищу",
				message: "Произошла непредвиденная ошибка при обращении к хранилищу Git-репозитория",
			},
			checkout: {
				"invalid-path": {
					title: "Недопустимое имя файла для Windows",
					message:
						'Не удалось выполнить операцию: имя файла содержит символы, недопустимые в Windows (например, кавычки ", *, ?, <, >, :, |). Переименуйте файл через Linux/macOS или веб-интерфейс GitLab и повторите попытку.\n\nФайл: {{path}}',
					"message-generic":
						'Не удалось выполнить операцию: один из файлов имеет имя, недопустимое в Windows (например, содержит кавычки ", *, ?, <, >, :, |, или слишком длинный путь). Переименуйте файл через Linux/macOS или веб-интерфейс GitLab и повторите попытку.',
				},
			},
		},
		"merge-requests": {
			"empty-state": {
				title: "Нет запроса на слияние",
				description: "Создайте запрос из списка веток, чтобы он здесь появился",
			},
			"branch-tab-tooltip": "В этой ветке есть запрос на объединение",
			"branch-tab-badge": "Запрос",
			diff: "Изменения",
			"advanced-mode": "Расширенный режим",
			"advanced-mode-description": "Детальная информация о добавленных/удалённых строках и ресурсах статей",
			create: "Создать запрос слияния",
			approvedCountTooltip: "Утверждено {{approvedCount}} из {{approvedTotal}}",
			changes: "Изменения",
			back: "Назад",
			"create-request": "Создать запрос",
			by: "От",
			into: "в",
			you: "Вы",
			name: "Запрос слияния",
			approvers: "Утверждающие",
			approvers2: "утверждающих",
			"no-approvers": "Нет утверждающих",
			"approved-of": "Утверждено",
			of: "из",
			approval: {
				approved: "Утверждено",
				unapproved: "Ожидает утверждения",
				"publish-tooltip": "Подтверждение сохранится только после публикации изменений",
			},
			status: {
				draft: "Черновик",
				"draft-tooltip": "Запрос слияния ожидает публикации",
				"in-progress": "Ревью",
				"in-progress-tooltip": "Ожидает проверки и утверждения",
				approved: "Утверждено",
				"approved-tooltip": "Утверждено и готово к слиянию",
			},
			"disable-button-reason": {
				"has-conflicts": "Сначала разрешите конфликты",
				draft: "Запрос ожидает публикации: опубликуйте изменения, чтобы слить",
				"not-approved": "Не все утверждающие подтвердили запрос",
				"not-author": "Слить может только автор запроса",
			},
			"delete-confirm": {
				title: "Удалить запрос слияния?",
				body: "Запрос на слияние будет удален для всех пользователей после публикации изменений",
			},
			confirm: {
				title: "Слить ветки?",
				body: {
					"delete-branch-after-merge":
						"<p>Изменения из ветки <code>{{sourceBranch}}</code> попадут в ветку <code>{{targetBranch}}</code>, а ветка <code>{{sourceBranch}}</code> удалится. Отменить это действие не получится.</p>",
					"not-delete-branch-after-merge":
						"<p>Изменения из ветки <code>{{sourceBranch}}</code> попадут в ветку <code>{{targetBranch}}</code>. Отменить это действие не получится.</p>",
					"squash-comment":
						"<p>Изменения из ветки <code>{{sourceBranch}}</code> будут объединены в один коммит и попадут в ветку <code>{{targetBranch}}</code>. Отменить это действие не получится.</p>",
					"squash-delete-branch-comment":
						"<p>Изменения из ветки <code>{{sourceBranch}}</code> будут объединены в один коммит и попадут в ветку <code>{{targetBranch}}</code>, а ветка <code>{{sourceBranch}}</code> удалится. Отменить это действие не получится.</p>",
				},
			},
			warning: {
				"no-changes": {
					title: "Нет изменений",
					body: "В ветках нет изменений для слияния",
				},
			},
			error: {
				"merge-with-conflicts": {
					title: "Не удалось слить ветки",
					body: "<p>В ветках есть конфликт изменений. Слейте изменения из ветки <code>{{targetBranch}}</code> в ветку <code>{{sourceBranch}}</code>. Затем решите конфликт.</p>",
				},
			},
		},
		"connect-source": {
			error: {
				"unable-to-connect": "Не удалось подключиться к git-серверу",
			},
		},
		lfs: {
			"file-is-pointer-2": "Файл хранится в Git LFS и ещё не загружен, попробуйте синхронизировать каталог",
			"file-is-pointer": "Этот файл хранится в Git LFS и ещё не загружен. Попробуйте синхронизировать каталог",
		},
	},
	confluence: {
		blogs: "Блоги",
		"link-board": "Ссылка на доску",
		error: {
			"ext-not-supported": "Расширение не поддерживается:",
			http: "Ошибка HTTP:",
			"couldnt-find-file": "Не удалось найти имя файла:",
			"couldnt-find-fileId": "Не удалось найти вложение с fileId:",
			"http-2": "Ошибка HTTP при загрузке файла:",
		},
	},
	import: {
		modal: {
			title: "Импортировать каталог",
			description: "Выберите источник для импорта",
			load: "Импорт",
			"add-new-source": "Добавить новый источник",
			props: {
				source: {
					name: "Источник",
					placeholder: "Выберите источник",
				},
			},
		},
		error: {
			"page-conversion": "Ошибка конвертации страницы",
			"ext-not-supported": "Расширение не поддерживается:",
			"source-required": "Источник является обязательным",
			"space-required": "Пространство является обязательным",
			"cannot-import": {
				title: "Не удалось импортировать элемент из ",
				desc: "Вы можете перенести его вручную со страницы",
			},
		},
	},
	diff: {
		modes: "Режимы отображения",
		"source-text": "Исходный текст",
		"file-too-large-for-preview": "Файл превышает 1 МБ и не может быть отображён",
		"unknown-extension": "Превью не поддерживается для данного типа файла",
		deleted: {
			column: "Удаленный столбец",
			tab: "Вкладка удалена",
			fragment: "Фрагмент",
		},
		type: {
			added: "Добавлено",
			modified: "Изменено",
			deleted: "Удалено",
			removed: "Удалено (в превью старой версии)",
			breadcrumb: "Статья перемещена",
		},
		moved: {
			"from-title": "Перемещено · уехал отсюда {direction}",
			"to-title": "Перемещено · приехал сюда {direction}",
			"from-body": "Здесь стоял блок «{preview}».",
			"to-body": "Блок переехал с прежнего места; внутри — обычный дифф правок.",
			"from-hint": "Кликните — перейти к новому месту",
			"to-hint": "Кликните — к прежнему месту",
			"from-direction-up": "вверх",
			"from-direction-down": "вниз",
			"to-direction-up": "снизу",
			"to-direction-down": "сверху",
		},
		live: {
			"baseline-error": "Не удалось загрузить старую версию статьи, сравнение не выполнено",
		},
		"only-changes": {
			panel: "Навигация по изменениям",
			title: "Изменения в статье",
			previous: "Предыдущее изменение",
			next: "Следующее изменение",
			collapse: "Только изменения: схлопнуть абзацы без правок",
			expand: "Показать всю статью",
			unchanged: "без изменений:",
			collapsed: "Свернуто",
			"blocks-one": "блок",
			"blocks-few": "блока",
			"blocks-many": "блоков",
		},
		link: {
			changed: "Адрес ссылки изменен",
			was: "Было",
			now: "Стало",
		},
		inline: {
			was: "Было",
			deleted: "Удаленный текст",
		},
		attrs: {
			title: "Изменились атрибуты",
			link: "ссылка «{text}»",
			"link-plain": "ссылка",
			"code-language": "язык кода",
			"not-set": "не задан",
			image: "картинка",
			heading: "заголовок",
			level: "уровень {level}",
			"links-removed": "Ссылок не стало",
			"links-added": "Ссылок появилось",
		},
		"previous-version": "Предыдущая версия",
		"previous-version-unavailable": "Предыдущая версия не отрисовалась",
		discard: "Откатить",
	},
	"unsupported-elements": {
		confluence: {
			title: "Некоторые элементы не перенесутся",
			description:
				"Gramax не поддерживает специфичные элементы из Confluence. Например: задачи из Jira, графики, отчёты. Данные из них вы можете перенести вручную.",
			noteTitle: "Список страниц с неподдерживаемыми элементами",
		},
		notion: {
			title: "Некоторые элементы не перенесутся",
			description:
				"Gramax не поддерживает специфичные элементы из Notion. Например: кнопки, содержание. Данные из них вы можете перенести вручную.",
			noteTitle: "Список страниц с неподдерживаемыми элементами",
			"region-restricted": {
				title: "Доступ ограничен",
				message:
					"К сожалению, ваш запрос не может быть выполнен, так как доступ в Notion ограничен для вашего региона.",
			},
		},
		default: {
			title: "Некоторые элементы не перенесутся",
			description:
				"Gramax не поддерживает некоторые элементы из источника данных. Данные из них вы можете перенести вручную.",
			noteTitle: "Список неподдерживаемых элементов",
		},
	},

	alert: {
		details: "Детали",
		image: {
			unavailable: "Не удалось отобразить изображение",
			path: "Проверьте, что оно существует и путь указан верно.",
		},
		gif: {
			unavailable: "Не удалось отобразить Gif",
		},
		video: {
			unavailable: "Не удалось отобразить видео",
			path: "Проверьте, что видео по ссылке существует и доступно для всех в интернете.",
		},
	},
	editor: {
		"at-revision": "Редактирование в истории изменений недоступно — вернитесь к текущей версии.",
		diff: "Просмотр изменений",
		ai: {
			improve: "Улучшить текст",
			generate: "Сгенерировать",
			transcribe: "Транскрипция речи в текст",
			discuss: "Обсудить в чате",
		},
		float: {
			name: "Выравнивание",
			left: "По левому краю",
			center: "По центру",
			right: "По правому краю",
		},
		italic: "Курсив",
		bold: "Жирный",
		stroke: "Зачёркнутый",
		code: "Строка кода",
		property: "Переменная",
		question: {
			name: "Блок вопроса",
			placeholder: "Заголовок вопроса",
			required: "Обязательный вопрос",
			types: {
				name: "Тип вопроса",
				one: "Один ответ",
				many: "Несколько ответов",
				text: "Свободный ответ",
			},
			answer: {
				add: "Добавить ответ",
				placeholder: "Ответ на вопрос",
				check: "Проверить",
				checking: "Проверяется...",
				"check-failed": "Не удалось проверить ответы",
			},
		},
		"code-block": "Блок кода",
		lists: "Списки",
		"bullet-list": "Маркированый",
		"ordered-list": "Нумерованный",
		"task-list": "Задачи",
		modes: {
			view: "Вид",
			tabs: {
				article: "Эта статья",
				catalog: "Весь каталог",
			},
			"mark-as-read": "Отметить все прочитанными",
			comments: "Ревью комментариев",
			"empty-state": {
				title: "Комментариев пока нет",
				description: "Выделите текст в статье, чтобы оставить первый комментарий",
			},
			counter: {
				unread: "Непрочитано",
				total: "Всего",
			},
			"search-placeholder": "Поиск по комментариям...",
			"source-text": "Исходный текст",
			"type-filter": {
				all: "Все",
				comments: "Комментарии",
				changes: "Изменения",
				unread: "Непрочитанные",
			},
			sorting: {
				title: "Сортировка",
				order: "Порядок",
				none: "Без сортировки",
				newest: "Сначала новые",
				oldest: "Сначала старые",
			},
			grouping: {
				title: "Группировка",
				none: "Без группировки",
				article: "По статье",
				date: "По дате",
			},
			filters: {
				title: "Фильтры",
				reset: "Сбросить все",
				"all-authors": "все авторы",
				date: {
					title: "Период",
					presets: {
						today: "Сегодня",
						"7-days": "7 дней",
						"30-days": "30 дней",
						"all-time": "Всё время",
					},
				},
				authors: { title: "Автор", placeholder: "Поиск автора..." },
			},
		},
		highlight: {
			name: "Выделение заднего фона",
			colors: {
				yellow: "Жёлтый",
				green: "Зелёный",
				purple: "Фиолетовый",
				blue: "Синий",
				orange: "Оранжевый",
				red: "Красный",
			},
		},
		note: "Заметка",
		notes: "Примечания",
		heading: "Заголовок",
		attachments: "Вложения",
		tools: "Инструменты",
		"keys-and-passwords": {
			name: "Ключи и пароли",
			empty: "Пока нет ключей и паролей",
			fields: {
				login: "Логин",
				password: "Пароль",
				token: "Токен",
				url: "URL",
			},
		},
		templates: {
			"inline-property": "Поле свойства",
			"block-field": "Блочное поле ввода",
		},

		link: {
			"other-catalogs": "Другие каталоги",
			"current-catalog": "Текущий каталог",
			catalogs: "Каталоги",
		},

		table: {
			name: "Таблица",
			row: {
				title: "Строка заголовка",
				"add-up": "Вставить строку сверху",
				"add-down": "Вставить строку снизу",
				"add-left": "Вставить столбец слева",
				"add-right": "Вставить столбец справа",
				delete: "Удалить всю строку",
			},
			column: {
				title: "Столбец заголовка",
				delete: "Удалить весь столбец",
			},
			width: {
				"reset-column": "Сбросить ширину",
				"reset-all": "Сбросить ширину всех столбцов",
			},
			align: {
				name: "Выравнивание",
				left: "По левому краю",
				center: "По центру",
				right: "По правому краю",
			},
			"join-cells": {
				action: "Объединить ячейки",
				sorted: "Объединение ячеек недоступно при сортировке",
			},
			"split-cells": "Разделить ячейки",
			aggregation: {
				name: "Агрегация",
				methods: {
					sum: { name: "SUM", tooltip: "" },
					avg: { name: "AVG", tooltip: "" },
					min: { name: "MIN", tooltip: "" },
					max: { name: "MAX", tooltip: "" },
					count: { name: "COUNT", tooltip: "Количество значений в столбце." },
					countDistinct: {
						name: "DISTINCT COUNT",
						tooltip: "Количество уникальных значений в столбце.",
					},
				},
			},
			sort: {
				asc: "По возрастанию",
				desc: "По убыванию",
				"not-available": "Сортировка недоступна из-за объединённых ячеек",
			},
			save: "Сохранить выбранные фильтры и сортировку",
		},

		gallery: {
			name: "Галерея",
			view: "Вид",
			caption: "Подпись галереи",
			add: "Добавить изображения",
			ungroup: "Разгруппировать",
			wrap: "Превратить в галерею",
			"drop-insert": "Добавить в галерею",
			"drop-merge": "Объединить в галерею",
			mosaic: "Мозаика",
			carousel: "Карусель",
			previous: "Назад",
			next: "Вперёд",
		},

		tabs: {
			name: "Вкладка",
			add: "Добавить новую вкладку",
			delete: "Удалить вкладку",
			"delete-last": "Вы удаляете последнюю вкладку. Удалить весь элемент?",
			"empty-placeholder": "Содержимое вкладки",
		},

		video: {
			name: "Видео",
			link: "Ссылка на видео",
			"link-description": "Вставьте ссылку на YouTube, Rutube или прямую ссылку на видеофайл.",
			"will-be-here": "Тут будет ваше видео",
			"not-available": "Видео недоступной",
			error: {
				none: "В дополнительной панели укажите ссылку на него и добавьте подпись.",
				"none-2": "Поддерживаемые сервисы: YouTube, Google Drive, Rutube ",
				"none-2-link": "и другие",
				some: "Проверьте наличие видео в файловом хранилище по",
				"some-link": " ссылке",
				"some-2": "Убедитесь, что в хранилище для ссылки/видео нет ограничений к доступу на просмотр.",
				generic: "Проверьте, правильно ли указано название файла.",
				"generic-2":
					"Убедитесь, что видео есть в соответствующей папке в SharePoint. Куда нужно поместить файл читайте",
				"generic-2-link": " здесь",
			},
		},
	},
	"bug-report": {
		name: "Сообщить об ошибке",
		"what-happened": "Что произошло",
		"what-will-be-sent": "Что отправится?",
		describe: "Опишите проблему",
		"attach-tech-details": "Поделиться деталями",
		"this-will-help-us":
			"Эта информация поможет нам оперативнее решить ошибку. Мы не увидим контент или личные данные. ",
		"tech-details": "Технические детали",
		"tech-details-description": "Перечисленные ниже данные будут отправлены вместе с отчетом об ошибке.",
		modal: {
			title: "Сообщите об ошибке",
			description: "Отправьте отчет об ошибке, чтобы мы могли ее исправить.",
		},
		error: {
			"cannot-send-feedback": {
				title: "Не удалось отправить отчет об ошибке",
				message: "Возможно, у вас включен блокировщик рекламы. Отключите его и попробуйте еще раз.",
			},
		},
	},

	word: {
		"table-of-contents": "Оглавление",
		"error-rendering": "Ошибка: не удалось отрисовать ",
		diagram: "диаграмму",
		picture: "картинку",
		tabledb: "таблицу БД",
		fragment: "фрагмент",
		video: "Видео",
		error: {
			"export-type-error": "Ошибка, такого типа экспорта нет: ",
			"canvas-to-blob-error": "Не удалось конвертировать canvas в Blob.",
			"canvas-error": "Не удалось получить контекст canvas.",
			"load-image-error": "Не удалось загрузить изображение.",
			"file-not-found-error": "Файл не найден по указанному пути.",
			"wrong-object-type": "Ошибка, такого типа объекта нет.",
			"divide-by-zero-error": "Ошибка деления на ноль.",
			"delete-failed-error": "Не удалось удалить файл",
		},
		template: {
			templates: "Шаблоны",
			"no-template": "Без шаблона",
			error: {
				"template-not-found": "Шаблон не найден",
				"processing-error": "Ошибка при обработке шаблона",
			},
		},
	},
	pdf: {
		"component-parsing-failed": "Не удалось обработать компонент",
		"kanban-view-export-error": "Представление в режиме Доска будет выгружено в режиме Список",
	},
	enterprise: {
		"user-not-found":
			"Эта почта не подключена к Gramax Enterprise Server. Вы можете продолжить работу в бесплатной версии приложения или обратиться к вашему администратору за помощью.",
		"workspace-exit-warning-1": "Рабочее пространство будет закрыто для текущей сессии.",
		"workspace-exit-warning-2": "Каталоги сохранятся и снова будут доступны после входа.",
		"workspace-exit": "Выйти из рабочего пространства",
		"config-error": "Проблемы с настройками. Обратитесь к администратору.",
		"workspace-exists":
			"Пространство с таким именем уже существует. Вы можете перейти в это пространство или задать другое имя",
		"workspace-exists-title": "Уже существует",
		"token-exchange-failed": "Не удалось получить токен по одноразовому коду.",
		"init-repo": {
			error: "Ошибка при создании репозитория",
			forbidden: "Недостаточно прав для создания репозитория",
			"already-exists": "Репозиторий с таким названием уже существует",
		},
		"delete-resource": {
			error: "Не удалось удалить каталог из пространства",
			forbidden: "Недостаточно прав для удаления каталога из пространства",
		},
		"add-reviews": {
			forbidden: "Недостаточно прав для добавления рецензентов",
			"not-found": "Не удалось найти ресурс",
			"failed-to-add-title": "Не удалось добавить рецензентов",
			"failed-to-add-message": "Обратитесь к администратору, чтобы добавить рецензентов вручную.",
		},
		"edit-workspace": {
			"cant-edit": "Изменить корпоративное пространство может только владелец пространства",
			"error-get-edit-info": "Не удалось получить информацию о корпоративном пространстве",
		},
		logout: {
			error: "Ошибка соединения",
			"error-message":
				"Не удалось выйти. Нет соединения с сервером <code>{url}</code>.<p>Проверьте подключение к сети и повторите попытку.</p>",
		},
		admin: {
			"settings-title": "Настройки пространства",
			"hide-sidebar": "Скрыть боковую панель",
			"show-sidebar": "Показать боковую панель",
			accesses: "Доступы",
			"adding-accesses": "Добавление доступов",
			mixed: "Смешано",
			selected: "Выбрано",
			saving: "Сохранение...",
			"search-error": "Ошибка поиска",
			cancel: "Отмена",
			all: "Все",
			unavailable: "Недоступно",
			tests: "Тесты",
			result: "Результат",
			passed: "Пройден",
			failed: "Не пройден",
			search: "Поиск...",
			"edit-all-hint": "Выберите минимум 2",
			"loading-more": "Загрузка...",
			"not-available-in-bulk": "Недоступно при массовом редактировании",
			retry: "Повторить",
			coverage: {
				title: "Охват",
				"add-to-all": "Применить ко всем",
				"included-in": "Присутствует в:",
			},
			forbidden: {
				title: "Доступ запрещен",
				description: "У вас нет доступа к этой странице",
			},
			errors: {
				"operation-error": "Ошибка операции",
				"loading-settings": "Проблема при загрузке настроек",
				"database-unavailable": "База данных недоступна",
				"save-error": "Не удалось сохранить изменения",
				"email-required": "Укажите email",
				"email-invalid": "Неверный формат email",
				"no-connection": "Нет соединения",
				causes: {
					offline: "Ошибка соединения",
					unknown: "Что-то пошло не так",
					"workspace-editor-required": "Недопустимая роль",
				},
				descriptions: {
					offline:
						"Нет соединения с сервером <code>{url}</code>.<p>Проверьте подключение к сети и повторите попытку.</p>",
					unknown: "Перезагрузите страницу и повторите попытку.",
					"workspace-editor-required":
						"Роли Редактора и Владельца каталога доступны только редакторам пространства. Перезагрузите страницу и проверьте роли.",
				},
			},
			logout: {
				error: "Не удалось завершить сессию. Статус:",
			},
			pages: {
				plugins: "Модули",
				pluginDetail: "Детали модуля",
				check: "Стайлгайд",
				workspace: "Пространство",
				groups: "Группы пользователей",
				editors: "Редакторы",
				members: "Участники",
				users: "Пользователи",
				resources: "Каталоги",
				mail: "Почтовый сервер",
				guests: "Внешние читатели",
				quiz: "Обучение",
				modules: "Модули",
				metrics: "Метрики",
				viewMetrics: "История посещений",
				searchMetrics: "Поисковые запросы",
				accessTokens: "Токены доступа",
				license: "Лицензия",
			},
			license: {
				status: "Статус",
				active: "Лицензия действует",
				invalid: "Лицензия недействительна",
				"expiration-date": "Действует до",
				"editor-limit": "Доступно лицензий редактора",
				"occupied-editors": "Используется лицензий",
				unlimited: "Без ограничений",
				perpetual: "Бессрочно",
				"not-specified": "Не указано",
			},
			users: {
				user: "Пользователь",
				users: "Пользователи",
				editor: "Редактор",
				editors: "Редакторы",
				"editor-slots-full": "Нет свободных лицензий",
				"editor-slots-used": "занято",
				"users-not-found": "Пользователи не найдены",
				add: "Добавить пользователя",
				adding: "Создание пользователя",
				editing: "Редактирование пользователя",
				"editing-many": "Редактирование пользователей",
				"adding-many": "Добавление пользователей",
				"editor-hint":
					"Позволяет пользователю войти в приложение для редактирования Gramax. Использует лицензию.",
				"user-only-role-hint": "Эту роль можно выдать только пользователям",
				"owner-requires-editor-hint": "Можно выдать только с лицензией Редактора",
				"workspace-editor-only-hint": "Доступно только редакторам пространства",
				"editor-revoke": {
					title: "Пользователь перестанет быть редактором",
					description: "В этих каталогах пользователь будет понижен до Читателя:",
					confirm: "Понизить",
					"catalog-column": "Каталог",
					"role-column": "Текущая роль",
				},
				find: "Найти по email или имени...",
				"find-by-email": "Найти по email...",
				"email-placeholder": "Введите email",
				"use-search-for-sso":
					"В списке отображаются пользователи с настроенными ролями. Воспользуйтесь поиском, чтобы настроить новых пользователей.",
				errors: {
					"needs-access": "Пользователь должен быть редактором либо иметь хотя бы один доступ или группу.",
					exists: "Пользователь с такой почтой уже существует",
				},
			},
			roles: {
				role: "Роль",
				select: "Выберите роль",
				workspaceOwner: "Владелец пространства",
				catalogOwner: "Владелец каталога",
				editor: "Редактор",
				reviewer: "Рецензент",
				reader: "Читатель",
				allowed: "Разрешено",
				denied: "Запрещено",
				change: "Изменить роль",
				editors: "Редакторы",
				workspaceOwners: "Владельцы пространства",
			},
			quiz: {
				export: {
					process: "Экспорт результатов тестов…",
					error: "Не удалось экспортировать результаты тестов",
				},
				"test-info": {
					"correct-answers-count": "Количество верных ответов",
					"answers-count": "Количество ответов",
				},
				switch: {
					on: "Модуль обучения включен",
					off: "Модуль обучения выключен",
				},
				filters: {
					users: {
						search: "Найти пользователей...",
						loading: "Загрузка пользователей...",
					},
					tests: {
						search: "Найти тесты...",
						loading: "Загрузка тестов...",
						empty: "Тесты не найдены",
					},
				},
				"users-test-table": {
					test: "Название теста",
					result: {
						free: "В тесте нет правильных ответов",
						tooltip: "Количество правильных ответов: {countOfCorrectAnswers} из {countQuestions}",
					},
					"created-at": "Дата прохождения",
				},
			},
			resources: {
				"repository-permission": "Настроить доступы",
				add: "Добавить каталог",
				adding: "Добавление каталога",
				editing: "Редактирование каталога",
				"editing-many": "Редактирование каталогов",
				"select-repository-description": "Выберите репозиторий каталога в Git-хранилище",
				"select-repository-placeholder": "Выберите каталог",
				"repository-not-found": "Каталог не найден",
				"main-branch": "Основная ветка",
				"main-branch-protection": "Защита от публикации",
				"main-branch-protection-description":
					"Публикация в основную ветку в интерфейсе Gramax запрещена. Изменения можно внести через слияние.",
				"select-main-branch-placeholder": "Выберите основную ветку",
				"protected-branch-not-found": "Ветки не найдены",
				"adding-user-accesses": "Добавление доступов пользователям",
				"adding-group-accesses": "Добавление доступов группам",
				"adding-guest-accesses": "Добавление доступов внешним читателям",
				find: "Найти по названию...",
				groups: {
					"not-found": "Группы не найдены",
				},
				branches: {
					placeholder: "Выберите ветки",
					required: "Выберите минимум 1 ветку",
				},
				catalog: {
					title: "Каталог",
					permission: {
						description: "Настройте доступы к каталогу",
					},
				},
				errors: {
					"base-not-deletable": "Базовые каталоги нельзя удалить",
				},
			},
			groups: {
				group: "Группа",
				groups: "Группы",
				add: "Добавить группу",
				adding: "Создание группы",
				editing: "Редактирование группы",
				"editing-many": "Редактирование групп",
				"adding-many": "Добавление групп",
				find: "Найти по названию...",
				"name-placeholder": "Введите название",
				"use-search-for-sso":
					"В списке отображаются пользовательские группы и SSO-группы с настроенными ролями. Воспользуйтесь поиском, чтобы настроить новые SSO-группы.",
				"sso-reader-only-hint": "SSO-группы могут иметь только роль Читателя",
				badges: {
					sso: "SSO",
					system: "Системная",
				},
				errors: {
					"delete-disabled": "Системные и SSO группы нельзя удалить",
					"name-required": "Укажите название",
					exists: "Группа с таким названием уже существует",
				},
			},
			guests: {
				guest: "Внешний читатель",
				guests: "Внешние читатели",
				reader: "Читатель",
				readers: "Читатели",
				add: "Добавить внешнего читателя",
				adding: "Создание внешнего читателя",
				editing: "Редактирование внешнего читателя",
				"editing-many": "Редактирование внешних читателей",
				"reader-only-hint": "Внешние читатели могут иметь только роль Читателя",
				"find-readers": "Найти по email...",
				"email-placeholder": "Введите email",
				"otp-enabled": "Вход по одноразовому паролю",
				"otp-description": "Вход по одноразовому паролю на почту для внешних читателей на портал документации",
				"general-settings": "Общие настройки",
				"session-duration-hours": "Продолжительность сеанса (часы)",
				"whitelist-settings": "Настройки белого списка",
				"whitelist-enabled": "Использовать белый список",
				"whitelist-domains": "Белый список доменов",
				"whitelist-domains-description":
					"Укажите домены почтовых адресов, разрешённые для входа внешних читателей (например, example.com, company.org)",
				domains: {
					title: "Домен",
					find: "Найти...",
					"add-domain": "Добавить домен",
					"add-domain-hint": "Введите домен для добавления в список разрешенных",
				},
				errors: {
					"domain-required": "Введите домен",
					"domain-invalid": "Некорректный домен",
					"domain-exists": "Домен уже существует в списке",
					"needs-access": "У внешнего читателя должен быть хотя бы один доступ.",
					"domain-not-allowed": "Домен email не входит в белый список.",
				},
			},
			mail: {
				"sender-settings": "Настройки отправителя",
				"sender-address": "Адрес отправителя (From)",
				"smtp-settings": "Настройки SMTP",
				host: "Хост",
				port: "Порт",
				password: "Пароль",
				"password-placeholder": "Введите пароль",
			},
			workspace: {
				"main-info": "Основная информация",
				"workspace-name": "Имя рабочего пространства",
				"source-url": "URL источника (GitLab)",
				"source-type": "Тип источника",
				templates: {
					title: "Шаблоны",
					description:
						"Загрузите сюда шаблоны в поддерживаемых форматах. При экспорте статьи из Gramax вы сможете выбрать один из них, чтобы автоматически оформить документ в вашем фирменном стиле.",
					word: {
						title: "Шаблоны Word",
						description: "Форматы: .docx, .docm, .dotx, .dotm.",
					},
					pdf: {
						title: "Шаблоны PDF",
						description: "Формат: .css.",
					},
				},
				views: {
					folder: "Папка",
					section: "Секция",
				},
				sections: {
					title: "Секции каталогов",
					add: "Добавить секцию",
					empty: "Секции каталогов не созданы",
					"empty-hint": 'Нажмите "Добавить секцию" для создания первой секции',
					"key-exists": 'Секция с ключом "{key}" уже существует. Пожалуйста, выберите другой ключ.',
					"table-header": "Название каталога",
					dialog: {
						"edit-title": "Редактировать секцию",
						key: "Ключ",
						"key-placeholder": "Введите ключ",
						"name-placeholder": "Введите название",
						"icon-description":
							"Введите название иконки Lucide в kebab-case формате (например: folder-open, settings, user-check)",
						view: "Вид",
						"view-empty": "Виды не найдены",
						"view-placeholder": "Выберите отображение",
						"description-placeholder": "Введите описание секции",
						catalogs: "Каталоги",
						"catalogs-description": "Добавляйте каталоги и настраивайте их порядок в секции",
						ok: "Ок",
						"unsaved-title": "У вас есть несохраненные изменения",
						"unsaved-description":
							"Вы внесли изменения в секцию, но не применили их. Применение изменений не сохраняет конфигурацию.",
						back: "Вернуться",
						"close-without-applying": "Закрыть без применения",
						apply: "Применить изменения",
						find: "Найти по названию...",
					},
					"add-catalogs": {
						title: "Выберите каталоги",
						empty: "Каталоги не найдены",
						loading: "Ищем каталоги...",
						description: "Выберите каталоги для добавления в список",
					},
				},
				repositories: {
					title: "Базовые каталоги",
					add: {
						title: "Выберите каталоги",
						empty: "Каталоги не найдены",
						description: "Выберите каталоги для добавления",
						label: "Каталоги",
					},
				},
			},
			check: {
				"service-unavailable": "Сервис стайлгайда недоступен",
				"check-failed": "Не удалось проверить статью",
				"checking-article": "Проверка статьи",
				"import-rules": "Импортировать правила",
				"export-rules": "Экспортировать правила",
				"run-all-tests": "Протестировать",
				"stop-all-tests": "Остановить проверку",
				"rules-llm-title": "Правила LLM",
				"rules-lgt-title": "Правила LanguageTool",
				"rules-types": {
					plainText: "Только для обычного текста",
					heading: "Только для заголовков",
				},
				"rule-title": "Настройка правила",
				"rule-name-placeholder": "Название правила",
				"rule-new-name": "Новое правило",
				"rule-llm-prompt-placeholder": "Описание ЛЛМ правила...",
				"rule-types-placeholder": "Выберите типы правила...",
				"tests-correct": "Тестов пройдено",
				"tests-title": "Тестирование",
				"tests-correct-section-title": "Строки с ошибками",
				"tests-incorrect-section-title": "Строки без ошибок",
				"test-add": "Добавить тест",
				"test-delete-confirm": "Вы уверены, что хотите удалить тест?",
				"test-run": "Запустить тест",
				"test-placeholder": "Текст примера",
				"test-popup-title": "Последний тест",
				"test-popup-empty": " Здесь будут результаты теста",
				"test-popup-done": "Выполнено",
				"service-connection-error":
					"Возникла проблема при подключении к сервису, обратитесь в техническую поддержку",
				retry: "Попробовать еще раз",
				"save-error": "Ошибка при сохранении настроек",
				"rule-name-duplicate": "Правило с таким именем уже существует",
				"rule-name-xml-hint": 'Редактируется только в поле "Описание" в атрибуте "name"',
				"passed-tooltip": "{passed} из {total} пройдено успешно",
			},
			plugins: {
				find: "Найти по названию...",
			},
			"access-tokens": {
				"service-unavailable": "Сервис токенов доступа недоступен",
			},
		},
	},
	"enterprise-cloud": {
		buttons: {
			publish: "Опубликовать",
		},
		"org-settings": {
			title: "Настройки организации",
			"cant-edit": "Изменять настройки организации может только владелец или администратор организации",
			users: {
				name: "Имя",
				email: "Email",
				placeholder: "Найдите пользователей",
				invite: "Пригласить",
				"email-placeholder": "john.doe@gmail.com",
				"invite-title": "Пригласить пользователя",
				"status-header": "Статус",
				status: {
					user: "Активен",
					invite: "Приглашен",
				},
				"invite-form": {
					title: "Пригласить пользователя",
					description: "Введите email пользователя, которого вы хотите пригласить",
					role: "Роль",
					errors: {
						"subscription-required":
							"Достигнут лимит редакторов в бесплатной подписке. Перейдите на платный тариф, чтобы пригласить нового редактора",
						"subscription-past-due": "По подписке есть просроченный платёж",
						"subscription-suspended": "Подписка приостановлена",
						"seat-purchase-required":
							"Все оплаченные места для редакторов заняты. Добавьте места в подписку, чтобы пригласить нового редактора",
						"invalid-role": "Эту роль нельзя назначить при приглашении",
						"admin-requires-editor-role": "Администратор должен быть приглашён как редактор",
						"admin-requires-owner": "Пригласить администратора может только владелец организации",
						"editor-role-requires-workspace-editor":
							"Роли редактора и владельца каталога доступны только редакторам",
						"already-invited": "У этого email уже есть активное приглашение",
						generic: "Не удалось отправить приглашение. Пожалуйста, попробуйте позже.",
					},
				},
				"invite-toast": "Приглашение успешно отправлено",
				"editor-seats": "Редакторские места",
				"buy-seats": "Купить места",
				"owner-always-editor-hint": "Владелец организации всегда является редактором",
				admin: {
					"admin-hint": "Позволяет пользователю управлять настройками организации",
					"owner-cant-be-admin-hint": "Владельца нельзя назначить администратором",
					"requires-editor-hint": "Администратор также должен быть редактором",
					"only-owner-can-change-hint": "Права администратора может менять только владелец организации",
					"only-owner-can-change-admin-editor-hint":
						"Роль редактора у администратора может менять только владелец организации",
				},
				"ai-agent": {
					access: "Доступ к AI-агенту",
					hint: "Позволяет пользователю работать с AI-агентом",
					"owner-always-has-access-hint": "Владельцу организации всегда доступен AI-агент",
				},
				roles: {
					admin: "Администратор",
					owner: "Владелец организации",
					reader: "Читатель",
					editor: "Редактор",
				},
			},
			subscription: {
				"choose-title": "Выберите тариф",
				"required-description":
					"Бесплатные места закончились. Выберите тариф, чтобы добавить новых участников.",
				"monthly-title": "Месячная подписка",
				"annual-title": "Годовая подписка",
				"per-month": "/ мес",
				"per-editor": "за редактора",
				total: "Итого",
				"seats-count": "ред.",
				"billed-yearly": "Оплата раз в год",
				continue: "Продолжить",
				"current-plan": "Текущий тариф",
				"load-error": "Не удалось загрузить тарифы",
				payment: {
					title: "Добавить места редакторов",
					description: "Одно место - один редактор в организации",
					"change-period-title": "Переход на годовую оплату",
					"change-period-description": "Один платёж в год вместо ежемесячных",
					seats: "мест редакторов",
					"set-seats-count": "Сколько мест добавить",
					"set-seats-count-placeholder": "Введите количество мест",
					"new-seats-count": "Всего в организации станет {newSeatsCount} мест",
					"not-enough-seats-error": "Укажите не меньше {minSeatsCount} мест",
					"per-editor-yearly": "Цена за редактора / год",
					"annual-subscription": "Годовая подписка",
					"editor-seats-for-period": "{editorsCount} мест редакторов на 1 {periodUnit}",
					"period-unit-month": "месяц",
					"period-unit-year": "год",
					"total-monthly": "Итого за месяц",
					monthly: "Ежемесячно, начиная",
					"total-yearly": "Итого за год",
					yearly: "Ежегодно, начиная",
					"periodic-payment-from": "{periodicPayment} с {date}",
					"due-today-title": "К оплате сейчас",
					"due-now-seats": "Добавленные места (пропорционально)",
					"due-now-seats-until-next-charge": "{seatsCount} × за оставшиеся {daysCount} дней до {date}",
					"due-today": "Итого к оплате сейчас",
					terms: "Я согласен с условиями использования",
					pay: "Оплатить",
					"pay-amount": "Оплатить {amount}",
					"pay-and-enable-autorenew": "Оплатить и подключить автопродление",
					"autorenew-notice":
						"Подписка продлевается автоматически. Сумма зависит от количества участников. Автопродление можно отключить.",
					"payment-method-save-notice":
						"Платежный способ будет сохранён для следующих платежей. Его можно отвязать во вкладке «Способы оплаты» в настройках организации.",
					"offer-acceptance-prefix": "Нажимая кнопку, вы принимаете",
					offer: "оферту",
					"pay-by-card": "Оплатить банковской картой",
					"create-invoice": "Сформировать счет",
					"load-error": "Не удалось загрузить детали платежа",
					"payment-methods-load-error": "Не удалось проверить способы оплаты",
					"pay-error": "Не удалось провести оплату",
					"unused-days-credit": "Неиспользованные дни",
					"recover-title": "Возобновление подписки",
					"recover-description": "Оплатите, чтобы восстановить доступ",
					"reset-to-free-message": "Подписка будет переведена на бесплатный тариф.",
					"recover-confirm": "Перейти на бесплатный тариф",
					"autopay-success": "Платёж обрабатывается. Изменения станут доступны через несколько секунд",
				},
				"payer-type": {
					title: "Как оформить подписку?",
					description: "У организации пока нет сохраненных способов оплаты. Выберите тип плательщика.",
					individual: "Физическое лицо",
					"individual-description": "Продолжить оплату картой и сохранить ее как способ оплаты.",
					"legal-entity": "Юридическое лицо",
					"legal-entity-description":
						"Заполнить реквизиты организации, затем перейти к подтверждению оплаты.",
					"legal-entity-title": "Оформление подписки на юр.лицо",
					"legal-entity-submit": "Оформить",
				},
			},
			billing: {
				title: "Биллинг",
				"change-plan": "Изменить тариф",
				"your-plan": "Ваш тариф",
				"current-plan": "Текущий тариф",
				type: {
					name: "Тип",
					individual: "Индивидуальная",
					corporate: "Корпоративная",
				},
				"plan-free": "Бесплатный",
				"plan-paid": "Платный",
				"period-month": "Помесячно",
				"period-year": "Ежегодно",
				"available-seats": "Доступно мест",
				"next-charge-date": "Дата следующего списания",
				"next-charge-amount": "Размер следующего списания",
				"will-become-free-tooltip":
					"Следующий платеж будет 0, так как в организации занятые места меньше {freeSeatsLimit}",
				"load-error": "Не удалось загрузить информацию о биллинге",
				"legal-entity": {
					title: "Переход в режим юр.лица",
					"search-error": "Не удалось загрузить реквизиты",
					"submit-error": "Не удалось перейти в режим юр.лица",
					submit: "Перейти",
					type: "Тип",
					company: "Юридическое лицо",
					"individual-entrepreneur": "ИП",
					"full-name": "Полное наименование",
					inn: "ИНН",
					kpp: "КПП",
					"registered-address": "Адрес",
					"document-email": "Email для документов",
					"reqs-select": {
						title: "Выберите юр.лицо",
						placeholder: "Найдите юр.лицо",
					},
					"email-input": {
						title: "Введите email юр.лица",
						placeholder: "john.doe@gmail.com",
					},
				},
				"cancel-subscription": {
					open: "Отменить подписку",
					title: "Отмена подписки",
					description:
						"Подписка останется активной до <b>{{currentPeriodEnd}}</b> До этой даты сохранятся все оплаченные места, а следующего списания не будет. После этого организация перейдет на бесплатный план, где доступно до <b>{{freeSeatsLimit}}</b> бесплатных мест.",
					"seats-overflow-warning":
						"Сейчас в организации <b>{{occupiedSeats}}</b> участников, а в бесплатном плане доступно <b>{{freeSeatsLimit}}</b> мест. После <b>{{currentPeriodEnd}}</b>, работать с каталогами смогут только первые <b>{{freeSeatsLimit}}</b> участников. Остальные останутся в организации, но не смогут читать или вносить изменения, пока вы не возобновите подписку.",
					"payment-method-notice":
						"Сохраненные способы оплаты не будут удалены. Их можно удалить отдельно в разделе способов оплаты.",
					close: "Оставить подписку",
					action: "Отменить продление",
					error: "Ошибка при отмене подписки",
				},
				payments: {
					title: "История платежей",
					date: "Дата",
					kind: "Тип",
					amount: "Сумма",
					status: "Статус",
					empty: "Платежей пока нет",
					kinds: {
						seat_purchase: "Покупка мест",
						subscription_renewal: "Продление подписки",
						subscription_recovery: "Восстановление подписки",
						ai_wallet_topup: "Пополнение AI-баланса",
						plan_upgrade: "Апгрейд плана",
					},
					statuses: {
						pending: "Ожидает оплаты",
						succeeded: "Оплачен",
						canceled: "Отменён",
					},
				},
			},
			"payment-methods": {
				title: "Способы оплаты",
				add: "Добавить",
				"add-confirm": {
					title: "Переход в ЮKassa",
					description: "Для привязки способа оплаты откроется страница платёжного сервиса ЮKassa.",
				},
				"set-default": "Сделать основным",
				delete: "Удалить",
				method: "Способ оплаты",
				expiry: "Срок",
				type: "Тип",
				sbp: "СБП",
				other: "Другой способ оплаты",
				default: "По умолчанию",
				"bind-error": "Не удалось запустить привязку карты",
				"bind-failed": "Карта не привязана",
				"bind-pending": "Идёт проверка привязки карты…",
				"set-default-error": "Не удалось назначить основной способ оплаты",
				"delete-error": "Не удалось удалить способ оплаты",
				"make-another-default": {
					title: "Укажите другой способ оплаты как основной",
					description: "Необходимо выбрать новый способ оплаты в качестве основного перед удалением старого",
				},
			},
			"ai-wallet": {
				title: "AI-кредиты",
				balance: "Текущий баланс",
				"top-up": "Пополнить",
				"load-error": "Не удалось загрузить AI-баланс",
				modal: {
					title: "Пополнение AI-баланса",
					"amount-label": "Сумма пополнения",
					"amount-placeholder": "Введите сумму",
					"amount-invalid": "Введите сумму не менее {minAmount}",
					pay: "Пополнить",
					"offer-acceptance-prefix": "Нажимая кнопку, вы принимаете",
					offer: "оферту",
					"pay-error": "Не удалось провести пополнение",
					"form-error": "Невозможно отправить форму",
				},
				access: {
					title: "Доступ к AI-агенту",
					description: "Выберите участников организации, которым доступен AI-агент",
					column: "Доступ к AI-агенту",
					"load-error": "Не удалось загрузить доступы к AI-агенту",
					"save-error": "Не удалось изменить доступ к AI-агенту",
				},
			},
			documents: {
				title: "Счета",
				date: "Дата",
				number: "Номер",
				download: "Скачать PDF",
				error: "Не удалось загрузить список счетов",
			},
			pages: {
				organization: "Организация",
				resources: "Ресурсы",
				users: "Пользователи",
				billing: "Биллинг",
				subscription: "Подписка",
				"payment-methods": "Способы оплаты",
				"ai-wallet": "AI-кредиты",
				"access-tokens": "Токены доступа",
				documents: "Документы",
				repos: "Каталоги",
			},
			organization: {
				save: "Сохранить",
				name: {
					label: "Название организации",
					placeholder: "Введите название организации",
				},
			},
			tokens: {
				name: "Наименование",
				"name-placeholder": "Введите наименование токена",
				"created-at": "Дата создания",
				"expires-at": "Дата истечения срока действия",
				"expires-at-placeholder": "Выберите дату",
				placeholder: "Найдите токены",
				create: "Создать токен",
				"create-form": {
					title: "Создать токен",
					description: "Заполните поля, чтобы создать новый токен",
				},
				"show-form": {
					title: "Токен создан",
					description: "Скопируйте токен сейчас — позже он не будет доступен",
					"copy-placeholder": "Копировать токен",
				},
			},
		},
		organization: {
			loading: "Загрузка организаций...",
			"error-loading": "Не удалось загрузить организаций",
		},
		"invite-mismatch": {
			title: "Несоответствие email",
			message:
				"Приглашение в организацию было отправлено на другой email-адрес. Убедитесь, что вы используете правильную учетную запись.",
		},
		"organization-access-denied": {
			title: "Организация не найдена",
			message:
				"Похоже, у вас пока нет доступа к этой организации. Попросите её владельца пригласить вас или войдите в аккаунт, у которого есть доступ.",
		},
		"sign-out": {
			title: "Выход",
			description: "Вы уверены, что хотите выйти из аккаунта?",
			"web-description":
				"Вы уверены, что хотите выйти из аккаунта? Неопубликованные каталоги и неопубликованные статьи в каталогах будут удалены.",
		},
		forms: {
			"publish-new-catalog": {
				name: "Публикация нового каталога",
				description: "Укажите название каталога и репозитория",
				message:
					"Данные каталога будут храниться в репозитории <code>{{repositoryName}}</code>. Это название станет частью ссылки на каталог, поэтому изменить его можно только сейчас.",
				"repository-name": "Имя репозитория",
			},
		},
		"subscription-inactive-alert": {
			title: {
				past_due: "Подписка просрочена",
				suspended: "Подписка приостановлена",
			},
			description: {
				past_due: "Подписка просрочена. Пожалуйста, оплатите подписку, чтобы продолжить использование сервиса.",
				suspended: "Подписка приостановлена. Пожалуйста, произведите оплату, чтобы восстановить подписку.",
			},
			buttons: {
				pay: "Оплатить",
			},
		},
		"app-settings": {
			title: "Настройки приложения",
		},
	},
	network: {
		error: {
			title: "Не удалось подключиться к серверу",
			body: "Проверьте подключение к интернету и повторите попытку. Если проблема сохраняется, возможно, сервер временно недоступен.",
		},
	},
	"experimental-features": {
		label: "Экспериментальные функции",
		status: {
			"in-dev": "Эта функция находится в разработке и не предназначена для использования",
			experimental: "Эта функция экспериментальная и может не работать как ожидается",
			unstable: "Эта функция нестабильная и, вероятно, содержит ошибки",
			beta: "Эта функция не полностью стабилизирована и все еще может содержать ошибки",
		},
	},
	notifications: {
		title: "Уведомления",
		"mark-all-as-read": "Отметить все как прочитанные",
		loading: "Загрузка...",
		error: "Не удалось загрузить уведомления",
		"no-notifications": "Нет уведомлений",
		"loading-more": "Загрузка...",
		"mailing-list": "Список рассылки",
		"mailing-list-description": "Управление подписками на рассылку.",
		"mailing-list-groups": "Группы",
		"mailing-list-users": "Пользователи",
		"mailing-list-select-groups": "Выберите группы...",
		"mailing-list-search-users": "Поиск пользователей...",
		settings: "Настроить уведомления",
		"settings-description": "Выберите, когда вы хотите получать уведомления для этой статьи.",
		"on-create": "Уведомлять при создании",
		"on-change": "Уведомлять при изменении",
		"on-both": "Уведомлять при создании или изменении",
		disabled: "Не уведомлять",
	},
	export: {
		name: "Экспортировать",
		zip: {
			catalog: "Каталог в ZIP",
			article: "Статью в ZIP",
			category: "Раздел в ZIP",
			process: "Подготовка к выгрузке ZIP-архива",
		},
		docx: {
			catalog: "Каталог в DOCX",
			article: "Статью в DOCX",
			category: "Раздел в DOCX",
			process: "Подготовка к выгрузке DOCX-документа",
		},
		pdf: {
			catalog: "Каталог в PDF",
			article: "Статью в PDF",
			category: "Раздел в PDF",
			process: "Генерация PDF",
			canceled: "Отмена...",
			tocPageTitle: "Оглавление",
			preview: "Предпросмотр печати",

			form: {
				title: {
					catalog: "Экспорт каталога в PDF",
					category: "Экспорт раздела в PDF",
					article: "Экспорт статьи в PDF",
				},
				description: "Настройте содержимое и оформление.",
				titlePage: "Титульная страница",
				titlePageDescription:
					"Добавить титульную страницу с названием каталога/раздела и основной информацией.",
				tocPage: "Оглавление",
				tocPageDescription:
					"Добавить раздел с оглавлением, где будут перечислены все разделы каталога и номера страниц.",
				titleNumber: "Нумерация разделов",
				titleNumberDescription: "Автоматическая нумерация заголовков статей",
				articleTitle: "Заголовок статьи",
				articleTitleDescription: "Напечатать название статьи в начале первой страницы.",
				template: "Кастомный шаблон",
				templateDescription: {
					body: "Используйте собственные CSS-стили для оформления PDF.",
					more: "Подробнее",
				},
				openPrint: "Открыть окно печати",
				savePdf: "Сохранить PDF",
				printDialog: "В окне печати выберите «Сохранить как PDF»",
				footerDescription:
					"После экспорта откроется окно печати браузера.\nВыберите A4 и в поле «Принтер/Назначение» выберите сохранение в PDF.",
			},

			saved: {
				title: "PDF сохранен",
				showInFolder: "Показать в папке",
			},
			saveError: {
				title: "Не удалось сохранить PDF",
				diagnosis:
					"Gramax не может записать файл {name}: нет прав на запись в эту папку или файл открыт в другой программе. Каталог не изменился.",
				recipe: "Выберите другое место или закройте файл и сохраните еще раз.",
				chooseAnotherLocation: "Выбрать другое место",
			},

			error: {
				title: "Ошибка экспорта в PDF",
				message: "Что-то пошло не так во время экспорта в PDF",
			},
		},
	},
	account: "Аккаунт",
	add: "Добавить",
	apply: "Применить",
	article2: "Статья",
	article3: "статьёй",
	article4: "статьи",
	branch: "Ветка",
	branches: "Ветки",
	cancel: "Отменить",
	category2: "разделом",
	category3: "раздела",
	checking: "Проверяем",
	close: "Закрыть",
	collapse: "Сворачивать",
	command: "Команда",
	comment: "Комментарий",
	"no-selected": "Не выбран",
	"pick-random-value": "Выбрать случайное значение",
	"comment-on": "Комментировать",
	company: "Внутренняя документация",
	configure: "Настроить",
	confirm: "Подтвердить",
	continue: "Продолжить",
	filter: "Фильтр",
	copied: "Скопировано",
	copy: "Скопировать",
	count: "кол-во",
	creating: "Создание",
	current: "Русский",
	delete: "Удалить",
	deleting: "Удаление",
	description: "Описание",
	edit2: "Редактировать",
	actions: "Действия",
	edit: "Отредактировать",
	editing: "Редактирование",
	element: "Элемент",
	"enter-value": "Введите значение",
	error: "Ошибка",
	existing: "существующий",
	exit: "Выйти",
	expand: "Раскрыть",
	field: "Поле",
	file: "Файл",
	find: "Поиск",
	find2: "Найти",
	multiSelect: {
		placeholder: "Выберите значение",
		search: "Найти",
		loading: "Загрузка...",
		error: "Ошибка загрузки",
		inputHint: "Введите текст для поиска",
		empty: "Результатов не найдено",
	},
	replace: "Заменить",
	replaceAll: "Заменить все",
	caseSensitive: "С учетом регистра",
	wholeWord: "Слово целиком",
	fn: "Функциональные блоки",
	formula: "Формулы",
	group2: "группы",
	group: "Группа",
	healthcheck: "Проверка на ошибки",
	"healthcheck-description": "Проверьте каталог на ошибки",
	"check-errors": "Проверить на ошибки",
	hide: "Скрыть",
	icon: "Иконка",
	image: "Изображение",
	in: "в",
	interface: "Интерфейс",
	invalid2: "Некорректный",
	invalid: "Некорректное",
	link2: "Ссылку",
	link: "Ссылка",
	clickToViewDetails: "Кликните, чтобы посмотреть детали",
	load: "Загрузить",
	loading2: "Загружаем...",
	loading: "Загрузка...",
	loadWait: "Ожидает загрузки",
	local: "Локальная ветка",
	mail: "Почта",
	email: "Email",
	more: "Подробнее",
	"read-more": "Подробнее..",
	name: "Название",
	name2: "Имя",
	"enterprise-catalog-required-title": "Каталог доступен в GES",
	"enterprise-catalog-required-description":
		"Этот каталог доступен только в Gramax Enterprise Server (GES). Откройте ссылку в GES вашей организации.",
	ok: "Понятно",
	open: "Открыть",
	"open-in-new-window": "Открыть в новом окне",
	other: "Прочее",
	page: "Страница",
	products: "Продукты и сервисы",
	projects: "Проекты",
	pull: "Pull",
	refresh: "Перезагрузить",
	remote: "Опубликовано",
	repository2: "репозитория",
	repository: "Репозиторий",
	resolve: " Решено ",
	save: "Сохранить",
	save2: "Сохраняем",
	see: "См.",
	select: "Выбрать",
	send: "Отправить",
	signature: "Подпись",
	fragment: "Фрагмент",
	"fragment-link": "Ссылка на фрагмент",
	source2: "Источника",
	source: "Источник",
	space: "Раздел",
	storage2: "хранилища",
	storage: "Хранилище",
	strike: "Зачеркнутый",
	style: "Стиль",
	switch: "Сменить",
	sync: "Синхронизировать",
	synchronization: "Синхронизация...",
	theme: {
		title: "Тема",
		light: "Светлая",
		dark: "Тёмная",
	},
	title: "Заголовок",
	token: "токен",
	type: "Тип",
	unresolve: "Нерешено",
	user: "Пользователь",
	value: "значение",
	values: "шт",
	"export-logs": {
		title: "Экспорт логов",
		session: "Текущая сессия",
		today: "Сегодня",
		"last-7-days": "Последние 7 дней",
		all: "Все",
	},
	"log-level": {
		title: "Уровень логирования",
		description:
			"Более подробные уровни помогают поддержке разбираться с проблемами, но увеличивают размер лог-файлов",
		off: "Выключено",
		commands: "Команды",
		important: "Важные",
		internal: "Внутренняя логика",
		files: "Взаимодействие с файлами",
		full: "Полные",
		desc: {
			off: "Логи не записываются",
			commands: "Выполнение верхнеуровневой логики",
			important: "Ключевые шаги внутри команд",
			internal: "Внутренняя работа Git, каталога и файловой структуры",
			files: "Плюс операции записи при взаимодействии с файлами",
			full: "Все операции, включая чтения",
		},
	},
	version: "Версия",
	warning: "Предупреждение",
	who: "Кому",
	forward: "Вперед",
	backward: "Назад",
	"add-account": "Добавить аккаунт",
	"add-annotation": "Добавить аннотацию",
	"add-new-branch": "Добавить новую ветку",
	"add-new-fragment": "Добавить новый фрагмент",
	"add-new-source": "Добавить новый источник",
	"add-new-storage": "Добавить новое хранилище",
	"add-square": "Добавить квадрат",
	"add-storage": "Добавить хранилище",
	"storage-actions": "Действия с хранилищем",
	"add-to-continue-downloading": "Добавьте его, чтобы продолжить загрузку.",
	"add-value": "Добавить значение",
	"after-merge": "После слияния",
	"all-groups": "Все группы",
	"and-sync-catalog": "И синхронизировать каталог?",
	"annotation-text": "Текст аннотации",
	"article-titles": "Заголовки статьи",
	"authorization-by-mail": "Авторизация по почте",
	"bottom-left-pointer": "Нижняя левая аннотация",
	"bottom-right-pointer": "Нижняя правая аннотация",
	"branch-name-already-exists": "Ветка с таким названием уже существует",
	"branch-name-can-not-be-reserved-names": "Имя ветки не может совпадать с зарезервированными именами HEAD",
	"branch-name-can-not-have-dot-and-slash-at-end-and-contain-sequences-of-slashes":
		"Имя ветки не может заканчиваться на '/' или '.', а также содержать последовательности '//'",
	"branch-name-can-not-have-dots-sequence-and-leading-dot":
		"Имя ветки не может начинаться с точки или содержать последовательность двойных точек '..'",
	"branch-name-can-not-have-encoding-symbols":
		'Имя ветки не может содержать специальные символы, такие как пробел, *, ?, [], ~, :, ", <, >, |, ^, \\',
	"branch-name-can-not-have-existing-prefix-branch": "Имя ветки не может содержать префикс, как у существующей ветки",
	"branch-name-not-end-with-lock": "Имя ветки не может заканчиваться на '.lock'",
	"branches-are-updated": "Бренчи обновлены",
	"by-azure": "C помощью Azure",
	"by-mail": "По почте",
	"cancel-crop": "Отменить обрезку",
	"space-name-min-length": "Название пространства должно содержать минимум 2 символа",
	"repository-name-min-length": "Название репозитория должно содержать минимум 2 символа",
	"directory-name-min-length": "Название каталога должно содержать минимум 2 символа",
	"cant-be-same-name": "Имя должно быть уникальным",
	"cant-be-same-path": "Путь должен быть уникальным",
	"cant-edit-this-line": "Нельзя редактировать эту строку",
	"cant-get-fragment-data": "Проверьте, правильно ли указан путь, а также есть ли файл со фрагментом в репозитории",
	"catalog-icons-title": "Иконки каталога",
	"icon-picker": {
		trigger: "Иконки и эмодзи",
		search: {
			icons: "Поиск иконки",
			emoji: "Поиск эмодзи",
		},
		tabs: {
			icons: "Иконки",
			emoji: "Эмодзи",
			"file-input": "Загрузить",
		},
		categories: {
			"catalog-icons-title": "Иконки каталога",
			"recently-used-icons": "Недавно использованные",
			text: "Текст",
			accessibility: "Доступность",
			medical: "Медицина",
			home: "Дом",
			multimedia: "Мультимедиа",
			devices: "Устройства",
			photography: "Фотография",
			layout: "Вёрстка",
			"food-beverage": "Еда и напитки",
			transportation: "Транспорт",
			emoji: "Эмодзи",
			buildings: "Здания",
			files: "Файлы",
			arrows: "Стрелки",
			science: "Наука",
			account: "Аккаунт",
			tools: "Инструменты",
			design: "Дизайн",
			gaming: "Игры",
			shopping: "Покупки",
			social: "Социальное",
			finance: "Финансы",
			travel: "Путешествия",
			connectivity: "Связь",
			notifications: "Уведомления",
			navigation: "Навигация",
			animals: "Животные",
			development: "Разработка",
			security: "Безопасность",
			shapes: "Фигуры",
			weather: "Погода",
			math: "Математика",
			time: "Время",
			nature: "Природа",
			charts: "Графики",
			communication: "Коммуникация",
			mail: "Почта",
			cursors: "Курсоры",
			sports: "Спорт",
			sustainability: "Экология",
		},
		"emoji-categories": {
			"recently-used": "Недавно использованные",
			"smileys-emotion": "Лица",
			"people-body": "Люди и тело",
			"animals-nature": "Животные и природа",
			"food-drink": "Еда и напитки",
			"travel-places": "Путешествия",
			activities: "Активности",
			objects: "Объекты",
			symbols: "Символы",
			flags: "Флаги",
		},
	},
	"change-and-sync": "Сменить и синхронизировать",
	"check-diagrams": "Диаграммы",
	"edit-diagram": "Редактирование диаграммы",
	"edit-diagram-description": "Измените содержимое диаграммы",
	"check-file-path": "Проверьте правильно ли указан путь до файла",
	"check-fs": "Файловая структура",
	"check-icons": "Иконки",
	"check-images": "Изображения",
	"check-links": "Ссылки",
	"check-unsupported": "Неподдерживаемые элементы",
	"check-content": "Статьи",
	"check-comments": "Комментарии",
	"check-aliases": "Дополнительные пути",
	"choose-header": "Выбрать заголовок",
	"clarifying-tags": "Уточняющие метки",
	"click-to-copy": "Нажмите, чтобы скопировать",
	"clone-branch-not-found":
		"Это может произойти в двух случаях: ветку удалили или создали, но не опубликовали. Запросите новую ссылку.",
	"clone-error-desc1": "Проверьте, существует ли репозиторий",
	"clone-error-desc2": "А также, убедитесь, что у вас есть права на его редактирование.",
	"clone-fail": "Не удалось загрузить каталог",
	"close-comment": "Закрыть комментарий",
	"exit-edit-mode": "Вы уверены, что хотите выйти из режима редактирования?",
	"comments-to-article": "Замечание к статье",
	"commit-message": "Комментарий",
	"confirm-answer-delete": "Удалить комментарий?",
	"comment-author-you": "Вы",
	"comment-not-here": "К этому месту нельзя оставить комментарий",
	"comment-over-comment": "Здесь уже есть комментарий — второй поверх пока нельзя",
	"confirm-create-catalog-on-clone":
		"Gramax создаст в репозитории папку docs и добавит в нее системные файлы каталога. Затем вы сможете начать работу.",
	"confirm-create-catalog-on-clone-header": "В репозитории нет каталога. Создать?",
	"connect-storage": "Подключить хранилище",
	"continue-locally": "Продолжить локально",
	"create-branch": "Создать ветку",
	"create-files-to-edit-markdown": "Добавьте статью для редактирования",
	"create-new2": "Создать каталог",
	"created-in-gramax": "Создано в Gramax",
	"crop-image": "Обрезать изображение",
	"current-branch": "Отображаемая ветка",
	"current-version": "Текущая версия",
	"danger-text": "Ошибка",
	"delete-as-resolved": "Удалить как решенный",
	"delete-branch": "Удалить ветку",
	"delete-file": "Удалить файл",
	"delete-fragment-confirm": "Вы уверены, что хотите удалить фрагмент?",
	"delete-fragment-confirm-not-use": "Этот фрагмент не используется ни в одной из статей",
	"delete-fragment-desc":
		"Вы собираетесь удалить фрагмент, который в настоящее время используется в следующих статьях:",
	"delete-fragment-warn":
		"После удаления фрагмента, в статьях, где он использовался, возникнут ошибки вместо отображения удаленного фрагмента",
	"deleting-fragment-in-use": "Удаление используемого фрагмента",
	"desktop-settings.target-directory-description":
		"Папка на локальном диске, в которой находятся каталоги для редактирования",
	"display-on-homepage": "Отображение на главной",
	"dont-save": "Не сохранять",
	"edit-on": "Редактировать в",
	"empty-field": "Пустое поле",
	"enter-branch-name": "Введите название ветки",
	"enter-fragment-text": "Введите текст фрагмента",
	"error-expand": "Показать детали",
	"error-mail": "Указана некорректная почта",
	"error-sing-in": "Ошибка входа",
	"error-occured": "К сожалению, при отображении документации возникла ошибка.",
	"export-disabled": "Добавьте статью для экспорта",
	"disabled-reason": {
		"publish-no-selection": "Выберите изменения, которые хотите опубликовать",
		"publish-no-access": "Нет доступа к репозиторию. Проверьте токен в настройках хранилища",
		"merge-unresolved": "Разрешите все конфликты, чтобы продолжить слияние",
		"view-editing-other": "Сначала сохраните или отмените изменения текущего представления",
		"storage-nothing-to-clean": "Очищать нечего",
		"storage-counting": "Идет подсчет занятого места",
		"editor-not-applicable": "Недоступно для выделенного фрагмента",
		"revisions-pick-two": "Выберите две ревизии, чтобы сравнить их",
		"mode-read-only": "Недоступно в режиме чтения",
		"branches-offline": "Нет сети. Ветки станут доступны, когда связь восстановится",
		"sync-offline": "Нет сети. Синхронизация пойдет, когда связь восстановится",
		"publish-offline": "Нет сети. Публикация станет доступна, когда связь восстановится",
		"inline-image-no-text": "Добавьте абзац с текстом над изображением или под ним",
		"inline-image-block-parts": "Сначала уберите подпись и изменения из редактора изображения",
	},
	"file-content": "Контент файла",
	"file-download-error-message": "Возможно, он был перенесен или удален.",
	"file-download-error-title": "Не удалось скачать файл",
	"find-branch": "Поиск ветки",
	"for-certain-users": "Определенным пользователям",
	"foreign-key": "Внешний ключ FK",
	"generate-link": "Сформировать ссылку",
	"git-pull": "Git pull",
	"git-status": "Git status",
	"go-to-article": "Перейти к статье",
	"go-to": "Перейти на",
	"img-h": "Вертикальные группы картинок",
	"img-v": "Горизонтальные группы картинок",
	"in-article": "В статье",
	"in-branch": "В ветку",
	"incorrects-icons": "Некорректные иконки",
	"incorrects-paths": "Некорректные пути",
	"incorrects-unsupported": "Элементы",
	"incorrects-content": "Некорректный синтаксис",
	"incorrects-comments": "Непривязанные комментарии",
	"incorrects-aliases": "Конфликтующие пути",
	"alias-taken": "Этот путь уже используется или совпадает с путем существующей статьи",
	"alias-self": "Совпадает с собственным путем статьи — такой путь ничего не делает",
	"alias-shadowed": "По этому пути уже есть статья — переход по нему никогда не сработает",
	"alias-duplicate": "Занят статьей {{winner}} — здесь путь не сработает",
	"alias-broken-moved": "Некорректная дата перемещения: {{moved}}",
	"markdown-error": "Некорректная разметка",
	"info-text": "Информация",
	"init-git-version-control": "Инициализировать Git",
	"invalid-index": "Индекс не соответствует требованиям!",
	"invalid-credentials-title": "Не удалось подключиться",
	"invalid-credentials-text": "Пожалуйста, проверьте правильность введённых данных.",
	"lab-text": "Примечание",
	"leads-to-the-branch": "Вы переходите по ссылке, которая ведет на другую ветку.",
	"leave-comment": "Оставить комментарий",
	"leave-file": "Оставить файл",
	"link-end-date": "Указать срок действия ссылки",
	"mail-or-group": "Почта или Группа",
	"max-length": "Максимальное количество символов: ",
	"must-be-not-empty": "Это поле не может быть пустым.",
	"no-access-to-storage": "Нет доступа к хранилищу",
	"no-branch-found": "Не найдено веток",
	"no-encoding-symbols-in-url": "URL может содержать только латинские буквы, цифры и символы '-', '_', '.'",
	"no-encoding-symbols-in-url-no-dot": "URL может содержать только латинские буквы, цифры и символы '-', '_'",
	"no-headers": "(Нет ни одного заголовка)",
	"no-such-function": "Такой функции нет!",
	"not-found": "Не найдено",
	"not-found2": "Не найдена",
	"note-text": "Предупреждение",
	"numbero-of-unsolved-comments": "Кол-во нерешенных комментариев",
	"on-the-same-version": "Находится на одной версии с этой веткой",
	"open-api": "OpenAPI",
	"hide-openapi-info": "Скрыть заголовок и описание API",
	"show-openapi-info": "Показать заголовок и описание API",
	OpenApi: "OpenAPI",
	Html: "HTML",
	"Img-v": "Вертикальная группа картинок",
	"Img-h": "Горизонтальная группа картинок",
	Formula: "Формула",
	Icon: "Иконка",
	Fragment: "Фрагмент",
	View: "Представление",
	"other-version": "Другая версия",
	"publish-catalog": "Опубликовать каталог",
	"publish-changes": "Опубликовать изменения",
	"quote-text": "Цитата",
	"remove-link": "Удалить ссылку",
	"repository-https-url": "HTTPS URL репозитория",
	"repository-ssh-url": "Repository SSH URL",
	"required-parameter": "Обязательный параметр",
	"resolve-conflict": "Решить конфликт",
	"save-and-exit": "Сохранить и выйти",
	"save-article-in": "Сохранить статью в",
	"save-changes": "Сохранить изменения",
	"schemas-block": "Выводить блок «Схемы»",
	"select-all": "Выбрать все",
	"select-or-add-new": "Выберите или добавьте новые",
	"share-access-token-not-installed": "Share Access Token не установлен",
	"send-comment": "Отправить комментарий",
	"show-comment": "Показать комментарий",
	"show-comments": "Комментарии",
	"show-diffs": "Изменения",
	"sing-in": "Войти",
	"sing-out": "Выйти",
	"fragment-already-exists": "Фрагмент с таким id уже существует",
	"fragment-render-error": "Не удалось отобразить фрагмент",
	"fragment-error": {
		"not-found": "Фрагмент {{id}} не найден в каталоге: {{path}}",
		"not-found-anywhere": "Фрагмент {{id}} не найден ни в каталоге, ни в {{scope}}",
		"not-found-anywhere-at": "Фрагмент {{id}} не найден ни в каталоге, ни в {{scope}}. Путь в каталоге: {{path}}",
		"unknown-scope": "Фрагмент {{id}} ссылается на область {{scope}}, которой нет в этом пространстве",
		unavailable: "Фрагмент {{id}} не удалось прочитать",
		"unavailable-in": "Фрагмент {{id}} не удалось прочитать в {{scope}}",
		cycle: "Фрагмент {{id}} вставлен сам в себя: {{path}}",
		failed: "Проверьте файл фрагмента {{path}}",
	},
	"so-far-its-empty": "Пока что тут пусто",
	"storage-not-connected": "Хранилище не подключено",
	"sync-offline": "Офлайн. Нажмите для повторного подключения.",
	"sync-offline-toast-title": "Нет доступа к удаленному серверу",
	"sync-offline-toast-desc": "Вход в офлайн.",
	"submit-login-link": "Отправить ссылку для входа",
	"switch-branch": "Переключить ветку",
	"sync-catalog": "Синхронизировать каталог?",
	"sync-catalog-push1": "неопубликованное изменение",
	"sync-catalog-push2": "неопубликованных изменения",
	"sync-catalog-push3": "неопубликованных изменений",
	"sync-catalog-changed1": "изменение доступно для синхронизации",
	"sync-catalog-changed2": "изменения доступно для синхронизации",
	"sync-catalog-changed3": "изменений доступно для синхронизации",
	"sync-catalog-desc": "Версия каталога устарела. Чтобы получить изменения, синхронизируйте каталог.",
	"sync-logs": "Логи синхронизации",
	"sync-something-changed": "В репозитории что-то изменилось, но каталог все еще актуален",
	"system-icons-title": "Системные иконки",
	"takes-to-more-current-version": "Ведет на более актуальную версию каталога",
	"technical-details": "Технические детали",
	"tip-text": "Совет",
	"to-branch": "На ветку",
	"to-navigate": "Навигация",
	click: "Кликните",
	"to-make-changes": "для изменения",
	"today-at": "Сегодня в ",
	"top-left-pointer": "Верхняя левая аннотация",
	"top-right-pointer": "Верхняя правая аннотация",
	"unable-to-get-sync-count": "Не удалось получить изменения для синхронизации",
	"unsaved-changes": "Сохранить изменения?",
	"unsupported-elements-title": "Неподдерживаемые элементы",
	"unsupported-elements-warning1": "DOCX не поддерживает некоторые элементы Gramax.",
	"unsupported-elements-warning2": "Список статей с неподдерживаемыми элементами",
	"unsupported-elements-warning3": "Файл будет сохранен без них.",
	"update-branches": "Обновить список веток",
	"users-group": "От какой группы дать права",
	"view-usage": "Посмотреть использования",
	"working-directory": "Рабочая директория",
	"yesterday-at": "Вчера в ",
	"your-branch": "Ваша ветка",
	"edit-html": "Редактировать HTML",
	"edit-html-description": "Редактируйте HTML-контент",
	"do-not-show-again": "Больше не показывать",
	properties: {
		name: "Свойства",
		"article-title": "Свойства статьи",
		"empty-state": {
			title: "Свойств пока нет",
			description: "Добавьте свойства, чтобы удобно\nфильтровать и находить статьи",
		},
		move: "Переместить свойство",
		edit: "Редактировать свойство",
		all: "Все",
		find: "Найти свойство",
		add: "Добавить свойство",
		empty: "(пусто)",
		"no-properties": "Нет свойств",
		"already-exist": "Такое свойство уже существует",
		"select-all": "(выбрать все)",
		"delete-property-confirm": "Вы уверены, что хотите удалить это свойство? Оно будет удалено со всех статей.",
		"validation-errors": {
			"all-parameters-added": "Все параметры добавлены",
			"prop-creator": "Имя слишком короткое или такое свойство уже существует",
		},
		system: {
			hierarchy: {
				name: "Иерархия",
				values: {
					"child-to-current": "Дочерние статьи текущей",
				},
			},
		},
		warning: {
			"delete-tag-from-catalog": {
				title: "Удаление свойства из каталога",
				body: "Вы уверены, что хотите удалить свойство? Оно будет удалено со всех статей.",
			},
			"delete-value-from-catalog": {
				title: "Удаление значения свойства",
				body: "Вы уверены, что хотите удалить это значение? Оно будет удалено из всех статей.",
			},
		},
		view: {
			name: "Представление",
			"group-by": "Группировка",
			"order-by": "Сортировка",
			filter: "Фильтр",
			select: "Выборка",
			displays: {
				name: "Вид",
				list: "Список",
				table: "Таблица",
				kanban: "Доска",
			},
			"empty-state": {
				"no-content": {
					title: "Статьи не найдены",
					description: "В каталоге нет статей, которые подходят под выбранные фильтры",
				},
				"no-groupby": {
					title: "Нет группировки",
					description: "Выберите свойство, по которому раскладывать статьи на доске",
				},
			},
		},
		types: {
			Numeric: "Числовой",
			Flag: "Флаг",
			Date: "Дата",
			Enum: "Один из списка",
			Many: "Несколько из списка",
			Text: "Текст",
			Array: "Массив",
			BlockMd: "Блок текста",
			InlineMd: "Строка Markdown",
			News: "Новость",
		},
		options: {
			docportalVisible: {
				name: "Показывать читателям",
				description: "Свойство будет видно и доступно для поиска на портале документации",
			},
		},
		selected: "(выбрано)",
		article: "Статья",
		archive: "Архивировать",
		"update-affected-articles": "статьи будут затронуты",
		"add-property": "Добавить свойство",
		"no-values": "Нет значений",
		colors: {
			red: "Красный",
			orange: "Оранжевый",
			yellow: "Желтый",
			lime: "Салатовый",
			green: "Зеленый",
			teal: "Бирюзовый",
			sky: "Голубой",
			blue: "Синий",
			lavender: "Лавандовый",
			purple: "Фиолетовый",
			pink: "Розовый",
			gray: "Серый",
		},
	},
	"create-new": "Создать новое",
	manage: "Управлять",
	change: "Изменить",
	"enter-number": "Введите число",
	"enter-text": "Введите текст",
	reset: "Сбросить",
	model: "Модель",
	"goto-original": "Перейти к оригиналу",
	"select-table": "Выделить таблицу",
	"no-date": "Нет даты",
	inbox: {
		"empty-state": { title: "Заметок пока нет", description: "Нажмите «+» вверху,\nчтобы добавить первую заметку" },
		author: "Автор",
		"add-note": "Добавить заметку",
		expand: "Показать полностью",
		collapse: "Скрыть",
		"empty-content": "Заметка без текста",
		placeholders: {
			title: "Заголовок заметки",
			content: "Текст заметки",
		},
		name: "Заметки",
		"new-note": "Новая заметка",
		"no-catalog-notes": "В текущем каталоге нет заметок",
		"search-placeholder": "Поиск автора...",
		"no-user-with-this-name": "Автор не найден",
	},
	template: {
		"empty-state": {
			title: "Шаблонов пока нет",
			description:
				"Создайте шаблон с переменными для быстрого заполнения. Нажмите «+», чтобы создать первый шаблон",
		},
		name: "Шаблоны",
		placeholders: {
			title: "Заголовок шаблона",
			content: "Текст шаблона",
		},
		"new-template": "Новый шаблон",
		"no-templates": "Нет шаблонов",
		"no-template": "Без шаблона",
		warning: {
			content: {
				name: "Вставить шаблон {{template}} в статью?",
				body: "Текст статьи будет заменен на шаблон. Если вы не хотите потерять его — отмените вставку и переместите текст в другую статью.",
			},
		},
		"choose-template": "Выбрать шаблон",
		"select-property": "Выбрать свойство",
	},
	clear: "Очистить",
	yes: "Да",
	no: "Нет",
	placeholder: "Плейсхолдер",
	fragments: "Фрагменты",
	"fragments-panel-empty-state": {
		title: "Фрагментов пока нет",
		description:
			"Сохраняйте повторяющийся контент, чтобы быстро вставлять его в статьи. Нажмите «+», чтобы создать первый фрагмент",
	},
	"fragments-panel-title": "Фрагменты",
	"fragments-panel-create": "Создать фрагмент",
	"fragments-panel-search": "Поиск фрагментов...",
	"fragments-panel-loading": "Загрузка фрагментов",
	"fragments-panel-empty": "Фрагменты не найдены",
	"fragments-panel-untitled": "Без названия",
	"fragments-panel-no-content": "Нет содержимого",
	"fragments-panel-manage": "Управление фрагментами",
	"new-fragment": "Новый фрагмент",
	"no-fragments": "В текущем каталоге нет фрагментов",
	"fragment-no-usages": "Фрагмент не используется ни в одной из статей",
	ai: {
		"search-prompts": "Поиск промптов",
		"no-prompts": "Промпты не найдены",
		"ai-prompts": "ИИ-промпты",
		"ask-ai": "Спросить у ИИ что-либо",
		generate: "Генерация текста",
		generating: "Генерация...",
		transcribe: {
			name: "Транскрипция",
			description: "Распознавание речи из медиа файла",
			click: "Запись",
			access: "Нажмите для запроса доступа к микрофону",
			"browser-denied": "Доступ к микрофону запрещен. Разрешите доступ в настройках браузера",
			"system-denied": "Доступ к микрофону запрещен. Разрешите доступ в настройках системы",
			loading: "Проверка доступа к микрофону...",
			notSupported: "Ваш браузер не поддерживает захват звука",
			recording: "Запись",
			reset: "Нажмите для сброса записи",
			pause: "Нажмите для паузы",
			resume: "Нажмите для продолжения",
			warningHomeSend: "Вы не можете сохранить аудио с главной страницы",
			history: "История аудио",
			modal: "<p>После транскрипции появится распознанный текст.</p><p>Вы можете отредактировать текст, чтобы улучшить его качество. Для этого кликните на поле ввода и редактируйте его.</p>",
			"limit-reached": "Превышен лимит в 5 минут. Вы можете продолжить запись после сохранения текущего аудио.",
			modalAttention:
				"<p><strong>Внимание!</strong> Распознанный текст никуда не сохраняется. Если вы хотите сохранить текст, вы можете скопировать его в буфер обмена.</p>",
		},
		responseError: {
			title: "Ошибка ответа от ИИ сервера",
			body: `<p>Попробуйте позже или свяжитесь со своим администратором.<br/>Если ошибка блокирует работу — cоздайте нам заявку в <a href="https://github.com/Gram-ax/gramax/issues">GitHub</a>.</p>`,
		},
		transcribtion: "Транскрипция...",
		placeholder: {
			prettify: "Что сделать с выделенным текстом ✨",
			generate: "Напишите что-нибудь прекрасное ✨",
		},
		warning: {
			"generate-many-selection":
				"С выделенным текстом можно работать только через всплывающую панель редактирования",
		},
		prompt: {
			placeholder: {
				title: "Заголовок промпта",
				content: "Текст промпта",
			},
			"new-prompt": "Новый промпт",
			"no-prompts": "В текущем каталоге нет промптов",
		},
	},
	"mark-as-read": "Отметить как прочитанное",
	"already-read": "Прочитано",
	"add-favorite": "Добавить в избранное",
	"remove-favorite": "Убрать из избранного",
	favorites: "Избранное",
	home: "Главная",
	"favorites-articles": "Избранные статьи",
	"no-favorites-in-catalog": "В текущем каталоге нет избранных статей",
	"inline-to-block-image": "Инлайн-изображение в блочный вид",
	"block-to-inline-image": "Блочное изображение в инлайн-вид",
	"save-file": "Сохранить файл",
	"confirm-inbox-note-delete": "Вы уверены, что хотите удалить эту заметку?",
	"confirm-prompts-delete": "Вы уверены, что хотите удалить этот промпт?",
	"confirm-templates-delete": "Вы уверены, что хотите удалить этот шаблон?",
	"templates-panel-title": "Шаблоны",
	"templates-panel-create": "Создать шаблон",
	"templates-panel-search": "Поиск шаблонов...",
	"templates-panel-loading": "Загрузка шаблонов",
	"templates-panel-empty": "Шаблоны не найдены",
	"templates-panel-untitled": "Без названия",
	"templates-panel-no-content": "Нет содержимого",
	"templates-panel-manage": "Управление шаблонами",
	"templates-panel-actions": "Действия с шаблоном",
	"confirm-agent-skills-delete": "Вы уверены, что хотите удалить этот агентский скилл?",
	tools: "Инструменты",
	download: "Скачать",
	"zoom-in": "Увеличить",
	"zoom-out": "Уменьшить",
	"copy-image": "Копировать изображение",
	"image-copied": "Изображение скопировано",
	write: "Введите",
	select2: "Выберите",
	"change-theme": "Сменить тему",
	"change-language": "Сменить язык",
	"new-section": "Новый раздел",
	"add-section": "Добавить раздел",
	"convert-to-folder": "Преобразовать в папку",
	"convert-to-folder-disabled-empty": "Нельзя преобразовать в папку: раздел пуст",
	"convert-to-section": "Преобразовать в раздел",
	"folder-title": "Название папки",
	"folder-more-catalogs": "Ещё",
	"folder-catalogs-count-one": "каталог",
	"folder-catalogs-count-few": "каталога",
	"folder-catalogs-count-many": "каталогов",
	"go-back": "Назад",
	"drop-to-uncategorize-hint": "Перетащите каталог сюда, чтобы вернуть его на главную страницу.",
	"empty-section-title": "Тут ничего нет",
	"empty-section-description": "Добавьте каталоги с помощью перетаскивания.",
	"drag-to-reorder-section": "Переместить раздел",
	"more-actions": "Другие действия",
	"home-view": "Вид главной",
	"personal-view": "Личный",
	"shared-view": "Общий",
	"shared-homepage-view-description":
		"Этот вид используется на докпортале и в редакторе у пользователей, которые не настроили личный вид.",
	"edit-homepage-view": "Редактировать главную",
	"edit-homepage-view-disabled-duplicate-catalog":
		"Редактирование главной недоступно — один каталог повторяется в нескольких разделах",
	"only-workspace-owner-can-edit-shared-view": "Только владелец пространства может редактировать общий вид",
	"configure-home-view": "Настроить вид главной",
	"configure-personal-view": "Настроить личный вид",
	"configure-view-for-everyone": "Настроить общий вид",
	"section-title": "Название раздела",
	"uncategorized-title": "Без категории",
	authorization: "Авторизация",
	create: "Создать",
	"choose-space": "Выбрать пространство",
	"try-again": "Попробовать снова",
	upload: "Загрузить",
	"fileupload-description": "Перетащите файлы или нажмите для выбора",
	"file-not-found": "Файл не найден",
	"file-upload-failed": "Не удалось вставить файлы",
	"open-in-supported-app": "Открыть в поддерживаемом приложении",
	welcome: {
		empty: {
			title: "Пока что тут пусто",
			description: "Администратор ещё не добавил ни одного каталога.",
		},
		"empty-clone": {
			title: "Добро пожаловать в Gramax!",
			description: "Начните с загрузки существующего каталога из хранилища",
		},
		editor: {
			title: "Добро пожаловать в Gramax!",
			description: "Создайте в Gramax каталог документации и опубликуйте из него сайт с ИИ-поиском",
			options: {
				"create-blank": {
					title: "Создать новый каталог",
					description: "Начните с чистого листа",
				},
				"download-exists": {
					title: "Подключить GitHub или GitLab",
					description: "Свяжите Gramax с Git репозиторием",
				},
				"import-exists": {
					title: "Перенести из другой системы",
					description: "Загрузите данные из Confluence или Notion",
				},
			},
		},
	},
	"try-later": "Попробуйте позже",
	"file-upload": {
		"file-too-large": "Файл ${fileName} превышает максимальный размер ${maxSizeBytes}.",
		"invalid-file-type": "Файл ${fileName} не является допустимым типом файла.",
		"single-file-too-large": "Файл превышает максимальный размер ${maxSizeBytes}.",
		"some-files-too-large": "Некоторые файлы превышают максимальный размер ${maxSizeBytes}",
		"too-many-files": "Вы можете загрузить максимум ${maxFiles} файлов",
	},
	"file-preview": {
		file: "Файл",
		of: "из",
		page: "Страница",
		pages: "Страницы",
		"preview-error": "К сожалению, файл {fileName} не поддерживается для предпросмотра",
		ready: "Предпросмотр",
		"render-error": "Не удалось отобразить этот файл",
		sheet: "Лист",
		sheets: "Листы",
		title: "Предпросмотр файла",
		"zoom-in": "Увеличить",
		"zoom-out": "Уменьшить",
	},
	empty: "Пусто",
	pagination: {
		shown: "Показано {count} из {total}",
		previous: "Предыдущая",
		next: "Следующая",
	},
	"confirm-popover": {
		click: "клик",
	},
	confirmation: {
		delete: {
			title: "Подтверждение удаления",
			body: "Вы уверены, что хотите удалить {count} {item}?",
		},
		unsaved: {
			title: "Несохраненные изменения",
			body: "Изменения будут потеряны, если вы продолжите без сохранения.",
		},
		unsaved2: {
			title: "Закрыть без сохранения?",
			body: "Ваши несохранённые изменения будут потеряны.",
		},
		"remove-caption": {
			title: "Удалить подпись?",
			body: "Текст подписи будет удалён.",
			buttons: {
				primary: "Удалить",
			},
		},
		buttons: {
			cancel: "Назад",
		},
		"unsaved-comment": {
			title: "Закрыть без сохранения?",
			body: "Вы внесли изменения, но не опубликовали их. Если закрыть окно, изменения потеряются.",
			buttons: {
				primary: "Продолжить редактирование",
				secondary: "Не сохранять",
			},
		},
		"convert-section-with-folders": {
			title: "Преобразовать раздел с папками?",
			body: "В этом разделе есть папки. Каталоги будут собраны в новую папку, а существующие папки перенесены в раздел «Без категории».",
			buttons: {
				primary: "Преобразовать",
				secondary: "Отмена",
			},
		},
		"delete-homepage-section": {
			title: "Удалить раздел?",
			body: "Раздел будет удален, а его элементы переместятся в «Без категории».",
		},
		"delete-homepage-folder": {
			title: "Удалить папку?",
			body: "Папка будет удалена, а ее каталоги вернутся в раздел.",
		},
		"empty-sections-on-save": {
			title: "Есть пустые разделы",
			body: "Некоторые разделы не содержат каталогов. При сохранении они будут удалены. Сохранить изменения?",
			buttons: {
				primary: "Сохранить",
				secondary: "Отмена",
			},
		},
		"discard-homepage-changes": {
			title: "Отменить изменения?",
			body: "Есть несохраненные изменения макета главной страницы. Если отменить, они будут потеряны.",
			buttons: {
				primary: "Отменить изменения",
				secondary: "Продолжить редактирование",
			},
		},
		"leave-edit-mode": {
			title: "Покинуть режим редактирования?",
			body: "У вас есть несохраненные изменения. Если покинуть режим редактирования, они будут потеряны.",
			buttons: {
				primary: "Покинуть",
				secondary: "Продолжить редактирование",
			},
		},
	},
	"save-and-close": "Сохранить",
	"editing-personal-homepage-view": "Редактирование личного вида",
	"editing-shared-homepage-view": "Редактирование общего вида",
	record: "запись",
	records: "записи",
	"already-added": "Уже добавлен",
	"available-changes-sync": "Доступны изменения для синхронизации",
	comments: {
		"assisted-by-agent": "С помощью AI-агента",
		answers: {
			one: "ответ",
			few: "ответа",
			many: "ответов",
		},
		move: {
			up: "Предыдущий комментарий",
			down: "Следующий комментарий",
		},
		diff: {
			single: {
				added: "Добавлен комментарий",
				deleted: "Удален комментарий",
				modified: "Изменен комментарий",
			},
			multiple: {
				title: "Изменение комментариев",
				added: "Добавлен",
				deleted: "Удален",
				modified: "Изменен",
			},
		},
	},
	quiz: {
		info: {
			title: "Вопросы",
			question: "Вопрос",
			answered: "Отвечено",
			total: "Всего",
			send: "Отправить ответы",
			retake: "Перепройти тест",
			statistics: {
				title: "Статистика",
				"correct-answers": "Правильных ответов",
				passed: "Тест пройден",
				failed: "Тест не пройден",
			},
		},
		settings: {
			name: "Настройки теста",
			"show-answers": {
				title: "Показывать ответы",
				description: "Показывать ответы на вопросы после прохождения теста",
			},
			retake: {
				title: "Перепрохождение теста",
				description: "Разрешить повторное прохождение теста, в случае неуспеха",
			},
			"precent-of-correct-answers": {
				title: "Количество правильных ответов",
				description: "Количество правильных ответов для прохождения теста",
				placeholder: "Число от 0 до 100",
			},
		},
		"answer-placeholder": {
			edit: "Здесь будет поле для ввода текста",
			render: "Напишите ответ",
		},
		"required-questions": "Пожалуйста, ответьте на все обязательные вопросы",
	},
	or: "или",
	errors: {
		"workspace-path-not-found": "Пространство с путем {{path}} не найдено",
		"workspace-access-denied": "Нет доступа к пространству в директории:",
		"workspace-access-denied-title": "Нет доступа к пространству",
		"workspace-access-denied-other": "Проверьте права доступа к этой директории.",
		"workspace-access-denied-macos":
			"Перейдите в Системные настройки → Конфиденциальность и безопасность → Файлы и папки и разрешите Gramax доступ к этой директории.",
		"workspace-access-denied-macos-category":
			"Перейдите в Системные настройки → Конфиденциальность и безопасность → Файлы и папки и включите для Gramax доступ к разделу «{{category}}».",
		"tcc-category": {
			desktop: "Рабочий стол",
			documents: "Документы",
			downloads: "Загрузки",
			icloud: "iCloud Drive",
		},
		"open-system-settings": "Открыть настройки",
	},
	diagrams: "Диаграммы",
	plugins: {
		messages: {
			"load-error": "Не удалось загрузить модуль {name}",
			"sdk-incompatible-title": "Модуль «{name}» не запущен",
			"sdk-incompatible-description":
				"Эта версия модуля несовместима с вашей версией Gramax. Обратитесь к администратору пространства и попросите обновить модуль.",
			"already-exists": "Модуль с таким ID {id} уже существует",
			"built-in-cannot-delete": "Встроенный модуль нельзя удалить",
		},
		list: {
			"no-plugins-title": "Модули не настроены",
			"no-plugins-description":
				"Загрузите папки с модулями для расширения функциональности Gramax. Каждая папка модуля должна содержать файл manifest.json и файл JavaScript.",
			"add-button": "Добавить модуль",
			"upload-button": "Загрузить папку модуля",
			saving: "Сохранение...",
			sync: "Синхронизировать",
			save: "Сохранить",
			"disabled-badge": "Отключен",
			enabled: "Включен",
			disabled: "Отключен",
		},
		detail: {
			"current-status": "Включен",
			delete: "Удалить",
			"not-found-title": "Модуль не найден",
			"not-found-description": "Пожалуйста, выберите модуль из боковой панели",
			fields: {
				name: "Название",
				id: "ID",
				version: "Версия",
				author: "Автор",
				description: "Описание",
				"sdk-version": "Версия SDK в Gramax",
				"sdk-range": "Поддерживаемые версии SDK",
				status: "Статус",
			},
			status: {
				enable: "Включен",
				disable: "Отключен",
			},
		},
		"delete-modal": {
			title: "Удалить модуль",
			content: 'Вы уверены, что хотите удалить модуль "{name}"?',
			"batch-content": "Вы уверены, что хотите удалить {count} модуль(ей)?",
			description: "Это действие нельзя отменить",
			cancel: "Отмена",
			confirm: "Удалить",
		},
		"save-modal": {
			title: "Сохранить изменения",
			content: "Вы хотите сохранить изменения?",
			cancel: "Отмена",
			confirm: "Сохранить",
		},
	},
	metrics: {
		title: "Метрики",
		"data-for": "Данные за",
		"failed-to-load": "Не удалось загрузить данные метрик",
		disabled: "Модуль метрик отключен",
		enabled: "Модуль метрик включен",
		"disabled-hint": "Метрики отключены. Включите их переключателем выше.",
		export: {
			process: "Экспорт метрик…",
			error: "Не удалось экспортировать метрики",
			title: "Экспорт",
			xlsx: "Excel (.xlsx)",
			csv: "CSV (.csv)",
		},
		filters: {
			date: {
				today: "Сегодня",
				yesterday: "Вчера",
				"this-week": "Эта неделя",
				"last-7-days": "Последние 7 дней",
				"last-28-days": "Последние 28 дней",
				"this-month": "Этот месяц",
				"last-month": "Прошлый месяц",
				"this-year": "Этот год",
				"custom-range": "Свой диапазон",
				cancel: "Отмена",
				apply: "Применить",
			},
			users: {
				"users-filter": "Пользователи",
				"all-users": "Все пользователи",
				"users-selected": "выбрано",
				"search-users": "Поиск пользователей...",
				"no-users-found": "Пользователи не найдены",
				"type-to-search": "Введите для поиска",
				"clear-selection": "Сбросить выбор",
				anonymous: "Анонимный",
				loading: "Загрузка...",
			},
			anonymous: {
				label: "Тип пользователя",
				all: "Все пользователи",
				registered: "Только зарегистрированные",
				anonymous: "Только анонимные",
			},
			catalog: {
				placeholder: "Каталоги",
				all: "Все каталоги",
				search: "Поиск каталогов...",
				"clear-selection": "Сбросить выбор",
				"no-results": "Каталоги не найдены",
			},
		},
		chart: {
			visitors: "Посетители",
			visits: "Визиты",
			views: "Просмотры",
			total: "Всего",
			daily: "Дни",
			weekly: "Недели",
			monthly: "Месяцы",
			"daily-breakdown": "Разбивка по дням",
			"weekly-breakdown": "Разбивка по неделям",
			"monthly-breakdown": "Разбивка по месяцам",
			totalSearches: "Всего поисков",
			avgCTR: "Средний CTR",
			noClickRate: "Доля без кликов",
			refinementRate: "Доля уточнений",
		},
		searchChart: {
			title: "Динамика поисковых запросов",
		},
		viewChart: {
			title: "Динамика истории просмотров",
		},
		table: {
			"catalog-name": "Каталог",
			"parent-article": "Родительская статья",
			article: "Статья",
			visitors: "Посетители",
			visits: "Визиты",
			pageviews: "Просмотры",
			"search-query": "Поисковый запрос",
			"not-specified": "Не указан",
			"search-count": "Количество поисков",
			"unique-visitors": "Уникальные пользователи",
			"ctr-percent": "CTR",
			"most-clicked-item": "Самая популярная статья",
			"avg-click-position": "Средняя позиция клика",
			"refinement-rate-percent": "Доля уточнений",
			catalog: "Каталог",
			pinned: "Закреплено",
			yes: "Да",
			no: "Нет",
			clicks: "Клики",
			"avg-position": "Средняя позиция",
			searches: "Количество поисков",
			"refinement-percent": "Доля уточнений (%)",
			tooltips: {
				"ctr-percent":
					"Click-Through Rate - процент поисковых запросов, которые привели к клику на результат поиска",
				"avg-click-position":
					"Средняя позиция в результатах поиска, где пользователи кликнули. Меньшие числа означают, что пользователи нашли релевантные результаты выше в списке",
				"refinement-rate-percent":
					"Процент поисковых запросов, при которых пользователи изменили свой запрос для уточнения поиска",
				"no-click-rate":
					"Процент поисковых запросов, при которых пользователи не кликнули ни на один результат поиска",
			},
		},
		"no-data": "Нет данных",
		search: {
			"statistics-title": "Статистика поисковых запросов",
			"query-details-title": "Детали запроса",
			"article-ratings-title": "Рейтинг статей по поиску",
		},
	},
	"form-errors": {
		minLength: "Минимальная длина {min} символов",
		maxLength: "Максимальная длина {max} символов",
		required: "Обязательное поле",
		pattern: "Неверный формат",
		validate: "Неверное значение",
	},
	rename: "Переименовать",
	"storage-stats": {
		git: "Git",
		lfs: "LFS",
		"pack-files": "Pack-файлы",
		"loose-objects": "Loose Git-объекты",
		"lfs-objects": "LFS-объекты",
		unreachable: "Недостижимые Git-объекты",
		prunable: "Недостижимые LFS-объекты",
		cleanup: "Очистить",
		error: "Не удалось загрузить статистику хранилища",
		retry: "Повторить",
		confirm: {
			title: "Подтвердите очистку",
			git: "Недостижимые Git-объекты будут удалены из репозитория. Это действие необратимо",
			lfs: "LFS-файлы, на которые больше ничего не ссылается, будут удалены. Это действие необратимо",
		},
		tooltips: {
			lfs: "Файлы Git LFS, используемые репозиторием",
			"pack-files": "Сжатые Git-объекты, объединённые в pack-файлы. Нужны для истории репозитория — удалить их ",
			"loose-objects":
				"Достижимые Git-объекты, которые ещё не упакованы. Можно безопасно сжать в pack-файлы при очистке",
			unreachable: "Loose-объекты, на которые не ссылается ни одна ветка или тег. Можно безопасно удалить",
			prunable:
				"LFS-файлы, на которые больше ничего не ссылается. Можно безопасно удалить, чтобы освободить место",
			"git-clear": "Произойдёт сжатие loose-объектов в pack-файлы, а недостижимые объекты будут удалены.",
			"lfs-clear": "Недостижимые LFS-файлы будут удалены.",
		},
	},
	files: {
		one: "файл",
		few: "файла",
		many: "файлов",
	},
	agent: {
		"empty-state": {
			title: "Чем могу помочь?",
			description: "Читаю и пишу статьи, ищу нужное\nв интернете – просто спросите",
			"description-read-only": "Найду нужное в базе знаний\nи помогу разобраться – просто спросите",
		},
		"message-too-long": "Слишком длинное сообщение",
		"view-json": "Показать JSON",
		expand: "Развернуть",
		collapse: "Свернуть",
		"availability-error": {
			enterprise: {
				title: "AI-агент недоступен",
				description: "Не удалось подключиться к AI-агенту. Обратитесь к администратору.",
			},
			"enterprise-cloud": {
				title: "AI-агент временно недоступен",
				description: "Не удалось подключиться к сервису. Попробуйте ещё раз позже.",
				"balance-empty": {
					title: "AI-баланс организации исчерпан",
					description: "Пополните баланс, чтобы продолжить работу с AI-агентом.",
				},
				"access-denied": {
					title: "Нет доступа к AI-агенту",
					description:
						"Администратор организации ещё не выдал вам доступ. Обратитесь к нему, чтобы начать работу с AI-агентом.",
				},
				"access-restricted": {
					title: "AI-агент недоступен",
					description:
						"Ваш доступ в организации ограничен. Чтобы его восстановить, обратитесь к администратору организации.",
				},
			},
		},
		thinking: "Думаю...",
		"thinking-working": "Работаю",
		"thinking-worked": "Работал",
		"thinking-done": "Работал",
		"duration-minutes": "м",
		"duration-seconds": "с",
		skills: {
			"empty-state": {
				title: "Скиллов пока нет",
				description:
					"Сохраняйте промпты, чтобы быстро вызывать их в чате AI-агента. Нажмите «+», чтобы создать первый скилл",
			},
			name: "Агентские скиллы",
			"menu-name": "Скиллы",
			"new-skill": "Новый скилл",
			"no-skills": "В текущем каталоге нет агентских скиллов",
			loading: "Загрузка…",
			"attach-file": "Прикрепить файл",
			manage: "Управление скиллами",
			"edit-skill": "Редактировать скилл",
			"search-placeholder": "Найти скилл...",
			"title-placeholder": "Название скилла",
			"content-placeholder": "Описание скилла",
			"unnamed-skill": "Скилл без названия",
			"no-content": "Нет содержимого",
		},
		input: {
			placeholder: "Напишите сообщение...",
			"file-invalid-format": "Недопустимый формат файла.",
			"too-many-files": "Можно прикрепить не больше {{max}} файлов.",
			"model-switch-cost-warning": "Первый запрос после смены модели может иметь повышенную стоимость.",
			"ai-disclaimer": "ИИ может ошибаться. Перепроверяйте действия агента.",
		},
		history: {
			empty: "Нет истории чатов",
			"new-chat": "Новый чат",
			"search-placeholder": "Поиск по названию и содержимому...",
			"delete-confirm-title": "Удалить чат?",
			"delete-confirm-description": "Чат «{{title}}» и история его сообщений будут удалены безвозвратно.",
		},
		search: {
			"not-found": "Ничего не найдено",
		},
		"scroll-to-bottom": "Прокрутить вниз",
		usage: {
			"tooltip-label": "Показать использование контекста",
			"tooltip-title": "Окно контекста",
			"tooltip-percent": "{{used}}% использовано ({{left}}% свободно)",
			"tooltip-tokens": "{{used}} / {{total}} токенов использовано",
			"tooltip-view-context": "Посмотреть отправляемый контекст",
			modal: {
				title: "Контекст",
				"percent-full": "{{percent}}% заполнено",
				"percent-unknown": "—% заполнено",
				"tokens-of-window": "{{used}} / {{total}} токенов",
				"row-last-turn": "Последний ответ агента",
				"row-uncached": "Незакэшированные токены",
				"sent-context": "Отправленный контекст",
				"context-loading": "Загрузка…",
				"context-error": "Не удалось загрузить контекст",
				"context-retry": "Повторить",
			},
		},
		"chat-error": {
			"session-not-found": "Сессия чата обновилась. Попробуйте отправить сообщение ещё раз.",
			"session-cancelled": "Сессия была остановлена. Создаём новую…",
			"empty-message": "Введите сообщение.",
			"agent-failed": "Не удалось получить ответ ассистента. Попробуйте ещё раз.",
			"load-history-error": "Не удалось загрузить историю чата.",
			"no-active-session": "Нет активной сессии чата.",
			"no-model-selected": "Не выбрана модель ИИ. Откройте чат заново и попробуйте ещё раз.",
			"send-message-error": "Не удалось отправить сообщение. Попробуйте ещё раз.",
			"get-response-error": "Не удалось получить ответ. Попробуйте ещё раз.",
			"chat-connection-failed": "Не удалось подключить чат. Проверьте подключение и попробуйте снова.",
			"delete-session-error": "Не удалось удалить сессию. Попробуйте ещё раз.",
			"rename-session-error": "Не удалось переименовать чат. Попробуйте ещё раз.",
		},
		"error-type": {
			unauthorized:
				"API-ключ отсутствует или недействителен. Обратитесь к администратору, чтобы проверить настройки AI-сервиса.",
			forbidden:
				"Для работы с AI-агентом нужна роль редактора. Обратитесь к администратору рабочего пространства.",
			payment_required: "Для продолжения требуется оплата или подписка.",
			"balance-exhausted": {
				"enterprise-cloud": "Сервис сейчас недоступен. Попробуйте переключить модель или попробуйте позже.",
				enterprise:
					"Недостаточно средств, чтобы выполнить запрос к провайдеру ИИ-модели. Обратитесь к администратору или воспользуйтесь другой моделью.",
			},
			max_steps_exceeded: "Агент остановлен: достигнуто максимальное число шагов.",
			network_error: "Ошибка сети. Проверьте подключение и попробуйте снова.",
			unexpected: "Произошла непредвиденная ошибка.",
			"unexpected-with-message": "Непредвиденная ошибка: {{message}}",
		},
		"missing-secret": {
			verb: { one: "Отсутствует", few: "Отсутствуют", many: "Отсутствуют" },
			"noun-token": { one: "токен", few: "токены", many: "токены" },
			"noun-login": { one: "логин", few: "логины", many: "логины" },
			and: "и",
			"description-one":
				"Без него запрос не может быть выполнен. Добавьте его в настройках — агент сможет продолжить работу.",
			"description-many":
				"Без них запрос не может быть выполнен. Добавьте их в настройках — агент сможет продолжить работу.",
			button: "Добавить",
		},
		"warning-type": {
			cache_hit_zero: "Кэш контекста не использовался в этом запросе.",
		},
		"turn-cancelled": "Работа агента была прервана пользователем",
		"stopped-after": "Вы остановили работу через",
		"context-compacted": "Выполнено сжатие контекста",
		browser: {
			badge: "Браузер",
			allow: "Веб-поиск",
			tooltip: "Открыть браузер",
			"tooltip-title": "Использовать веб-поиск",
			"tooltip-text": "Позволяет агенту находить актуальную информацию в интернете и использовать её в работе.",
			"tooltip-desktop-only": "Эта функция доступна только в десктопной версии приложения.",
		},
		"panel-name": "AI-агент",
		tooltips: {
			"toggle-chat": "Открыть AI-агента",
			add: "Добавить файл и многое другое",
			history: "История чатов",
			"new-chat": "Новый чат",
			close: "Закрыть",
			"rename-session": "Переименовать чат",
			"delete-session": "Удалить чат",
			"remove-quote": "Убрать цитату",
			"remove-attachment": "Убрать вложение",
		},
		"ask-agent": "Спросить агента",
		tools: {
			tools: "Инструменты",
			parameters: "Параметры",
			result: "Результат",
			list_catalogs: "Получаю список каталогов",
			get_navigation: "Получаю дерево навигации",
			search_catalogs: "Ищу статьи",
			search_files: "Ищу файлы",
			read_catalog_item: "Читаю статью",
			get_files_navigation: "Получаю дерево навигации репозитория",
			read_file: "Читаю файл",
			get_catalog_item_headings: "Получаю заголовки статьи",
			create_catalog_item: "Создаю статью",
			write_catalog_item: "Обновляю статью",
			replace_catalog_item: "Обновляю статью",
			delete_catalog_item: "Удаляю статью",
			move_catalog_item: "Перемещаю статью",
			git_inspect: "Читаю изменения в git",
			git_discard: "Откатываю изменения в git",
			git_branch: "Работаю с ветками git",
			git_restore: "Восстанавливаю файлы из git",
			read_agent_skill: "Читаю скилл",
			read_agent_skill_planning: "Составляю план",
			read_agent_skill_diagrams: "Уточняю формат диаграмм",
			read_agent_skill_calendar: "Уточняю правила работы с календарём",
			read_agent_skill_mail: "Уточняю правила работы с почтой",
			read_agent_skill_skills: "Уточняю формат скиллов",
			read_document: "Читаю документ",
			save_chat_attachment: "Сохраняю вложение в статью",
			transcribe_audio: "Транскрибирую аудио",
			recognize_image: "Распознаю изображение",
			search_web: "Ищу в интернете",
			http_request: "Выполняю HTTP-запрос",
			mail_request: "Выполняю почтовый запрос",
			browser_navigate: "Открываю страницу в браузере",
			browser_read_page: "Читаю страницу в браузере",
			browser_read_element: "Читаю элемент страницы",
			browser_click: "Нажимаю на элемент страницы",
			browser_type: "Ввожу текст на странице",
			browser_scroll: "Прокручиваю страницу",
			compact_context: "Сжимаю контекст",
		},
		badges: {
			expensive: "Более умные модели расходуют больше AI-кредитов",
			"best-choice": "Лучший выбор",
		},
	},
	"app-settings": {
		title: "Настройки",
		description: "Управляйте параметрами приложения",
		level: {
			title: "Уровень настроек",
			app: "Приложение",
			workspace: "Пространство",
			catalog: "Каталог",
		},
		tabs: {
			general: "Основные",
			"compress-images": "Сжатие изображений",
			services: "Сервисы",
			updates: "Автообновления",
			diagnostics: "Диагностика",
			"experimental-features": "Экспериментальные",
			editor: "Редактор",
			"content-compare": "Сравнение",
			"keys-passwords": "Ключи и пароли",
			"ai-agent": "AI-агент",
		},
		sections: {
			general: {
				title: "Основные",
				description: "Язык интерфейса, оформление и обработка изображений при добавлении в статьи.",
			},
			services: {
				title: "Сервисы",
				description: "Адреса сервисов, к которым подключается Gramax.",
			},
			updates: {
				title: "Автообновления",
				description: "Как приложение проверяет и устанавливает новые версии.",
			},
			diagnostics: {
				title: "Диагностика",
				description: "Журналы работы приложения для разбора ошибок и обращений в поддержку.",
			},
			"experimental-features": {
				title: "Экспериментальные функции",
				description: "Функции в разработке. Они могут работать нестабильно и меняться в следующих версиях.",
			},
			"content-compare": {
				title: "Сравнение версий",
				description: "Как подсвечиваются изменения при сравнении версий статьи.",
			},
		},
		"exit-confirmation": {
			title: "Вы уверены, что хотите выйти?",
			body: "Ваши изменения не будут сохранены",
			"keep-editing": "Вернуться к редактированию",
			exit: "Выйти",
		},
		actions: {
			cancel: "Отмена",
			"reset-section": "Сбросить настройки",
			"reset-field": "Сбросить к значению по умолчанию",
		},
		general: {
			language: {
				title: "Язык интерфейса",
				placeholder: "Выберите язык",
				en: "English",
				ru: "Русский",
			},
			theme: {
				title: "Тема",
				placeholder: "Выберите тему",
				light: "Светлая",
				dark: "Тёмная",
			},
		},
		"compress-images": {
			enabled: "Сжимать изображения",
			"enabled-description": "Изображения сжимаются при добавлении в статью и сохраняются в webp.",
			rule: "Правило",
			source: "Сжимать изображения",
			target: "Сохранять как",
			effort: "Усилие сжатия",
			"effort-description": "Выше усилие — меньше файл, но дольше обработка.",
			quality: "Качество",
			"quality-description": "Ниже качество — меньше размер файла.",
			"compression-level": "Уровень сжатия",
			"compression-level-description": "Без потери качества. Выше уровень — меньше файл, но дольше обработка.",
			add: "Добавить правило",
			empty: "Правил сжатия нет. Изображения сохраняются как есть.",
		},
		services: {
			"web-editor": {
				title: "Веб-редактор",
				description: "Адрес сервиса веб-редактора Gramax.",
			},
			auth: {
				title: "Авторизация",
				description: "Адрес сервиса авторизации пользователей.",
			},
			"diagram-renderer": {
				title: "Diagram Renderer",
				description: "Адрес сервиса рендеринга диаграмм.",
			},
			"git-proxy": {
				title: "Git Proxy",
				description: "Прокси для работы с Git-репозиториями из браузера.",
			},
			ai: {
				title: "AI",
				enabled: "Включить AI",
				endpoint: "Эндпоинт AI",
				token: "Токен AI",
			},
		},
		diagnostics: {
			logging: {
				title: "Логирование",
				description: "Что записывается в файлы логов на этом устройстве.",
				console: "Выводить логи в консоль",
				"console-description": "Дублировать вывод логов в консоль разработчика.",
			},
			troubleshooting: {
				title: "Устранение неполадок",
				description: "Экспортируйте архив логов, чтобы приложить его к баг-репорту или обращению в поддержку",
			},
		},
		updates: {
			frequency: {
				title: "Частота проверки обновлений",
				description:
					"Как часто приложение автоматически проверяет наличие обновлений. Ручная проверка работает при любой настройке.",
				"every-launch": "При каждом запуске",
				"twice-daily": "Каждые 12 часов",
				daily: "Каждые 24 часа",
				weekly: "Раз в неделю",
				never: "Никогда",
			},
			check: {
				action: "Проверить обновления",
				checking: "Проверка обновлений...",
				"update-found": "Обновление найдено, загружается",
				"up-to-date": "У вас последняя версия",
				"in-progress": "Обновление уже загружается",
				error: "Не удалось проверить обновления",
			},
			"install-from-cache": {
				description: "Выберите архив версии из кэша обновлений. Приложение установит её и перезапустится.",
				action: "Установить из кэша",
				error: "Не удалось установить версию из кэша",
			},
		},
		"keys-passwords": {
			title: "Ключи и пароли пользователя",
			description: "Храните ключи, пароли и логины для повторного использования в защищённых переменных.",
			"search-placeholder": "Найти по названию...",
			"kind-label": "Тип",
			"kind-token": "Токен",
			"kind-login": "Логин",
			"key-placeholder": "Название",
			"key-label": "Название",
			"login-label": "Логин",
			"login-disabled-tooltip": "Доступно только для типа «Логин»",
			"url-label": "URL",
			"value-placeholder": "Значение",
			"value-label": "Пароль или ключ",
			"key-required": "Ключ обязателен",
			"key-duplicate": "Такой токен или логин уже есть — введите другое название",
			"delete-confirm-title-token": "Удалить токен?",
			"delete-confirm-title-login": "Удалить логин?",
			"delete-confirm-description":
				"Скиллы, использующие «{{key}}», перестанут работать, пока вы не добавите его заново.",
			add: "Добавить",
			manage: "Настроить ключи и пароли",
		},
		"content-compare": {
			sensitivity: {
				title: "Детальность подсветки",
				description:
					"По словам — читается чище. По буквам — видно, что именно изменилось. Гибридно — мелкая правка подсвечивается по буквам, крупная — словом целиком.",
				hybrid: "Гибридно",
				character: "По буквам",
				word: "По словам",
			},
			"collapse-threshold": {
				title: "Порог сворачивания",
				description:
					"Насколько крупная правка внутри абзаца прячется под маркер: 0.1 — почти любая, 1 — никакая. Удаленный целиком абзац свернут всегда.",
			},
			developer: {
				title: "Для разработчика",
				description: "Параметры алгоритма сравнения. Менять их без нужды не стоит.",
			},
			"min-similarity": {
				title: "Сопоставление абзацев",
				description:
					"Насколько далеко может уйти абзац, чтобы всё ещё считаться правкой. Повысьте, чтобы крупные переписывания распадались на удаление и добавление.",
			},
			debounce: {
				title: "Задержка обновления",
				description:
					"Пауза после набора, прежде чем подсветка перерисуется. Повысьте, если длинные статьи подтормаживают.",
			},
			"min-match-length": {
				title: "Порог шума",
				description:
					"Короткие фрагменты, случайно уцелевшие при переписывании, всё равно считаются неизменными. Повысьте, чтобы отбросить их и оставить подсветку осмысленной.",
			},
			"stop-word-min-blocks": {
				title: "Порог частых слов",
				description:
					"Слово, которое встречается в стольких абзацах и больше, не помогает найти пару изменённому абзацу. Повысьте, если повторяющиеся абзацы путаются между собой.",
			},
			"cut-down-min-words": {
				title: "Урезанный абзац: слов",
				description:
					"Сколько слов должно остаться в абзаце, у которого удалили большую часть текста, чтобы он считался правкой, а не удалением с новым абзацем.",
			},
			"cut-down-min-kept": {
				title: "Урезанный абзац: доля слов",
				description:
					"Какая доля оставшихся слов должна совпадать со старым абзацем. Понизьте, если сильно сокращённые абзацы распадаются на удаление и добавление.",
			},
			preview: {
				title: "Предпросмотр",
				before: {
					typo: "Gramax хранит документацию в Git-репазитории.",
					reworded:
						"Каталог собирает статьи в общее дерево. Отдельной страницы с правами у него нет вовсе, доступ выдаётся в общем списке команды.",
					survivors: "Чтобы собрать статью, нужно нажать кнопку и подождать.",
				},
				after: {
					typo: "Gramax хранит документацию в Git-репозитории.",
					reworded:
						"Каталог собирает статьи в общее дерево. Доступ теперь выдаётся прямо на странице каталога, а общий список команды убран.",
					survivors: "Чтобы опубликовать статью, нужно нажать кнопку и немного подождать.",
				},
			},
		},
	},
};

export default locale;
